var _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208, _path3209, _path3210, _path3211, _path3212, _path3213, _path3214, _path3215, _path3216, _path3217, _path3218, _path3219, _path3220, _path3221, _path3222, _path3223, _path3224, _path3225, _path3226, _path3227, _path3228, _path3229, _path3230, _path3231, _path3232, _path3233, _path3234, _path3235, _path3236, _path3237, _path3238, _path3239, _path3240, _path3241, _path3242, _path3243, _path3244, _path3245, _path3246, _path3247, _path3248, _path3249, _path3250, _path3251, _path3252, _path3253, _path3254, _path3255, _path3256, _path3257, _path3258, _path3259, _path3260, _path3261, _path3262, _path3263, _path3264, _path3265, _path3266, _path3267, _path3268, _path3269, _path3270, _path3271, _path3272, _path3273, _path3274, _path3275, _path3276, _path3277, _path3278, _path3279, _path3280, _path3281, _path3282, _path3283, _path3284, _path3285, _path3286, _path3287, _path3288, _path3289, _path3290, _path3291, _path3292, _path3293, _path3294, _path3295, _path3296, _path3297, _path3298, _path3299, _path3300, _path3301, _path3302, _path3303, _path3304, _path3305, _path3306, _path3307, _path3308, _path3309, _path3310, _path3311, _path3312, _path3313, _path3314, _path3315, _path3316, _path3317, _path3318, _path3319, _path3320, _path3321, _path3322, _path3323, _path3324, _path3325, _path3326, _path3327, _path3328, _path3329, _path3330, _path3331, _path3332, _path3333, _path3334, _path3335, _path3336, _path3337, _path3338, _path3339, _path3340, _path3341, _path3342, _path3343, _path3344, _path3345, _path3346, _path3347, _path3348, _path3349, _path3350, _path3351, _path3352, _path3353, _path3354, _path3355, _path3356, _path3357, _path3358, _path3359, _path3360, _path3361, _path3362, _path3363, _path3364, _path3365, _path3366, _path3367, _path3368, _path3369, _path3370, _path3371, _path3372, _path3373, _path3374, _path3375, _path3376, _path3377, _path3378, _path3379, _path3380, _path3381, _path3382, _path3383, _path3384, _path3385, _path3386, _path3387, _path3388, _path3389, _path3390, _path3391, _path3392, _path3393, _path3394, _path3395, _path3396, _path3397, _path3398, _path3399, _path3400, _path3401, _path3402, _path3403, _path3404, _path3405, _path3406, _path3407, _path3408, _path3409, _path3410, _path3411, _path3412, _path3413, _path3414, _path3415, _path3416, _path3417, _path3418, _path3419, _path3420, _path3421, _path3422, _path3423, _path3424, _path3425, _path3426, _path3427, _path3428, _path3429, _path3430, _path3431, _path3432, _path3433, _path3434, _path3435, _path3436, _path3437, _path3438, _path3439, _path3440, _path3441, _path3442, _path3443, _path3444, _path3445, _path3446, _path3447, _path3448, _path3449, _path3450, _path3451, _path3452, _path3453, _path3454, _path3455, _path3456, _path3457, _path3458, _path3459, _path3460, _path3461, _path3462, _path3463, _path3464, _path3465, _path3466, _path3467, _path3468, _path3469, _path3470, _path3471, _path3472, _path3473, _path3474, _path3475, _path3476, _path3477, _path3478, _path3479, _path3480, _path3481, _path3482, _path3483, _path3484, _path3485, _path3486, _path3487, _path3488, _path3489, _path3490, _path3491, _path3492, _path3493, _path3494, _path3495, _path3496, _path3497, _path3498, _path3499, _path3500, _path3501, _path3502, _path3503, _path3504, _path3505, _path3506, _path3507, _path3508, _path3509, _path3510, _path3511, _path3512, _path3513, _path3514, _path3515, _path3516, _path3517, _path3518, _path3519, _path3520, _path3521, _path3522, _path3523, _path3524, _path3525, _path3526, _path3527, _path3528, _path3529, _path3530, _path3531, _path3532, _path3533, _path3534, _path3535, _path3536, _path3537, _path3538, _path3539, _path3540, _path3541, _path3542, _path3543, _path3544, _path3545, _path3546, _path3547, _path3548, _path3549, _path3550, _path3551, _path3552, _path3553, _path3554, _path3555, _path3556, _path3557, _path3558, _path3559, _path3560, _path3561, _path3562, _path3563, _path3564, _path3565, _path3566, _path3567, _path3568, _path3569, _path3570, _path3571, _path3572, _path3573, _path3574, _path3575, _path3576, _path3577, _path3578, _path3579, _path3580, _path3581, _path3582, _path3583, _path3584, _path3585, _path3586, _path3587, _path3588, _path3589, _path3590, _path3591, _path3592, _path3593, _path3594, _path3595, _path3596, _path3597, _path3598, _path3599, _path3600, _path3601, _path3602, _path3603, _path3604, _path3605, _path3606, _path3607, _path3608, _path3609, _path3610, _path3611, _path3612, _path3613, _path3614, _path3615, _path3616, _path3617, _path3618, _path3619, _path3620, _path3621, _path3622, _path3623, _path3624, _path3625, _path3626, _path3627, _path3628, _path3629, _path3630, _path3631, _path3632, _path3633, _path3634, _path3635, _path3636, _path3637, _path3638, _path3639, _path3640, _path3641, _path3642, _path3643, _path3644, _path3645, _path3646, _path3647, _path3648, _path3649, _path3650, _path3651, _path3652, _path3653, _path3654, _path3655, _path3656, _path3657, _path3658, _path3659, _path3660, _path3661, _path3662, _path3663, _path3664, _path3665, _path3666, _path3667, _path3668, _path3669, _path3670, _path3671, _path3672, _path3673, _path3674, _path3675, _path3676, _path3677, _path3678, _path3679, _path3680, _path3681, _path3682, _path3683, _path3684, _path3685, _path3686, _path3687, _path3688, _path3689, _path3690, _path3691, _path3692, _path3693, _path3694, _path3695, _path3696, _path3697, _path3698, _path3699, _path3700, _path3701, _path3702, _path3703, _path3704, _path3705, _path3706, _path3707, _path3708, _path3709, _path3710, _path3711, _path3712, _path3713, _path3714, _path3715, _path3716, _path3717, _path3718, _path3719, _path3720, _path3721, _path3722, _path3723, _path3724, _path3725, _path3726, _path3727, _path3728, _path3729, _path3730, _path3731, _path3732, _path3733, _path3734, _path3735, _path3736, _path3737, _path3738, _path3739, _path3740, _path3741, _path3742, _path3743, _path3744, _path3745, _path3746, _path3747, _path3748, _path3749, _path3750, _path3751, _path3752, _path3753, _path3754, _path3755, _path3756, _path3757, _path3758, _path3759, _path3760, _path3761, _path3762, _path3763, _path3764, _path3765, _path3766, _path3767, _path3768, _path3769, _path3770, _path3771, _path3772, _path3773, _path3774, _path3775, _path3776, _path3777, _path3778, _path3779, _path3780, _path3781, _path3782, _path3783, _path3784, _path3785, _path3786, _path3787, _path3788, _path3789, _path3790, _path3791, _path3792, _path3793, _path3794, _path3795, _path3796, _path3797, _path3798, _path3799, _path3800, _path3801, _path3802, _path3803, _path3804, _path3805, _path3806, _path3807, _path3808, _path3809, _path3810, _path3811, _path3812, _path3813, _path3814, _path3815, _path3816, _path3817, _path3818, _path3819, _path3820, _path3821, _path3822, _path3823, _path3824, _path3825, _path3826, _path3827, _path3828, _path3829, _path3830, _path3831, _path3832, _path3833, _path3834, _path3835, _path3836, _path3837, _path3838, _path3839, _path3840, _path3841, _path3842, _path3843, _path3844, _path3845, _path3846, _path3847, _path3848, _path3849, _path3850, _path3851, _path3852, _path3853, _path3854, _path3855, _path3856, _path3857, _path3858, _path3859, _path3860, _path3861, _path3862, _path3863, _path3864, _path3865, _path3866, _path3867, _path3868, _path3869, _path3870, _path3871, _path3872, _path3873, _path3874, _path3875, _path3876, _path3877, _path3878, _path3879, _path3880, _path3881, _path3882, _path3883, _path3884, _path3885, _path3886, _path3887, _path3888, _path3889, _path3890, _path3891, _path3892, _path3893, _path3894, _path3895, _path3896, _path3897, _path3898, _path3899, _path3900, _path3901, _path3902, _path3903, _path3904, _path3905, _path3906, _path3907, _path3908, _path3909, _path3910, _path3911, _path3912, _path3913, _path3914, _path3915, _path3916, _path3917, _path3918, _path3919, _path3920, _path3921, _path3922, _path3923, _path3924, _path3925, _path3926, _path3927, _path3928, _path3929, _path3930, _path3931, _path3932, _path3933, _path3934, _path3935, _path3936, _path3937, _path3938, _path3939, _path3940, _path3941, _path3942, _path3943, _path3944, _path3945, _path3946, _path3947, _path3948, _path3949, _path3950, _path3951, _path3952, _path3953, _path3954, _path3955, _path3956, _path3957, _path3958, _path3959, _path3960, _path3961, _path3962, _path3963, _path3964, _path3965, _path3966, _path3967, _path3968, _path3969, _path3970, _path3971, _path3972, _path3973, _path3974, _path3975, _path3976, _path3977, _path3978, _path3979, _path3980, _path3981, _path3982, _path3983, _path3984, _path3985, _path3986, _path3987, _path3988, _path3989, _path3990, _path3991, _path3992, _path3993, _path3994, _path3995, _path3996, _path3997, _path3998, _path3999, _path4000, _path4001, _path4002, _path4003, _path4004;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotorOil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#191a1c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 115v1h3v2h-5v-1h-4v1H48v2h2v1h-2v1h2v1h-4v-2h-1v-2h-1v-2h-1v-2h3v-1h2v1h5zm21-60h1v2h2v3h-1v4h1v1h-1v4h-1v-5h-1v-1zm-6 64h-3v-2h-2v3h-1v-3h-2v-2h7v2h2v2zm7-69V39h1v2h1v3h-1v2h1v4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 117h1v1h-1v1h-2v-3h-4v-1h6zm2-79v-1h-4v-1h1v-1h1v1h1v-2h1v2h1v2zm-1 17v-1h-1v-1h2v-2h1v4zm1 37h-1v-7h1v1zM78 37v-1h2v2h1v1h-2v-1h-1zm9 32h1v4h-1v-1zm2 32v4h-1v-4zM75 34h2v2h-1v-1h-1zm13 81h-1v-3h1zm-15 2v1h-3v-1zm15-86v1h-2v-1h1zm-6 2v1h-2v-1h1zm-44 81v-2h1v2zm34 6h-1v-1h2v1zm3-106v-1h1v1zm3 6h-1v-1h1zm4 16v-1h1v1zm-1 2v-1h1v1zm-12 3v-1h1v1zm4-1v1h-1v-1zm8 0h1v1h-1zm-3 2v-1h1v1zm3 0h-1v-1h1zm7 32v-1h1v1zm2 1v1h-1v-1zm-2 3h1v1h-1zm-48 34h-1v-1h1zm0 1v-1h1v1zm25 8v-1h1v1zm21 1v-1h1v1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 42v4h-2v-6h-2v-1h2v-2h4v2h-2zm-44 73v2h1v2h-5v-3h-1v-2h1v-2h1v1h1v4h1v-2zm47-64h-1v2h-4v-1h1v-2h-2v-2h3v2h3zm-17 63v3h-4v-1h-3v-1h4v-1zm16-5h-1v-2h-1v-2h2zm-7-65h-2v-2h1v-1h1zm8 31h-1v-5h1v2zm-17 43v-1h2v3h-2v-1h1v-1zm16-58h1v4h-1v-2zm-2 28v-1h1v4h-1zm-9 29v2h-2v-2zm-13 4h-4v-1h4zm25-45v1h-1v1h-1v-2zm-9-41h1v2h-1v-1zm-40 5v1h-1v-2h1zm48 1v-2h1v2zm1 3v2h-1v-2zm0 13h-1v-2h1v1zm-2 24v-1h1v2h-1zm0 2v2h-1v-2zm0 17v2h-1v-2zm0 16v1h-1v-2h1zm-15 2v1h-2v-1h1zm-29 3v-2h1v2zm6-2v1h-2v-1h1zm-5 2h1v2h-1v-1zm3 0h2v1h-2zM79 16h1v1h-1zm-2 4h-1v-1h1zm12 13v1h-1v-1zm-19 3v1h-1v-1zm10 1h1v1h-1zm0 3h-1v-1h1zm3 1h-1v-1h1zm6 24h1v1h-1zm-2 5h-1v-1h1zm1 4h-1v-1h1zm-49 38h-1v-1h1zm46 1v-1h1v1zm-5 1h1v1h-1zm1 2v1h-1v-1zm-11 4v-1h1v1z",
    fill: "#1a1b1d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46h2v-7h1v11h-1v-2h-3v2h-1v-2h-3v-2h-2v-3h-1v-1h3v2h2v-3h1v1h1v-2h1zm-42 75h-2v-2h3v2h1v2h-2v-1zm46-55h1v4h-1v-1zm-1 10v-2h1v2zm0 8v-1h1v2h-1zm-1 3v-2h1v2zm-46 30v-2h1v2zm37-99v-1h1v1zm11 15h-1v-1h1zm-12 1h-1v-1h1zm7 1h-1v-1h1zm5 1v-1h1v1zm2 3h-1v-1h1zm-21 2v-1h1v1zm8 8v-1h1v1zm9 29v-1h1v1zm3 0h-1v-1h1zm-2 3v1h-1v-1zm-2 9v-1h1v1zm-47 20v1h-1v-1zm31 4v1h-1v-1zm-32 2h1v1h-1zm31 2v-1h1v1zm2 0v1h-1v-1zm3 1h-1v-1h1zm-6 0h1v1h-1zm-7 1v1h-1v-1zm25 2h1v1h-1z",
    fill: "#1b1c1e"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#191b1a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 46v-5h-3v-1h-2v1h-3v-1h1v-1h3v-1h7v2h-1v4h2v2h-1v1h-1v-1zm-3 3v-1h1v1h1v1h-5v1h-1v-1h-2v-2h4v1zm6-11v-1h10v1zM37 53v-6h1v6zm9-9v2h-2v-2zm11-2v-1h3v1zm19 6v1h-3v-1h1zm-21 73v-1h3v1zm22-84h1v2h-1v-1zm-2 3v-1h2v1h-1zm-13 0h2v1h-2zm-9 10v-1h2v1h-1zm-9-10v-1h1v1zm-2 1h-1v-1h1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 41h-1v-1h1zm-20 4v-1h1v1zm15 2h-1v-1h1zm4 0h1v1h-1zm31 20h-1v-1h1z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41h3v-1h2v1h3v5h-7v-2h-2v2h-1v-3h2zm13-2h1v1h3v1h-5v-1h1zm-5 10h-2v-1h1v-1h4v1h-3zm22-12h2v2h-2zm-9 0h2v1h-2zM49 48h1v1h-2v-1zm23 1h-1v-1h2v1zM57 38v1h-1v-1zm-11 2h-1v-1h1zm31 0v-1h1v1zm-34 0v1h-1v-1zm2 0v1h-1v-1zm24 8h1v1h-1zm17 18v-1h1v1z",
    fill: "#181a19"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 46v-1h-2v1h-3v-2h1v-2h5v-2h1v1h1v3h2v-1h2v1h-1v2zm0-3h-1v1h2v-1zm20 41v1h-1v-5h1zm-24 34v1h-5v-1h1zm25-22h-1v-4h1v2zM78 41v-1h3v1zm12 51h-1v-3h1zm1-51v2h-1v-2zM81 18h-1v-1h1zm-6 1v-1h1v1zm3 3h-1v-1h1zm9 8h1v1h-1zm4 8h-1v-1h1zm-7 2v1h-1v-1zm-4 7v1h-1v-1zm-40 64h1v1h-1zm-1 6v1h-1v-1zm11 1h1v1h-1zm20 1h-1v-1h1zm-28 4h-1v-1h1z",
    fill: "#1d1e20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48v-3h1v-2h-1v-1h3v4h7v1h3v1h-8v2h-2v-2zm3 2v2h-1v1h-1v1h-1v-2h1v-2zm14 72v-1h4v1h-1zm-1 2h-2v-2h2zm12-85v-1h3v1zm-6 1v-1h2v1h-1zm-17 2h-1v-1h2v1zm31-3v-1h1v1zM38 64v-1h1v1z",
    fill: "#161817"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80 120v-1h2v-2h3v2h2v2h-2v-1zm8-51h-1v-5h1v1zm0 4v-4h1v4zm1 19v4h-1v-4zm-25 26h-4v-1h4zM79 14h-2v-1h2zm2 22v1h-1v-2h1zm-2 2v2h-1v-2zm9 19v-2h1v2zm-11 63h-1v-1h2v1zm-11 1v-1h2v1h-1zM80 14v1h-1v-1zm-1 2v1h-1v-1zm0 2v-1h1v1zm6 17v-1h1v1zm-10 1v-1h1v1zm12 0v-1h1v1zm-3 2h1v1h-1zm5 1v-1h1v1zm-18 0v1h-1v-1zm8 2h1v1h-1zm2 75h-1v-1h1zm1 0v1h-1v-1zm5 2h1v1h-1zm-17 3h-1v-1h1zm16 1v1h-1v-1zm-3 2v-1h1v1z",
    fill: "#18191b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h1v-1h4v2h-5zm-5-5v-2h3v1h-1v1zm3 2v-2h1v-1h1v3zm-10 74v-2h3v1h-1v1zm-2-78h2v2h-2zm26 43v4h-1v-4zm-1 7h1v4h-1v-2zm-46 31h-1v-1h-1v-1h2zm26-82h2v1h-2zm11 6h-2v-1h2zm9 32v-1h1v2h-1zm-39 39v1h-2v-1h1zM79 14v1h-1v-1zm4 18v-1h1v1zm-2 6h1v1h-1zm2 2h-1v-1h1zm0 1h1v1h-1zm4 42v1h-1v-1zm-27 35h1v1h-1zm10 1v1h-1v-1z",
    fill: "#1c1d1f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66 38v1h2v1h-6v-1h-2v1h-1v-1h-1v1h-2v-1h1v-1h2zm-22 3h1v2h-2v3h-1v-4h2zm16 7v1h-7v-1h1zm-6 73v1h-2v-1h-1v-1h4v1zm-6-74v-1h3v1zm-4 2v1h-1v-2h1zm-1-8v-1h1v1zm-1 1h-1v-1h1zm10 5v1h-1v-1zm18 2v-1h1v1z",
    fill: "#171918"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-2v1h-1v1h-2v-2h-2v-4h1v1h1v1h3v-1h3v2zm2-2v-1h4v1h-1zm-12 6v-1h3v1zm5 3h-2v-1h2zm17-13h1v1h-1zm-25 1v1h-1v-1zm-5 1v1h-1v-1zm-6 4v1h-1v-1zm0 2v1h-1v-1zm18 1h1v1h-1zm20 2h1v1h-1zm-28 2v1h-1v-1zm-10 3v1h-1v-1zm49 14v1h-1v-1zm-28 53v1h-1v-1z",
    fill: "#1a1c1b"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M85 120v2h-4v-1h-1v2h-4v-3h2v-1h2v1zm-20 2v-1h3v1h1v1h-2v-1zm6 1v-2h2v2zm17-90v1h-1v1h-1v-2zm-25 89h-1v-1h2v1zm18-90h1v1h-1zm-2 2h1v1h-1zm5 3h1v1h-1zm-16 84v-1h1v1zm3-1v1h-1v-1z",
    fill: "#161719"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M77 36v-2h2v1h1v1zm-6 85v-1h5v1h-2zm9-86v-1h3v1zm2 82v-1h3v1h-1zM71 37v1h-2v-1h1zm-11 84h2v1h-2zM75 13v1h-1v-1zm1 1v-1h1v1zm3 0v-1h1v1zm8 19v-1h1v1zm-7 1h-1v-1h1zm7 1v-1h1v1zm-1 0v1h-1v-1zm-4 1h1v1h-1zm-12 4h-1v-1h1zm1 0v-1h1v1zm14 81h1v1h-1zm-4 2v-1h1v1zm4 0h-1v-1h1z",
    fill: "#17181a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91 92h-1v-3h1v1zm-34 27v-1h3v1zm34-83v1h-1v-2h1zm-1 3h1v2h-1v-1zm-21 4h2v1h-2zm22 4v1h-1v-2h1zm-2 57v-1h1v2h-1zm2 3v1h-2v-1h1zm-39 11h1v1h-2v-1zm25-97h-1v-1h1zm-8 14v1h-1v-1zm12 5h-1v-1h1zm9 4h1v1h-1zm0 58h1v1h-1zm1 4h-1v-1h1zm-53 12h1v1h-1zm27 1h1v1h-1zm22 3h1v1h-1z",
    fill: "#1e1f21"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76 28v1h2v2h-1v-1h-2v1h-1v-3zm1-3v-1h1v-1h1v2zm5 3v2h-1v-2zm-26 7h-2v-1h2zM77 6V5h1v1zm-2 3V8h1v1zm10 11h1v1h-1zm-1 5v1h-1v-1zm0 1h1v1h-1zm-5 2v1h-1v-1zm5 1v1h-1v-1zm-27 2h-1v-1h1zm12 2h-1v-1h1zm-29 1v-1h1v1zm22-1v1h-1v-1z",
    fill: "#2d2e30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90 69h1v9h-1zm1-12v5h-1v-5zm-1-2v-3h1v3zM57 29v-1h2v1h-1zm24-15h1v1h-1zM55 29h-1v-1h1zm-3 0h1v1h-1zm34 1v1h-1v-1zm4 5h-1v-1h1zm-1 75v-1h1v1z",
    fill: "#212224"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91 88h-1v-8h1zm-1-24h1v5h-1v-2zm-28 56v-1h3v1h-1zM74 10v1h-1v-1zm1 1v-1h1v1zM52 29v1h-1v-1zm15 6v1h-1v-1zm23 17v-1h1v1zm-1 56h1v1h-1z",
    fill: "#202123"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v1h-2v-1h1zM75 9h-1V8h1zm2 3v1h-1v-1zm0 12h-1v-1h1zm0 1v1h-1v-1zm3 0v1h-1v-1zm2 3h-1v-1h1zm-9 1h-1v-1h1zm5 0h-1v-1h1zm7 0v1h-1v-1zm-31 1h1v1h-1zm19 0h1v1h-1zm-29 3h1v1h-1zm16 0h1v1h-1zm-18 2v-1h1v1zm11 0v-1h1v1zm-3 0h1v1h-1zm-10 2h-1v-1h1zm-1 0v1h-1v-1zm1 2v-1h1v1z",
    fill: "#2e2f31"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73 123v-2h3v2zm-4 0v-1h-1v-1h3v2zm-6-1h1v1h-4v-1zm18 0v1h-1v-2h1zm6-89h-1v-1h1zm-18 6v-1h1v1zm-5 83v-1h1v1zm2 1v-1h1v1z",
    fill: "#151618"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48h3v2h-2v2h-1zm19 75h-1v1h-1v-2h4v2h-2zM41 42h1v4h-1v-1zm-3 2v-1h1v1zm17 78h-1v-1h1z",
    fill: "#151716"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85 27v1h-3v-1zm-25 5v1h-3v-1zm-22 7h-1v-2h1v1zm44-14v1h-1v-1zm4 3v1h-1v-1zm-13 2v-1h1v1zm7 0v-1h1v1zm-8 1v-1h1v1zm10-1v1h-1v-1zm-31 2v-1h1v1zm3-1h1v1h-1zm3 0v1h-1v-1zm-9 1v1h-1v-1zm14 1h-1v-1h1zm-13 2h1v1h-1z",
    fill: "#313234"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53 119v-1h4v1h-1zm37-71h1v3h-1v-1zm0 54v1h-1v-2h1zm1 3h-1v-2h1v1zm-2 0h1v2h-1v-1zM75 10v1h-1v-1zm7 8h-1v-1h1zm4 13v-1h1v1zm-19 5v-1h1v1zm17 2v1h-1v-1zm6 70h1v1h-1z",
    fill: "#1f2022"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72v1h-1v-2h1zm-1 13v-2h1v2zm41-73h1v1h-1zm4 3h-1v-1h1zm-4 7h-1v-1h1zm0 1v-1h1v1zm-25 6v-1h1v1zm-1 1h-1v-1h1zm35 2h-1v-1h1zm-11 2v-1h1v1zm-8 1h-1v-1h1zm2 0h-1v-1h1zm14 0h1v1h-1zm-43 4v1h-1v-1zm42 0v1h-1v-1zm-45 67h-1v-1h1zm5 5h1v1h-1z",
    fill: "#242527"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36 82h-1v-6h1zm-1-28h1v5h-1v-1zm1-6h-1v-3h1zm0 4h-1v-2h1v1zm-1 33h1v2h-1v-1zm13-55h-1v-1h1z",
    fill: "#333335"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76 27v-1h3v1zm0-17h-1V9h2v1zm10 15h1v1h-2v-1zm-1 9v1h-1v-2h1zM74 6h1v1h-1zm3 1h-1V6h1zm-3 2v1h-1V9zm11 13h1v1h-1zm-28 8h-1v-1h1zm16 2v1h-1v-1zm6 1v1h-1v-1zm-18 2v-1h1v1zm-23 80h-1v-1h1z",
    fill: "#262729"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86 23h1v2h-1v-1zM65 34h1v1h-2v-1zm10 2h-1v-2h1v1zM37 86v1h-1v-2h1zM76 6v1h-1V6zM55 30v-1h1v1zm33-1v1h-1v-1zm-36 1v1h-1v-1zm25 3h-1v-1h1zm-35 1h-1v-1h1zm-1 1h-1v-1h1zm26-1h1v1h-1zm4 1v-1h1v1zm-16 1v-1h1v1z",
    fill: "#252628"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29v-1h3v1zm-1-3h2v1h-2zm-24 8h-1v-2h1v1zm7-1h-2v-1h2zM76 8h-1V7h1zm1 16v1h-1v-1zm3 0v1h-1v-1zm0 1h1v1h-1zm-6 2v-1h1v1zm12 1h-1v-1h1zm-35 4h-1v-1h1zm18-1h1v1h-1zm-9 1h1v1h-1z",
    fill: "#303133"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M54 32h1v-1h1v3h-2zm22-6h-1v-2h1v1zm-24 6v-1h2v1h-1zm6 0h-1v-1h2v1zm17-21h1v1h-1zm5 5h1v1h-1zm-10 5v-1h1v1zm6 0h-1v-1h1zm6 10v-1h1v1zm-29 3v1h-1v-1zm20 2v1h-1v-1z",
    fill: "#323335"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M87 26v1h-2v-1h1zm-21 7h1v1h-2v-1zm-8 2v-1h2v1h-1zm28-15h-1v-1h1zm-2 6v-1h1v1zm-8 0v1h-1v-1zm4 1h-1v-1h1zm-1 3h-1v-1h1zm-26 0v1h-1v-1zm31 0v1h-1v-1zm-15 4h-1v-1h1zm-16 1v1h-1v-1zm19 1h-1v-1h1zm0 4v-1h1v1zm-34 77h-1v-1h1z",
    fill: "#292a2c"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M69 124v1h-7v-1h5zm5 1v-1h4v1h-2zm-17 0v-1h2v1h-1zm14 0v-1h2v1h-1zm4-11h-1v-1h1zm-21 10h1v1h-1zm7 1h-1v-1h1z",
    fill: "#1a1a1a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76 32v-1h-1v-1h2v2zm2-25v1h-2V7h1zm0 18h1v1h-2v-1zm-12 7h2v1h-2zm-4 2v-1h2v1h-1zm19-8v1h-1v-1zm-3 1h1v1h-1zm3 1v1h-1v-1zm1 1h1v1h-1zm-31 6h1v1h-1zm-13 82v1h-1v-1z",
    fill: "#2c2d2f"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71h1v5h-1v-2zm0-5h1v3h-1v-1zm1 19h-1v-3h1zm-1-22v-1h1v2h-1zm38-51h-1v-1h1zM46 31v-1h1v1zM36 59v1h-1v-1zm0 30v1h-1v-1z",
    fill: "#343436"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43v-2h1v3h-2v-1zm-6 5v-2h2v1h-1v1zM46 38h2v1h-2zm15 7h-1v-1h2v1zm14 2h1v1h-2v-1zm-19-9h-1v-1h1zm-13 2h-1v-1h1zm16 5h1v1h-1zm-2 4h1v1h-1z",
    fill: "#1b1d1c"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h1v2h-1v-1zm3 5h-2v-1h2zm-2-22V9h1v1zm3 12v1h-1v-1zm0 2v-1h1v1zm7 0v-1h1v1zm-5 5h1v1h-1zm7 1h-1v-1h1zm-40 2h1v1h-1zm40 1h-1v-1h1zm-19 0h1v1h-1zm23 1h-1v-1h1zm-33 0h1v1h-1zm-16 2h-1v-1h1z",
    fill: "#2a2b2d"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M60 36v-1h4v1h-2zm31 42v2h-1v-2zm-30 41h1v1h-2v-1zM77 10v1h-1v-1zM55 28h1v1h-1zm-2 2v-1h1v1zm-2 1h-1v-1h1zm30 0h1v1h-1zm-8 3h-1v-1h1zm12 2v1h-1v-1zm5 21v-1h1v1z",
    fill: "#222325"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76 29v-2h2v1h-1v1zm-16 4v1h-3v-1h1zm27-5v1h-1v-2h1zm-6-12v-1h1v1zm3 9h-1v-1h1zm-2 1v-1h1v1zm1 1v-1h1v1zm-28 4v-1h1v1zm20 2v-1h1v1zm-37 3v-1h1v1zm1 5h-1v-1h1z",
    fill: "#2f3032"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30v-2h1v1h1v1zm-15 2v1h-2v-1h1zM77 5v1h-1V5zm-5 23v-1h1v1zm15 0h1v1h-1zm-39 5v-1h1v1zm23-1h1v1h-1zm-26 1h1v1h-1zm33 0v1h-1v-1zm-30 3v-1h1v1zm24-1h1v1h-1zm-2 1h1v1h-1z",
    fill: "#343537"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M75 32v2h-1v-1h-1v-1zm9 1v1h-1v-2h1zm-3-17h-1v-1h1zm-7 3v-1h1v1zm12 10h1v1h-1zm-5 4h-1v-1h1zm-39 1v1h-1v-1zm28 1v1h-1v-1zm14 0h1v1h-1zm-2 3v-1h1v1zm-11 0h1v1h-1zm-33 77v1h-1v-1z",
    fill: "#28292b"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v-1h4v1h-2zm25 9v-1h4v1h-1zm3-6h-1v-1h2v1zm-8 6v-1h2v1h-1zm3 0h1v1h-2v-1zm-26-9v1h-1v-1z",
    fill: "#1d1f1e"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M79 27h2v1h-1v1h-1zM76 8h1v1h-1zm9 14v-1h1v1zm0 2v1h-1v-1zm-10 4v-1h1v1zm-22 3v-1h1v1zm20 1v-1h1v1zm-30 0v1h-1v-1zm29 2h-1v-1h1zm-33 1v-1h1v1zm17 0v-1h1v1zm-18 1h1v1h-1z",
    fill: "#2b2c2e"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35v1h-4v-1h1zM36 69h1v2h-1v-1zm18-39v-1h1v1zm-11 4h-1v-1h1zm39 0v-1h1v1zm4-1v1h-1v-1zm-14 1h1v1h-1zm18 0h1v1h-1zm-53 76h1v1h-1zm1 2v1h-1v-1z",
    fill: "#232426"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v1h-5v-1h1zm7 5v1h-3v-1zm-5 5v-2h1v2zm6-1v1h-2v-1h1zm6-4v1h-1v-1zm-34 82v1h-1v-1z",
    fill: "#1d1e1f"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M55 37v1h-2v-1h1zm7 7h2v1h-2zm-2 2v-1h2v1h-1zm-1 1h1v1h-2v-1zm17 0h2v1h-2zm-17 2h1v1h-2v-1zm11-1v-1h1v1zm3-1h1v1h-1z",
    fill: "#1c1e1d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M86 24v1h-1v-2h1zm-29 5h2v1h-2zm6 5h1v1h-2v-1zm14-22h-1v-1h1zm-2 15v1h-1v-1zm-2 4v1h-1v-1zm-30 2h1v1h-1zm31 0v1h-1v-1zm-14 1h1v1h-1zm-21 1h1v1h-1z",
    fill: "#27282a"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M60 114v1h-5v-1h1zm16-77h-1v-1h2v1zm11 61v-2h1v2zm-36 24v1h-1v-2h1zm-2-72v1h-1v-1z",
    fill: "#191a1b"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M93 64v3h-1v-3zM79 4V3h2v1h-1zm14 57h-1v-2h1v1zm-3-34v-1h1v1zm3 42h-1v-1h1zm0 1v1h-1v-1zm-1 15v-1h1v1z",
    fill: "#29282e"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M90 96v3h-1v-3zm-6-81v2h-1v-2zm-9 3v-1h1v1zm3-1v1h-1v-1zm10 58v1h-1v-1zm-2 10v-1h1v1zm-45 36v1h-1v-1zm0 2v1h-1v-1z",
    fill: "#1d1d1f"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18h-2v-1h2zm2 37h1v2h-1v-1zm-47 66v-2h1v2zm51-1v1h-2v-1h1zm-2-45h-1v-1h1zm0 2h-1v-1h1zm-44 47v-1h1v1z",
    fill: "#1c1c1e"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25v-1h2v1h-1zm-9-6v1h-1v-1zm5 4v1h-1v-1zm8 0v1h-1v-1zm-9 2v1h-1v-1zm-2 2v-1h1v1zm-4 0h1v1h-1zm4 3h-1v-1h1zm-22 3v-1h1v1zm1 1v1h-1v-1z",
    fill: "#353638"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M43 125v-1h7v1h-5zm44-51v1h-1v-1zm-34 50h1v1h-1zm3 1h-1v-1h1zm27-1h1v1h-1z",
    fill: "#1c1c1c"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67 124v-1h9v1zm-3 0h-2v-1h2z",
    fill: "#151617"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M47 123h1v1h-2v-1zM77 17v1h-1v-1zM54 50h1v1h-1zm33 45h1v1h-1zm1 3v1h-1v-1zm1 11v1h-1v-1zm-41 5h1v1h-1zm31 0h1v1h-1zm9 6v1h-1v-1z",
    fill: "#1a1a1c"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M70 25v2h-1v-2zm2 3v1h-1v-2h1zm-21 5h-1v-1h1zm34-1v1h-1v-1zm-33 2v-1h1v1zm-2 0h1v1h-1zm19 0h1v1h-1zm-31 2v1h-1v-1z",
    fill: "#363739"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h4v1h-1zm1-4v1h-3v-1zm-26-8v-1h1v1zm-4 0h1v1h-1zm28 12v1h-1v-1z",
    fill: "#1e201f"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M50 115v-1h3v1zm-5-65h1v1h-2v-1zm16 64h2v1h-2zm-8-63h-1v-1h1zm33 14v-1h1v1zm0 32h1v1h-1z",
    fill: "#191a1a"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v2h-1v-2zm-47 63v-1h1v2h-1zM78 14v1h-1v-1zm-1 3h-1v-1h1zm8 37v-1h1v1zm3 68h-1v-1h1zm-42 1v1h-1v-1z",
    fill: "#1b1b1d"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v2h-1v-2zm1 1v-1h2v1h-1zm5-35h1v1h-1zm-3 32v-1h1v1zm-7 0v1h-1v-1zm10 5v-1h1v1zm14 72v1h-1v-1z",
    fill: "#1f1f1f"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M76 21v1h-1v-1zm-2 3h1v1h-1zm6 8v1h-1v-1zm-32 1v1h-1v-1zm21 0h1v1h-1zm-20 2h-1v-1h1zm-7 1h-1v-1h1zm5 0v-1h1v1zm35 2h1v1h-1z",
    fill: "#3a3b3d"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50v2h-1v-2zm1 54v-1h1v2h-1zm0 6h1v2h-1v-1zm-1-57h1v1h-1zm2 39h-1v-1h1zm0 15v1h-1v-1z",
    fill: "#191b1d"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M83 125h-4v-1h4zm-20-10v-1h1v1zm-21 9h1v1h-1zm14 1v-1h1v1zm3-1h1v1h-1zm14 0h1v1h-1z",
    fill: "#1b1b1b"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M90 96h1v5h-1zM76 16v-1h1v1zm9 75h1v1h-1zm-44 32h-1v-1h1z",
    fill: "#1f1f21"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M64 24v2h-2v-1h1v-1zm-4 1h1v1h-2v-1zm5 2h-1v-1h1zM36 93v-1h1v1zm0 16h1v1h-1z",
    fill: "#252525"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27h2v1h-2zM37 49v1h-1v-2h1zm21-21v-1h1v1zM37 45h-1v-1h1zm54 10v1h-1v-1zm-32 64h1v1h-1z",
    fill: "#222324"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48v-2h2v1h1v1zm-4-2v2h-1v-2zM37 82h1v1h-1z",
    fill: "#202020"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v-2h4v2z",
    fill: "#212121"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M63 48h5v1h-5zm-3 0h1v1h-1zm-8 3h1v1h-1zm-9 61h1v1h-1z",
    fill: "#181818"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M86 101h1v2h-1v-1zm-21 14h-1v-1h2v1zm13-66h-1v-1h1zm8 23h1v1h-1zm-19 43v-1h1v1zm-8 6v-1h1v1z",
    fill: "#1a1c1c"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M88 99v-3h1v3zM77 16h1v1h-1zM39 97h-1v-1h1zm10 17h1v1h-1zm39 8h1v1h-1z",
    fill: "#19191b"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M35 65v-1h1v2h-1zm1 4v2h-1v-2zm14-41v1h-1v-1zM36 60v1h-1v-1zm0 29h-1v-1h1z",
    fill: "#353537"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M36 88v-1h1v4h-1zm12-56h-2v-1h2zm0-2h1v1h-1z",
    fill: "#262628"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v-1h-1v-1h2v2zm-3-1v1h-2v-1h1zm6-1v1h-1v-1zm1 1v1h-1v-1z",
    fill: "#313332"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M37 78h-1v-5h1v2zm7-45v-1h1v1zm-7 49v1h-1v-1z",
    fill: "#252528"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M75 41v1h-2v-1h1zm11 33v-1h1v1zm0 4v-1h1v1zm2 2v1h-1v-1zm-44 43v1h-1v-1zm42 1h-1v-1h1z",
    fill: "#1b1c1d"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M92 80v-2h1v2zM82 3v1h-1V3zm7 20v1h-1v-1zm-1 3h-1v-1h1zm4 56v-1h1v1z",
    fill: "#26252b"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M92 71h1v3h-1zM84 7h-1V6h1zm8 63v-1h1v1zm0 14v-1h1v1z",
    fill: "#28272d"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61v3h-1v-3zM85 7h-1V6h1zm7 51h1v1h-1zm1 9v1h-1v-1z",
    fill: "#2a292f"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13v-1h1v1zm5 19h-1v-1h1zm2 0v-1h1v1zm-2 0h1v1h-1zm-33 2h1v1h-1zm21 31v1h-1v-1z",
    fill: "#434446"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49v1h-3v-1zm10-34v1h-1v-1zm14 61h-1v-1h1zm-36 49h-1v-1h1z",
    fill: "#1d1d1d"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M49 34h-1v-1h4v1h-2v1h-1zm26-11v-1h1v1z",
    fill: "#38393b"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h1v2h-1v-1zm-1-2h1v1h-1zm2 6v-1h1v1zm-24 4h-1v-1h1zm-3 0v1h-1v-1z",
    fill: "#393a3c"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M70 31h2v1h-2zm1-7v1h-1v-1zm1 1h1v1h-1zM45 35h-1v-1h1zm38 2h1v1h-1z",
    fill: "#424345"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M59 119v1h-5v-1h2zm2-90h-1v-1h1z",
    fill: "#222423"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-2v-1h2zm-9-5h-1v-1h1zm10 0h-1v-1h1zm21 43h-1v-1h1zm-45 43v1h-1v-1z",
    fill: "#1c1d1e"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M70 50h-1v-1h4v1zm4-11h1v1h-1zm-4 9h-1v-1h1z",
    fill: "#1f2120"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M86 105h1v2h-1v-1zM50 51v-1h1v1zm4 1h-1v-1h1zm-9 63v-1h1v1zm34-1v1h-1v-1z",
    fill: "#1a1a1b"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67v-1h3v-2h1v3z",
    fill: "#a83133"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M73 24v1h-2v-1h1zm6 7v-1h2v1h-1zM75 6V5h1v1z",
    fill: "#4a4b4d"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M86 8v1h-1V7h1zm-3-3h1v1h-1zm1 3v1h-1V8zm8 38h1v1h-1z",
    fill: "#323137"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M86 5v1h-1V5zm-3 2h1v1h-1zm10 43h-1v-1h1zm-1 39v-1h1v1zm0 3v-1h1v1z",
    fill: "#2e2d33"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M92 71v2h-1v-2zM78 9h-1V8h1zm14 66h-1v-1h1zm-1 18h1v1h-1z",
    fill: "#2a2b2e"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M92 82v1h-1v-2h1zM77 10V9h1v1zM46 32v1h-1v-1zm9 3v1h-1v-1z",
    fill: "#252629"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M77 14v1h-1v-1zm-2 2v-1h1v1zm10 1v1h-1v-1zM50 31h-1v-1h1zm-12 76v1h-1v-1z",
    fill: "#232325"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v1h-1v-2h1zm7-7v-1h1v1zm-7 5h1v1h-1zm-28 85h-1v-1h1z",
    fill: "#262626"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M88 118v-3h1v3zm-9-99v-1h1v1zm9 91h1v1h-1z",
    fill: "#191a1e"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M82 50v1h-4v-1h1zm2-32v1h-1v-1z",
    fill: "#1b1e1f"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M70 23v1h-1v-1zm0 6v-1h1v1zm1 2h-1v-1h1zm8 0h-1v-1h1zm-29 2h-1v-1h1z",
    fill: "#37383a"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31h1v2h-1v-1zm-11-7h-1v-1h1zm3 1h-1v-1h1zM46 35v1h-1v-1z",
    fill: "#444547"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M83 25h-1v-1h1zm-14 5h1v1h-1zm1 3h-1v-1h1zm-17 0h1v1h-1zm20 2v-1h1v1z",
    fill: "#333436"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27v-2h1v1h2v1zm-3 0h-1v-1h1z",
    fill: "#242424"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M61 28h1v1h-1zM46 38v-1h1v1zm-8 5h-1v-1h1zm3 11h-1v-1h1zm44 11h1v1h-1z",
    fill: "#232524"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M64 30v-1h3v1h-1zm-3 1h-1v-1h2v1z",
    fill: "#2e302f"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31h3v1h-3zm5-2h1v1h-1zm0 2h-1v-1h1z",
    fill: "#303231"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M91 62h1v2h-1v-1zm-1-30h1v1h-1zm2 28v1h-1v-1zm0 34v1h-1v-1z",
    fill: "#2b2c2f"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M37 54h-1v-4h1v1zm14-18h1v1h-1z",
    fill: "#232425"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37h-4v-1h4zm12 10h1v1h-1z",
    fill: "#1c1e1f"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M91 40h1v3h-1zm1 17h-1v-1h1zm-1 45h1v1h-1z",
    fill: "#2f2f33"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41v1h-1v-1zm-1 3h1v1h-1zm3 9h-1v-1h1zm-1 0v1h-1v-1zm15 69v1h-1v-1z",
    fill: "#141615"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50h2v1h-2zm11-9v1h-1v-1zm14 65v1h-1v-1zm-4 18v-1h1v1z",
    fill: "#1e1f20"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52v-1h5v1z",
    fill: "#1a1d1e"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v-1h1v2h-1zm0-4v-1h1v1zm0 1h1v1h-1zm1 33v1h-1v-1z",
    fill: "#2c2b31"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M49 64v2h-3v-1h2v-1zm-1 3h1v1h-1z",
    fill: "#a73032"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73h-1v-4h1v1zm8 39h1v1h-1z",
    fill: "#1e1c1b"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M91 85h1v3h-1zm1-6v1h-1v-2h1z",
    fill: "#27272b"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M87 95v-3h1v3zm2-15h-1v-1h1zm0 31v1h-1v-1z",
    fill: "#191a1d"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M90 99v2h-1v-2zm-1 20v1h-1v-1zm-50 2h1v1h-1zm50 1h-1v-1h1z",
    fill: "#1e1e20"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M87 104v1h-1v-2h1zm0 5v-1h1v2h-1zm-1-2h1v1h-1z",
    fill: "#191b1c"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M86 112v-2h1v2zm-1 2v1h-1v-2h1zm-8 0h1v1h-1z",
    fill: "#191b1e"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M57 125h2v1h-2zm-17 0v-1h1v1zm15 1v-1h1v1zm15-1h1v1h-1z",
    fill: "#1a1a1a",
    fillOpacity: 0.678
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M39 120v2h-1v-2zM84 3v1h-1V3zm3 20h-1v-1h1z",
    fill: "#272729"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h2v1h-2zm0-22h1v1h-1zm13 32v1h-1v-1z",
    fill: "#3c3d3f"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M93 87h-1v-2h1v1zM84 6V5h1v1zm3 20h1v1h-1z",
    fill: "#2b2a30"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M86 7h-1V6h1zm4 18h1v1h-1zm3 23v1h-1v-1zm0 45h-1v-1h1z",
    fill: "#2f2e34"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M84 9V8h1v1zm2 2v1h-1v-1zM45 31v1h-1v-1zm48 63h-1v-1h1z",
    fill: "#302f35"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M72 11h-1v-1h1zm12 4h-1v-1h1zM50 29v1h-1v-1zm-1 2v1h-1v-1z",
    fill: "#29292b"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M85 18v-1h1v2h-1zm-10-4h1v1h-1zm13 9h-1v-1h1z",
    fill: "#28282a"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M71 18v-1h1v1zm-4 6v-1h1v1zm1 1h1v1h-1zm12 61h1v1h-1z",
    fill: "#303030"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M76 19v-1h1v1zm-8 18v-1h1v1zM54 51h-1v-1h1zm33 20h-1v-1h1z",
    fill: "#1a1b1c"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h2v1zm4-3v1h-1v-1zM36 56h1v1h-1z",
    fill: "#232323"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M93 75v3h-1v-3zm-4-50h-1v-1h1z",
    fill: "#25242a"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1zm3 0h1v1h-1zm22 37h1v1h-1zM36 94v-1h1v1z",
    fill: "#232424"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v-1h1v1zm2 5h-1v-1h1zm-1 2v-1h1v1zm1 3h-1v-1h1z",
    fill: "#3c3b41"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M64 30v1h-2v-1h1zm4 2h-1v-1h1zm-24 6h-1v-1h1z",
    fill: "#2f3130"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M92 32v1h-1v-1zm0 3h-1v-1h1zm-1 39v-1h1v1zm1 18h-1v-1h1z",
    fill: "#2a2a2e"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M91 98v-2h1v2zM64 34v-1h1v1zm27 37v-1h1v1z",
    fill: "#2b2b2e"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M50 123v1h-2v-1h1zm28-87v1h-1v-1zm4 88h-1v-1h1z",
    fill: "#171819"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M51 124h-1v-1h2v1zm18-86h-1v-1h1zM43 50h1v1h-1z",
    fill: "#181919"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M64 122h2v1h-2zm7-83h-1v-1h1zm-31 2h-1v-1h1z",
    fill: "#141517"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M86 99h1v2h-1v-1zM68 40h1v1h-1zm19 29h-1v-1h1z",
    fill: "#1a1b1b"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h-1v-1h2v1zm-1 64v-1h1v1zm21 16h-1v-1h1z",
    fill: "#161818"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45v1h-1v-2h1zm-1 7h1v2h-1v-1z",
    fill: "#313135"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M53 124v1h-2v-1h1zm8-78v1h-1v-1zm2 3h1v1h-1z",
    fill: "#1e1e1e"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M92 52h-1v-4h1v1z",
    fill: "#303134"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M92 52v-2h1v2zm1 1v1h-1v-1zm-1 37h1v1h-1z",
    fill: "#2d2c32"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M38 108v2h-1v-2zm-1-53h-1v-1h1zm-1 40v-1h1v1z",
    fill: "#242425"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58v2h-1v-2zm-1 37h1v1h-1zm0 6v-1h1v1z",
    fill: "#2c2c30"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M34 73h-1v-3h1zm0 3h-1v-1h1z",
    fill: "#5a5a5a",
    fillOpacity: 0.231
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M38 77v1h-1v-4h1z",
    fill: "#201e1d"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M39 77h-1v-3h1v1zm-1 2h1v1h-1z",
    fill: "#151a16"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M39 94h1v2h-1v-1zm0-6h1v1h-1zm0 2h1v1h-1z",
    fill: "#1e1611"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101h1v1h-1zm-3 1h1v1h-1zm3 1v1h-1v-1zm-2 1v1h-1v-1z",
    fill: "#664037"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M88 112h1v3h-1zm-7 3v-1h1v1z",
    fill: "#1a1b1e"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M58 113h1v1h-2v-1zm16 1h-1v-1h1zm6-1v1h-1v-1z",
    fill: "#1a1a19"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M70 125h-1v-1h2v1zm-9-1h1v1h-1zm17 1v-1h1v1z",
    fill: "#191919"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M72 5V4h1v1zm2 6v1h-1v-1zm-3 2v-1h1v1z",
    fill: "#3a3a3c"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M92 103v2h-1v-2zM76 5V4h1v1z",
    fill: "#2e2e32"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M73 7h-1V6h1zm6 2V8h1v1zm11 109v1h-1v-1z",
    fill: "#2b2c31"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M79 6h2v1h-2zm6 4h-1V9h1z",
    fill: "#27282d"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M74 8V7h1v1zM59 31h1v1h-1zm-12 5v1h-1v-1z",
    fill: "#323334"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M85 7v1h-1V7zm8 40v1h-1v-1zm-1 48v-1h1v1z",
    fill: "#313036"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M71 8h1v1h-1zm10 3v1h-1v-1zm10 98h1v1h-1z",
    fill: "#2c2d31"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M72 10h-1V9h1zm0 4v-1h1v1zM50 31v1h-1v-1z",
    fill: "#2c2c2e"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M73 10v1h-1v-1zm2 8h-1v-1h1zM37 82h-1v-1h1z",
    fill: "#252527"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M71 11h1v1h-1zM50 29v-1h1v1zM36 44h-1v-1h1z",
    fill: "#38383a"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M78 12v-1h1v2h-1zm12 103h-1v-1h1z",
    fill: "#212226"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12v1h-1v-1zm25 24v1h-1v-1zm-1 80h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M80 12v1h-1v-1zM44 32v1h-1v-1zm47 36h1v1h-1z",
    fill: "#27282b"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15v-1h1v1zm6 104v1h-1v-1zm-3 5h-1v-1h1z",
    fill: "#202022"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M84 16v-1h1v1zM60 123h1v1h-1zm6 0h1v1h-1z",
    fill: "#151517"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M78 19h-1v-1h1zm6 34v-1h1v1zm5 30h-1v-1h1z",
    fill: "#1b1b1e"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20v-1h1v1zm-10 5h-1v-1h1zm-12 3v1h-1v-1z",
    fill: "#919191",
    fillOpacity: 0.027
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h-1v-1h1zm2-1h1v1h-1zM48 35h-1v-1h1z",
    fill: "#3b3c3e"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M37 46v2h-1v-2zm21-19v1h-1v-1z",
    fill: "#222223"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28h-1v-1h1zm0 10h1v1h-1zm-60 4v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M59 28h1v1h-1zm-6 9h-1v-1h1zm33 47h-1v-1h1z",
    fill: "#212223"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M41 31v-1h1v1zm53 7v-1h1v1zm-61 63v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M72 30v1h-1v-1zm13 2h-1v-1h1zm-13 5v1h-1v-1z",
    fill: "#494a4c"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33h1v1h-1zm0 32v-1h1v1zm1 26h-1v-1h1z",
    fill: "#292a2d"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M91 36v-1h1v1zm1 40v1h-1v-1zm0 13v1h-1v-1z",
    fill: "#29292d"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36v1h-1v-1zM36 80v-1h1v1zm0 19h1v1h-1z",
    fill: "#242526"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37v-1h1v1zm36 8h1v1h-1zm1 57h-1v-1h1z",
    fill: "#1e2021"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36h1v1h-1zm21 47h-1v-1h1zm-1 19h1v1h-1z",
    fill: "#1a1c1d"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37v1h-1v-1zm-5 1h1v1h-1zm33 2v1h-1v-1z",
    fill: "#202221"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44h1v1h-1zm1 18h-1v-1h1zm-1 26v-1h1v1z",
    fill: "#353437"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46v-1h1v1zm49 38h1v1h-1zm0 7v-1h1v1z",
    fill: "#202021"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v-2h1v2zM34 96v1h-1v-1z",
    fill: "#d4d4d4",
    fillOpacity: 0.047
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h1v2h-1v-1zm0-3h1v1h-1z",
    fill: "#323234"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49v1h-1v-1zm-15 6h-1v-1h1zm6 59h-1v-1h1z",
    fill: "#191c1b"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M52 113h1v1h-2v-1zm4-63v1h-1v-1z",
    fill: "#1a1a17"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51h1v1h-2v-1zm-5 1h-1v-1h1z",
    fill: "#181716"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54h-2v-1h2zm-4 0v-1h1v1z",
    fill: "#423c3c"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63h3v1h-3z",
    fill: "#a22e31"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65v-1h1v2h-1zm1 15v1h-1v-1z",
    fill: "#414143",
    fillOpacity: 0.969
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h2v1h-2zm-4-1h-1v-1h1z",
    fill: "#a72f32"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v-3h1v3z",
    fill: "#a93435"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66v1h-1v-1zm-1 4v-1h1v1zm0 8v-1h1v1z",
    fill: "#28282c"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M34 69h1v3h-1z",
    fill: "#424244",
    fillOpacity: 0.984
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M34 72h1v3h-1z",
    fill: "#414143",
    fillOpacity: 0.988
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M92 75v-1h1v1zm0 5h1v1h-1zm0 3v-1h1v1z",
    fill: "#27262c"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M39 86v1h-1v-2h1zm37 27h1v1h-1z",
    fill: "#161a19"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M38 95v1h-1v-2h1zm-1-6v-1h1v1z",
    fill: "#242122"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89h1v3h-1z",
    fill: "#5d5d62",
    fillOpacity: 0.192
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M37 91v1h-1v-1zm-1 4h1v1h-1zm1 17v1h-1v-1z",
    fill: "#262627"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M40 91v3h-1v-3z",
    fill: "#1d1510"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M38 96v-2h1v2zm45 27v-1h1v1z",
    fill: "#17181b"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M89 100v1h-1v-2h1zm-1 20h-1v-1h1z",
    fill: "#18181a"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h1v1h-1zm2 2v-1h1v1zm0 1h1v1h-1z",
    fill: "#643e35"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M90 111v-1h1v2h-1zm0 2h1v1h-1z",
    fill: "#202027"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M86 113v-1h1v1zm-45 0h1v1h-1zm1 1h1v1h-1z",
    fill: "#181c1d"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M59 114v-1h1v1zm5-1h1v1h-1zm4 0v1h-1v-1z",
    fill: "#1b1a18"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M67 114v1h-1v-1zm2 0v1h-1v-1zm-19 6v-1h1v1z",
    fill: "#1b1d1d"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M66 124h-2v-1h2zm-4 0h-1v-1h1z",
    fill: "#141516"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M76 123h2v1h-2zm3 0h1v1h-1z",
    fill: "#161718"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M63 126v-1h3v1z",
    fill: "#1d1d1d",
    fillOpacity: 0.651
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M74 3v1h-1V3zm12 79v1h-1v-1z",
    fill: "#232225"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M76 4h-1V3h1zm11 19h1v1h-1z",
    fill: "#252429"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M78 5h-1V3h1v1z",
    fill: "#29282d"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M72 6V5h1v1zm10 2h-1V7h1z",
    fill: "#323338"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M75 5v1h-1V5zM41 111h-1v-1h1z",
    fill: "#545556"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M79 6V5h1v1zm0 15h1v1h-1z",
    fill: "#3a3b40"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M82 6V5h1v1zm10 110h-1v-1h1z",
    fill: "#414146"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M74 6v1h-1V6zm3 0h1v1h-1z",
    fill: "#26272a"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M79 6v1h-1V6zm11 111h-1v-1h1z",
    fill: "#26272c"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M72 7v1h-1V7zm0 13h-1v-1h1z",
    fill: "#35363a"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M79 9h-1V8h1zm11 109h-1v-1h1z",
    fill: "#2a2b30"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M73 10h-1V9h1zM53 35h1v1h-1z",
    fill: "#27272a"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M81 10h1v1h-1zm9 103v-1h1v1z",
    fill: "#212228"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M74 11h1v1h-1zm-2 15h-1v-1h1z",
    fill: "#404143"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M78 11v1h-1v-1zM53 29v-1h1v1z",
    fill: "#212225"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M79 12v-1h1v1zm11 103v1h-1v-1z",
    fill: "#232428"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M76 13h-1v-1h1zm-2 11h-1v-1h1z",
    fill: "#545557"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M74 13v1h-1v-1zM39 122h1v1h-1z",
    fill: "#212123"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M81 13v1h-1v-1zm-2 3h-1v-1h1z",
    fill: "#131416"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M85 13h1v1h-1zm8 86h-1v-1h1z",
    fill: "#37363c"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15v-1h1v1zm-3 10h-1v-1h1z",
    fill: "#2d2d2d"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M82 14h1v1h-1zM36 42v1h-1v-1z",
    fill: "#3c3c3e"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M86 15h-1v-1h1zM37 63v1h-1v-1z",
    fill: "#252427"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16h-1v-1h1zM36 99h-1v-1h1z",
    fill: "#444446"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M82 15h1v1h-1zM65 59h-1v-1h1z",
    fill: "#454547"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M72 16h1v1h-1zm-5 9h1v1h-1z",
    fill: "#2c2c2c"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v1h-1v-1zM48 29h1v1h-1z",
    fill: "#2f2f31"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M82 16v1h-1v-1zM70 36v-1h1v1z",
    fill: "#515254"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v-1h1v1zM38 120h-1v-1h1z",
    fill: "#2a2a2c"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18h-1v-1h1zM37 44h-1v-1h1z",
    fill: "#272728"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M72 19h-1v-1h1zM35 49v-1h1v1z",
    fill: "#323235"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M73 19h-1v-1h1zm19 35v1h-1v-1z",
    fill: "#313235"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M85 18v1h-1v-1zM36 61h1v1h-1z",
    fill: "#232526"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M75 20h-1v-1h1zm2 13v-1h1v1z",
    fill: "#48494b"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M75 21h-1v-1h1zM37 40v-1h1v1z",
    fill: "#696a6c"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h1v1h-1zm9 4v-1h1v1z",
    fill: "#232228"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M79 23h-1v-1h1zm10 4v1h-1v-1z",
    fill: "#2b2b30"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24v-1h1v1zm15 9v-1h1v1z",
    fill: "#454648"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h-1v-1h1zm35 50h1v1h-1z",
    fill: "#444",
    fillOpacity: 0.161
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v1h-1v-2h1z",
    fill: "#292929"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24v1h-1v-1zm-16 4v-1h1v1z",
    fill: "#303031"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27h-1v-1h2v1z",
    fill: "#242329"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27v1h-1v-1zm36 6v1h-1v-1z",
    fill: "#272829"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1zm2-1h1v1h-1z",
    fill: "#232423"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27v1h-1v-1zm0 3v1h-1v-1z",
    fill: "#323333"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M51 29v-1h1v1zm-14 89h1v1h-1z",
    fill: "#2c2e30"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h1v1h-1zm-16 9v1h-1v-1z",
    fill: "#262827"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1zm11 12v-1h1v1z",
    fill: "#272928"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29v-1h1v1zm-3 1h-1v-1h1z",
    fill: "#2a2c2b"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v1h-1v-1zm-4 2h-1v-1h1z",
    fill: "#2c2e2d"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v-1h1v1zm-32 9h1v1h-1z",
    fill: "#333434"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30h1v1h-1zm6 3v-1h1v1z",
    fill: "#2e2f30"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M84 31v-1h1v1zm-12 5v1h-1v-1z",
    fill: "#3e3f41"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h1v1h-1zm-35 5h-1v-1h1z",
    fill: "#525355"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34v2h-1v-2z",
    fill: "#3f4042"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M66 35v1h-2v-1h1z",
    fill: "#202124"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M92 36v-1h1v2h-1z",
    fill: "#3d3c42"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36h1v1h-1zm-11 76h-1v-1h1z",
    fill: "#262728"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36v1h-1v-1zM37 81h-1v-1h1z",
    fill: "#232525"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1zm37 52h-1v-1h1z",
    fill: "#1f2021"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37v1h-1v-1zm14 64h1v1h-1z",
    fill: "#434344"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v1h-1v-1zm18 2h1v1h-1z",
    fill: "#2e2f32"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37v1h-1v-1zm0 70h-1v-1h1z",
    fill: "#2d2d31"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39h-1v-1h1zm10 80h1v1h-1z",
    fill: "#212322"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h1v1h-1zm0 67h1v1h-1z",
    fill: "#2c2d30"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M95 39v1h-1v-1zM34 99v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.024
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40v1h-1v-1zm25 18v1h-1v-1z",
    fill: "#454545"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v-1h1v2h-1z",
    fill: "#38373d"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43v-1h1v1zm49 26h-1v-1h1z",
    fill: "#38393a"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M77 42v1h-1v-1zm11 76h1v1h-1z",
    fill: "#1c1d20"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43v1h-1v-2h1z",
    fill: "#fff",
    fillOpacity: 0.035
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M95 46h-1v-2h1v1z",
    fill: "#fff",
    fillOpacity: 0.039
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h2v1h-1z",
    fill: "#1d1e1d"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1zm-13 4h-1v-1h1z",
    fill: "#171717"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1zm-16 64h1v1h-1z",
    fill: "#161616"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M95 49h-1v-1h1zm-2 69h-1v-1h1z",
    fill: "#c4c4c4",
    fillOpacity: 0.051
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M34 49v1h-1v-1zm60 11h1v1h-1z",
    fill: "#8b8b8b",
    fillOpacity: 0.086
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51h-1v-2h1v1z",
    fill: "#1f201f"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50v-1h1v1zM34 96h-1v-1h1z",
    fill: "#b6b6b6",
    fillOpacity: 0.055
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M34 51h-1v-1h1zm60 12v-1h1v1z",
    fill: "#848484",
    fillOpacity: 0.098
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h-1v-1zm8 1h1v1h-1z",
    fill: "#1e1e1c"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M64 50v1h-1v-1zM37 80v-1h1v1z",
    fill: "#1f1f1a"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51v-1h1v1zm16 58h1v1h-1z",
    fill: "#1f201d"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M93 51v-1h1v2h-1z",
    fill: "#424145",
    fillOpacity: 0.843
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h-1v-1h1zm-9 2v1h-1v-1z",
    fill: "#161816"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M56 52h-1v-1h1zM38 88v-1h1v1z",
    fill: "#161a1c"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51v1h-1v-1zm11 1h-1v-1h1z",
    fill: "#1b1e1c"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M67 52h-1v-1h2v1z",
    fill: "#1a201d"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M51 52h1v1h-1zm6 1h-1v-1h1z",
    fill: "#342826"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53h-2v-1h2z",
    fill: "#302922"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M65 52h1v1h-2v-1z",
    fill: "#2f2823"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M69 52v1h-2v-1h1z",
    fill: "#2d2722"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M79 53h-1v-1h2v1z",
    fill: "#222122"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54v-1h1v1zm62 46v1h-1v-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.157
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53v2h-1v-2z",
    fill: "#9f9f9f",
    fillOpacity: 0.063
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M87 54v1h-1v-1zm-46 60h1v1h-1z",
    fill: "#191c1d"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54v1h-1v-1zm-45 59h-1v-1h1z",
    fill: "#181a1b"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h-1v-1h1zm14 57v1h-1v-1z",
    fill: "#1a1b16"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57h-1v-2h1v1z",
    fill: "#403333"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M79 55v1h-1v-1zm1 2h1v1h-1z",
    fill: "#3a2e30"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57v-2h1v2z",
    fill: "#271b1d"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M94 57v-2h1v2z",
    fill: "#969696",
    fillOpacity: 0.067
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57v-1h1v1zm2 8h-1v-1h1z",
    fill: "#3d3133"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M80 56v1h-1v-1zm0 2h1v1h-1z",
    fill: "#3b2f31"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58v-1h1v2h-1z",
    fill: "#241d1e"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M86 58v1h-1v-2h1z",
    fill: "#221f22"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M37 58h1v1h-1zm1 45v-1h1v1z",
    fill: "#1e1a1b"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M94 58h1v1h-1zm0 49h1v1h-1z",
    fill: "#939393",
    fillOpacity: 0.075
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60h-1v-1h1zm48 28v-1h1v1z",
    fill: "#1f1a1e"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60h1v1h-2v-1z",
    fill: "#7b1e24"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v1h-1v-1zm-26 51h1v1h-1z",
    fill: "#302423"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61v1h-1v-1zm0 22h-1v-1h1z",
    fill: "#424244",
    fillOpacity: 0.961
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62h-1v-1h1zm1-1h1v1h-1z",
    fill: "#922731"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h1v1h-1zm0 14h1v1h-1z",
    fill: "#2b2b2f"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M34 62h1v1h-1zm1 19v1h-1v-1z",
    fill: "#414143",
    fillOpacity: 0.965
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62v1h-2v-1h1z",
    fill: "#9e2c30"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62h1v2h-1v-1z",
    fill: "#202223"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63h1v1h-1zm0 48h-1v-1h1z",
    fill: "#4e3934"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64v-1h1v1zm1 25h-1v-1h1z",
    fill: "#252124"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M36 64h1v2h-1v-1z",
    fill: "#272528"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v-1h1v2h-1z",
    fill: "#1f1c1c"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64v1h-2v-1h1z",
    fill: "#a62f31"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64h1v2h-1v-1z",
    fill: "#ac393d"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v1h-1v-1zm-3 25v-1h1v1z",
    fill: "#393132"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M43 65h1v1h-2v-1z",
    fill: "#a72f34"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v1h-1v-1zm-1 2h1v1h-1z",
    fill: "#3a3839"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65h1v1h-1zM35 93h1v1h-1z",
    fill: "#393939"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h-1v-1h1zm-1 22h1v1h-1z",
    fill: "#28292c"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M38 66v2h-1v-2z",
    fill: "#201d1d"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v1h-1v-1zm-1 3v-1h1v1z",
    fill: "#151915"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M42 67v-1h1v1zm3 0h-1v-1h1z",
    fill: "#a92e30"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M86 67h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#242625"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v-1h1v1zm0 10v-1h1v1z",
    fill: "#151a15"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v1h-1v-1zm0 5v1h-1v-1z",
    fill: "#1f1d1c"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71h-1v-2h1v1z",
    fill: "#151815"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v1h-2v-1h1z",
    fill: "#b34d53"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v1h-1v-1zm4 6h-1v-1h1z",
    fill: "#b04b4f"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v-2h1v2z",
    fill: "#151714"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M87 71v1h-1v-1zm-1 27h1v1h-1z",
    fill: "#1b1c1c"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M33 74v-1h1v2h-1z",
    fill: "#595959",
    fillOpacity: 0.235
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M40 75v1h-1v-2h1z",
    fill: "#1f1619"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75h-1v-1h1zm10 1v1h-1v-1z",
    fill: "#ad4a49"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M85 76h-1v-1h1zm-4 7h1v1h-1z",
    fill: "#302f2a"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M95 77v1h-1v-2h1z",
    fill: "#464646",
    fillOpacity: 0.157
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M39 85h-1v-2h1v1z",
    fill: "#151918"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M40 83v2h-1v-2z",
    fill: "#1d1416"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M92 84v1h-1v-2h1z",
    fill: "#262629"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84h1v2h-1v-1z",
    fill: "#444446",
    fillOpacity: 0.953
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M38 87h-1v-2h1v1z",
    fill: "#23221f"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#1e1c1f"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M37 87h1v1h-1zm1 10h-1v-1h1z",
    fill: "#232122"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h1v1h-2v-1z",
    fill: "#eb895f"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88v1h-1v-1zm3 25h-1v-1h1z",
    fill: "#161a1b"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M67 89h-1v-1h2v1z",
    fill: "#f4875f"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M69 89h-1v-1h1zm-11 3v-1h1v1z",
    fill: "#f3865a"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90h-1v-1h1zm0 4h-1v-1h1z",
    fill: "#232121"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M39 90v1h-1v-2h1z",
    fill: "#14181a"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M79 89v1h-1v-1zm1 0h1v1h-1z",
    fill: "#3a3030"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M37 92v-1h1v2h-1z",
    fill: "#232021"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M38 93v-1h1v2h-1z",
    fill: "#16171a"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92v2h-1v-2z",
    fill: "#ae6444"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93v-1h1v1zm-23 18h-1v-1h1z",
    fill: "#362424"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93h1v1h-1zm-11 13h1v1h-1z",
    fill: "#412d24"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M78 94v-1h1v1zm2 0v-1h1v1z",
    fill: "#442f2d"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M86 93h1v1h-1zm-47 17h-1v-1h1z",
    fill: "#1b1b20"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M40 95v-1h1v2h-1z",
    fill: "#ad6443"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M80 95h-1v-1h1zm0 2v-1h1v1z",
    fill: "#4b3330"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96v-2h1v2z",
    fill: "#49312d"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97v-1h1v1zm-24 14v1h-1v-1z",
    fill: "#352726"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M87 96v1h-1v-1zm-38 18v-1h1v1z",
    fill: "#1a191a"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M93 98h-1v-2h1v1z",
    fill: "#343339"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M38 98v-1h1v2h-1z",
    fill: "#19191d"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M77 97v1h-2v-1h1z",
    fill: "#5a3834"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M86 97v1h-1v-1zm-1 6v-1h1v1z",
    fill: "#241f1e"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M83 98h1v1h-1zm1 6v1h-1v-1z",
    fill: "#402a28"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M85 98v2h-1v-2z",
    fill: "#413332"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M92 100h-1v-2h1v1z",
    fill: "#2c2b2f"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h1v1h-1zm20 14v-1h1v1z",
    fill: "#26201f"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M48 99v1h-2v-1h1z",
    fill: "#9b9b9b"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100h-2v-1h2z",
    fill: "#979797"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100h1v2h-1v-1z",
    fill: "#643d32"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M65 101v1h-1v-1zm1 10v-1h1v1z",
    fill: "#4f3732"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M71 102h-1v-1h2v1z",
    fill: "#674138"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M70 102h1v1h-1zm-2 2h1v1h-1z",
    fill: "#653f37"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M70 103h1v1h-2v-1z",
    fill: "#684239"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103v2h-1v-2z",
    fill: "#352625"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M71 105h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#633d34"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M92 109v-2h1v2z",
    fill: "#49484e"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M84 110v-2h1v2z",
    fill: "#372e2b"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M58 110v1h-1v-2h1z",
    fill: "#352424"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109v1h-1v-1zm1 1h1v1h-1z",
    fill: "#382524"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h-1v-1h2v1z",
    fill: "#a09390"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109v1h-1v-1zm0 4v1h-1v-1z",
    fill: "#171d1d"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M56 110h1v1h-2v-1z",
    fill: "#322"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M90 112h-1v-2h1v1z",
    fill: "#1f2024"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M94 110h1v1h-1zm-59 5h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.02
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M61 111v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#382928"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M71 112h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#593330"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M69 113v-1h2v1h-1z",
    fill: "#412b25"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114v-1h1v1zm3-1v1h-1v-1z",
    fill: "#191819"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M51 114h-1v-1h1zm27 0v-1h1v1z",
    fill: "#1a1a18"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M55 114v-1h2v1h-1z",
    fill: "#191918"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M60 114v-1h2v1h-1z",
    fill: "#1c1917"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M65 113h2v1h-2z",
    fill: "#1b1b18"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M69 114v-1h2v1h-1z",
    fill: "#1c1a16"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M76 114h-1v-1h1zm-25 6v1h-1v-1z",
    fill: "#181a1a"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M80 114v-1h1v1zm-36 0v1h-1v-1z",
    fill: "#191b1b"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114v1h-1v-1zm16 1h-1v-1h1z",
    fill: "#1a1b1a"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M53 114h2v1h-2z",
    fill: "#1a1b19"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M75 115v-1h1v1zm9-1v1h-1v-1z",
    fill: "#191b1f"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M86 114h1v1h-2v-1z",
    fill: "#181b1d"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M52 123h-1v-2h1v1z",
    fill: "#181a18"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M60 122v2h-1v-2z",
    fill: "#151717"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M54 124v-1h1v1zm2 0v-1h1v1z",
    fill: "#151616"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M79 124h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#161618"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M82 124v-1h1v1zm2 0v-1h1v1z",
    fill: "#18191a"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M72 2v1h-1V2z",
    fillOpacity: 0.004
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M73 2v1h-1V2z",
    fill: "#242424",
    fillOpacity: 0.137
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M74 3h-1V2h1z",
    fill: "#212121",
    fillOpacity: 0.329
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M74 2h1v1h-1z",
    fill: "#1b1b1f",
    fillOpacity: 0.443
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M75 2h1v1h-1z",
    fill: "#1d1d1f",
    fillOpacity: 0.545
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M76 2h1v1h-1z",
    fill: "#222023",
    fillOpacity: 0.616
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M77 3V2h1v1z",
    fill: "#232325",
    fillOpacity: 0.647
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M78 3V2h1v1z",
    fill: "#212125",
    fillOpacity: 0.659
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M80 2v1h-1V2z",
    fill: "#232226",
    fillOpacity: 0.643
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M81 3h-1V2h1z",
    fill: "#232328",
    fillOpacity: 0.6
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M81 2h1v1h-1z",
    fill: "#211f25",
    fillOpacity: 0.533
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M83 2v1h-1V2z",
    fill: "#212125",
    fillOpacity: 0.451
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M83 3V2h1v1z",
    fill: "#202023",
    fillOpacity: 0.369
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M85 2v1h-1V2z",
    fill: "#202020",
    fillOpacity: 0.216
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M86 3h-1V2h1z",
    fill: "#27273a",
    fillOpacity: 0.051
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M70 4V3h1v1z",
    fill: "#1f1f1f",
    fillOpacity: 0.063
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M71 3h1v1h-1z",
    fill: "#242424",
    fillOpacity: 0.624
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M73 3v1h-1V3z",
    fill: "#232323",
    fillOpacity: 0.922
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M75 3v1h-1V3z",
    fill: "#222026"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M77 3v1h-1V3z",
    fill: "#27262b"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M79 3v1h-1V3z",
    fill: "#2a282e"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M83 4h-1V3h1z",
    fill: "#262529"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M85 3v1h-1V3z",
    fill: "#272729",
    fillOpacity: 0.973
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M86 3v1h-1V3z",
    fill: "#2c2c2d",
    fillOpacity: 0.792
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M86 4V3h1v1z",
    fill: "#2e2e2e",
    fillOpacity: 0.173
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M70 4h1v1h-1z",
    fill: "#333",
    fillOpacity: 0.349
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M74 5h-1V4h1z",
    fill: "#424246"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M74 4h1v1h-1z",
    fill: "#48484c"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M76 4v1h-1V4z",
    fill: "#3c3b40"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M78 5V4h1v1z",
    fill: "#2a2a2f"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M80 5h-1V4h1z",
    fill: "#2e2e34"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M80 4h1v1h-1z",
    fill: "#38383e"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M82 4v1h-1V4z",
    fill: "#47474d"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M82 4h1v1h-1z",
    fill: "#4d4c51"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M83 5V4h1v1z",
    fill: "#424145"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M85 4v1h-1V4z",
    fill: "#39383d"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M86 5h-1V4h1z",
    fill: "#38383c"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M87 4v1h-1V4z",
    fill: "#312e33",
    fillOpacity: 0.427
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M71 6h-1V5h1z",
    fill: "#2c2e30",
    fillOpacity: 0.471
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M72 5v1h-1V5z",
    fill: "#313236"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M74 6h-1V5h1z",
    fill: "#3d3e41"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M78 5h1v1h-1z",
    fill: "#333438"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M81 6h-1V5h1z",
    fill: "#3f4045"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M82 6h-1V5h1z",
    fill: "#494a4f"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M86 6V5h1v1z",
    fill: "#312f35",
    fillOpacity: 0.486
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M71 6v1h-1V6z",
    fill: "#333337",
    fillOpacity: 0.502
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M71 7V6h1v1z",
    fill: "#2e3033"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M81 7V6h1v1z",
    fill: "#27292d"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M82 6h1v1h-1z",
    fill: "#27272c"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M86 6h1v1h-1z",
    fill: "#39383d",
    fillOpacity: 0.553
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M71 8h-1V7h1z",
    fill: "#343437",
    fillOpacity: 0.537
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M72 8V7h1v1z",
    fill: "#2f3034"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M73 8V7h1v1z",
    fill: "#2f3033"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M79 7v1h-1V7z",
    fill: "#2d2e33"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M80 7v1h-1V7z",
    fill: "#2e2f34"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M81 8h-1V7h1z",
    fill: "#2f3035"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M83 7v1h-1V7z",
    fill: "#2f2f35"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M87 8h-1V7h1z",
    fill: "#3a393f",
    fillOpacity: 0.596
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M71 9h-1V8h1z",
    fill: "#2d2f30",
    fillOpacity: 0.573
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M73 9h-1V8h1z",
    fill: "#2a2b2f"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M74 8v1h-1V8z",
    fill: "#2b2c30"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M80 8h1v1h-1z",
    fill: "#303136"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M82 9h-1V8h1z",
    fill: "#36373c"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M83 8v1h-1V8z",
    fill: "#333338"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M86 9V8h1v1z",
    fill: "#2d2b31",
    fillOpacity: 0.663
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M71 9v1h-1V9z",
    fill: "#2d2d2f",
    fillOpacity: 0.592
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M79 10h-1V9h1z",
    fill: "#282930"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M80 10h-1V9h1z",
    fill: "#2e2d35"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M80 10V9h1v1z",
    fill: "#2f2f36"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M82 9v1h-1V9z",
    fill: "#33333a"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M83 9v1h-1V9z",
    fill: "#2e3036"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M84 10h-1V9h1z",
    fill: "#2b2d32"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M85 9h1v1h-1z",
    fill: "#29292f"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M87 10h-1V9h1z",
    fill: "#29292f",
    fillOpacity: 0.651
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M71 10v1h-1v-1z",
    fill: "#303031",
    fillOpacity: 0.604
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M77 11v-1h1v1z",
    fill: "#222326"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M79 11h-1v-1h1z",
    fill: "#23242a"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M80 10v1h-1v-1z",
    fill: "#24252b"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M81 11h-1v-1h1z",
    fill: "#25262c"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M82 11v-1h1v1z",
    fill: "#202328"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M83 10h1v1h-1z",
    fill: "#1f2227"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M84 11v-1h1v1z",
    fill: "#202227"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M86 11h-1v-1h1z",
    fill: "#26262c"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M87 11h-1v-1h1z",
    fill: "#312f35",
    fillOpacity: 0.612
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M71 12h-1v-1h1z",
    fill: "#363639",
    fillOpacity: 0.663
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M81 12v-1h1v1z",
    fill: "#3c3d42"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M82 11h1v1h-1z",
    fill: "#42454a"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M84 11v1h-1v-1z",
    fill: "#33373b"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M84 12v-1h1v1z",
    fill: "#2c2d32"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M86 12v-1h1v1z",
    fill: "#36353b",
    fillOpacity: 0.62
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12h1v1h-1z",
    fill: "#333334",
    fillOpacity: 0.718
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M72 13v-1h1v1z",
    fill: "#303032"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M75 12v1h-1v-1z",
    fill: "#6b6c6e"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M80 13v-1h1v1z",
    fill: "#353639"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M82 13h-1v-1h1z",
    fill: "#636467"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M82 13v-1h1v1z",
    fill: "#5e6165"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M84 13h-1v-1h1z",
    fill: "#2c2f34"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M85 12v1h-1v-1z",
    fill: "#23252a"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M86 13h-1v-1h1z",
    fill: "#303036"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M87 13h-1v-1h1z",
    fill: "#29282e",
    fillOpacity: 0.694
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M69 14v-1h1v1z",
    fill: "#3f3f3f",
    fillOpacity: 0.016
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M71 14h-1v-1h1z",
    fill: "#343436",
    fillOpacity: 0.757
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M71 13h1v1h-1z",
    fill: "#3c3c3d"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M81 14v-1h1v1z",
    fill: "#101113"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M82 13h1v1h-1z",
    fill: "#0f1114"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M84 13v1h-1v-1z",
    fill: "#17191d"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M85 14h-1v-1h1z",
    fill: "#232327"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M86 14v-1h1v1z",
    fill: "#2c2b31",
    fillOpacity: 0.671
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M70 15h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M71 14v1h-1v-1z",
    fill: "#2e2e2e",
    fillOpacity: 0.753
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h-1v-1h1z",
    fill: "#333"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v-1h1v1z",
    fill: "#353536"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M75 15h-1v-1h1z",
    fill: "#48484a"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M86 14h1v1h-1z",
    fill: "#323436",
    fillOpacity: 0.478
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16h-1v-1h1z",
    fill: "#5c5c5c",
    fillOpacity: 0.043
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16v-1h1v1z",
    fill: "#272727",
    fillOpacity: 0.816
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h1v1h-1z",
    fill: "#313133"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M77 15h1v1h-1z",
    fill: "#131315"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M80 16h-1v-1h1z",
    fill: "#111214"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M85 15h1v1h-1z",
    fill: "#1f1f22"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M86 16v-1h1v1z",
    fill: "#242426",
    fillOpacity: 0.439
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h1v1h-1z",
    fill: "#515151",
    fillOpacity: 0.086
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M71 17h-1v-1h1z",
    fill: "#313131",
    fillOpacity: 0.863
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M72 17h-1v-1h1z",
    fill: "#323232"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16v1h-1v-1z",
    fill: "#575759"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v1h-1v-1z",
    fill: "#5f5f61"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M83 16v1h-1v-1z",
    fill: "#3d3d3f"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17h-1v-1h1z",
    fill: "#222224"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M86 17v-1h1v1z",
    fill: "#28282b",
    fillOpacity: 0.416
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M70 17v1h-1v-1z",
    fill: "#3c3c3c",
    fillOpacity: 0.149
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18v-1h1v1z",
    fill: "#2f2f2f",
    fillOpacity: 0.929
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18h-1v-1h1z",
    fill: "#2d2d30",
    fillOpacity: 0.392
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h1v1h-1z",
    fill: "#373737",
    fillOpacity: 0.345
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18h1v1h-1z",
    fill: "#333335",
    fillOpacity: 0.992
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18v1h-1v-1z",
    fill: "#38393c"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v1h-1v-1z",
    fill: "#1c1c21"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M80 18h1v1h-1z",
    fill: "#1e2125"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M81 19v-1h1v1z",
    fill: "#282b2f"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M83 19h-1v-1h1z",
    fill: "#1f2325"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18h1v1h-1z",
    fill: "#2d2d30",
    fillOpacity: 0.373
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M70 19v1h-1v-1z",
    fill: "#2f3131",
    fillOpacity: 0.733
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h-1v-1h1z",
    fill: "#5b5c61"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20v-1h1v1z",
    fill: "#6a6b6e"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M76 20h-1v-1h1z",
    fill: "#26282a"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M78 20v-1h1v1z",
    fill: "#1c1b21"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M80 19v1h-1v-1z",
    fill: "#1a1b20"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M80 19h1v1h-1z",
    fill: "#25282d"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h-1v-1h1z",
    fill: "#33383c"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20v-1h1v1z",
    fill: "#272c2f"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M84 20h-1v-1h1z",
    fill: "#1b2121"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M85 19v1h-1v-1z",
    fill: "#202425"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M86 19h1v1h-1z",
    fill: "#363639",
    fillOpacity: 0.384
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20h1v1h-1z",
    fill: "#363836",
    fillOpacity: 0.494
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h-1v-1h1z",
    fill: "#2e3030",
    fillOpacity: 0.992
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M71 20h1v1h-1z",
    fill: "#4b4c4f"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h1v1h-1z",
    fill: "#8b8c91"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h1v1h-1z",
    fill: "#98999d"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h-1v-1h1z",
    fill: "#1b1c1f"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20v1h-1v-1z",
    fill: "#1d1d22"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20h1v1h-1z",
    fill: "#25262b"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M81 20v1h-1v-1z",
    fill: "#414449"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v-1h1v1z",
    fill: "#555a5e"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h1v1h-1z",
    fill: "#54595c"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M83 20h1v1h-1z",
    fill: "#2d3232"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21h-1v-1h1z",
    fill: "#242829"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21v-1h1v1z",
    fill: "#2d2d30",
    fillOpacity: 0.749
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M88 21h-1v-1h1z",
    fill: "#444",
    fillOpacity: 0.118
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v1h-1v-1z",
    fill: "#3f3f3f",
    fillOpacity: 0.11
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h1v1z",
    fill: "#353535",
    fillOpacity: 0.576
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M69 21v1h-1v-1z",
    fill: "#2e2e2e",
    fillOpacity: 0.988
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M69 22v-1h1v1z",
    fill: "#303131"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h1v1h-1z",
    fill: "#343538"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M71 21h1v1h-1z",
    fill: "#606165"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21v1h-1v-1z",
    fill: "#929398"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21h1v1h-1z",
    fill: "#949598"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v-1h1v1z",
    fill: "#6c6d6f"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v1h-1v-1z",
    fill: "#606267"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21h1v1h-1z",
    fill: "#72777b"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M82 21h1v1h-1z",
    fill: "#707678"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M84 21v1h-1v-1z",
    fill: "#3f4545"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21v1h-1v-1z",
    fill: "#282b2d"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21h1v1h-1z",
    fill: "#2b2b2d"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h-1v-1h1z",
    fill: "#252525",
    fillOpacity: 0.82
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M89 22h-1v-1h1z",
    fill: "#363636",
    fillOpacity: 0.22
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v1h-1v-1z",
    fill: "#2a2a2a",
    fillOpacity: 0.141
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23v-1h1v1z",
    fill: "#2a2a2a",
    fillOpacity: 0.467
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23h-1v-1h1z",
    fill: "#2c2c2c",
    fillOpacity: 0.859
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M68 22v1h-1v-1z",
    fill: "#2f2f2e"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M69 23h-1v-1h1z",
    fill: "#313231"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M70 22v1h-1v-1z",
    fill: "#303232"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M71 22v1h-1v-1z",
    fill: "#3d3e40"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h-1v-1h1z",
    fill: "#636468"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23v-1h1v1z",
    fill: "#7b7c80"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v1h-1v-1z",
    fill: "#717275"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23h-1v-1h1z",
    fill: "#565759"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M80 22v1h-1v-1z",
    fill: "#3c3c41"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M81 23h-1v-1h1z",
    fill: "#505357"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h-1v-1h1z",
    fill: "#606468"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23v-1h1v1z",
    fill: "#5e6466"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M83 23v-1h1v1z",
    fill: "#3b4040"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v-1h1v1z",
    fill: "#26292a"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h1v1h-1z",
    fill: "#29292a",
    fillOpacity: 0.894
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M90 22v1h-1v-1z",
    fill: "#464649",
    fillOpacity: 0.298
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23v1h-1v-1z",
    fill: "#363636",
    fillOpacity: 0.11
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1z",
    fill: "#292929",
    fillOpacity: 0.337
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v-1h1v1z",
    fill: "#232323",
    fillOpacity: 0.651
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M64 23h1v1h-1z",
    fill: "#222",
    fillOpacity: 0.91
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23v1h-1v-1z",
    fill: "#282828"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h-1v-1h1z",
    fill: "#313132"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v-1h1v1z",
    fill: "#58595b"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h1v1h-1z",
    fill: "#5e5f62"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M79 24v-1h1v1z",
    fill: "#323436"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24h-1v-1h1z",
    fill: "#3b3d3f"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24v-1h1v1z",
    fill: "#414244"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h1v1h-1z",
    fill: "#424446"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24h-1v-1h1z",
    fill: "#313035",
    fillOpacity: 0.933
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v1h-1v-1z",
    fill: "#515158",
    fillOpacity: 0.318
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1z",
    fill: "#2f2f2f",
    fillOpacity: 0.38
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24v1h-1v-1z",
    fill: "#252525",
    fillOpacity: 0.667
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v1h-1v-1z",
    fill: "#232323",
    fillOpacity: 0.89
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#2b2b2b"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24v1h-1v-1z",
    fill: "#26252c"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M91 25h-1v-1h1z",
    fill: "#3b3a41",
    fillOpacity: 0.922
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M92 25h-1v-1h1z",
    fill: "#68686d",
    fillOpacity: 0.22
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25h1v1h-1z",
    fill: "#505050",
    fillOpacity: 0.075
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M56 26h-1v-1h1z",
    fill: "#414141",
    fillOpacity: 0.275
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M57 25v1h-1v-1z",
    fill: "#343434",
    fillOpacity: 0.537
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v-1h1v1z",
    fill: "#2d2d2d",
    fillOpacity: 0.769
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26h-1v-1h1z",
    fill: "#292929",
    fillOpacity: 0.933
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1z",
    fill: "#2a2a2a"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25v1h-1v-1z",
    fill: "#212026"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26v-1h1v1z",
    fill: "#222127"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26v-1h1v1z",
    fill: "#525257",
    fillOpacity: 0.753
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M93 25v1h-1v-1z",
    fill: "#b2b2b2",
    fillOpacity: 0.039
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26v1h-1v-1z",
    fill: "#343434",
    fillOpacity: 0.114
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27h-1v-1h1z",
    fill: "#353535",
    fillOpacity: 0.353
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M54 27h-1v-1h1z",
    fill: "#3c3c3a",
    fillOpacity: 0.631
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M54 26h1v1h-1z",
    fill: "#373737",
    fillOpacity: 0.851
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M55 26h1v1h-1z",
    fill: "#2d2d2d",
    fillOpacity: 0.984
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v1h-1v-1z",
    fill: "#292928"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27h-1v-1h1z",
    fill: "#242324"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26v1h-1v-1z",
    fill: "#272727"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1z",
    fill: "#2a2929"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M68 27h-1v-1h1z",
    fill: "#2e2e2e"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M69 26v1h-1v-1z",
    fill: "#323233"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26h1v1h-1z",
    fill: "#444348",
    fillOpacity: 0.992
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M92 26h1v1h-1z",
    fill: "#736f73",
    fillOpacity: 0.322
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28v-1h1v1z",
    fill: "#2d2d2d",
    fillOpacity: 0.11
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M49 28v-1h1v1z",
    fill: "#323235",
    fillOpacity: 0.357
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M51 27v1h-1v-1z",
    fill: "#38383a",
    fillOpacity: 0.651
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M51 28v-1h1v1z",
    fill: "#383839",
    fillOpacity: 0.886
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27v1h-1v-1z",
    fill: "#363738"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h-1v-1h1z",
    fill: "#222323"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v1h-1v-1z",
    fill: "#242525"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h1v1h-1z",
    fill: "#272827"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1z",
    fill: "#2a2b2a"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v-1h1v1z",
    fill: "#2f2f2f"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M88 28h-1v-1h1z",
    fill: "#343438"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v-1h1v1z",
    fill: "#25252a"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M91 27v1h-1v-1z",
    fill: "#292930"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M92 28v-1h1v1z",
    fill: "#5b5a5e",
    fillOpacity: 0.71
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28v1h-1v-1z",
    fill: "#3f3f3f",
    fillOpacity: 0.267
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M47 29v-1h1v1z",
    fill: "#373739",
    fillOpacity: 0.596
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M49 29h-1v-1h1z",
    fill: "#333335",
    fillOpacity: 0.878
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28h1v1h-1z",
    fill: "#212325"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29h-1v-1h1z",
    fill: "#292b2a"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29v-1h1v1z",
    fill: "#2f312f"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M68 28h1v1h-1z",
    fill: "#313333"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v1h-1v-1z",
    fill: "#393b3e"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29h-1v-1h1z",
    fill: "#28292e"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v1h-1v-1z",
    fill: "#2b2b32"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28h1v1h-1z",
    fill: "#35343c"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M92 29v-1h1v1z",
    fill: "#4c4b51",
    fillOpacity: 0.937
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29v-1h1v1z",
    fill: "#737379",
    fillOpacity: 0.165
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h-1v-1h1z",
    fill: "#8d8d8d",
    fillOpacity: 0.035
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29v1h-1v-1z",
    fill: "#434346",
    fillOpacity: 0.341
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30v-1h1v1z",
    fill: "#3b3b3c",
    fillOpacity: 0.745
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30h-1v-1h1z",
    fill: "#38383a",
    fillOpacity: 0.98
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h1v1z",
    fill: "#262829"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30v-1h1v1z",
    fill: "#282a28"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30v-1h1v1z",
    fill: "#2d2f2e"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M88 30v-1h1v1z",
    fill: "#494a4e"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29v1h-1v-1z",
    fill: "#3d3e43"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M91 30h-1v-1h1z",
    fill: "#2b2c32"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30h-1v-1h1z",
    fill: "#303037"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30v-1h1v1z",
    fill: "#444348"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29h1v1h-1z",
    fill: "#5e5b61",
    fillOpacity: 0.349
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M43 30v1h-1v-1z",
    fill: "#47444b",
    fillOpacity: 0.306
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M43 31v-1h1v1z",
    fill: "#3b3a3f",
    fillOpacity: 0.757
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h1v1h-1z",
    fill: "#363539"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31h-1v-1h1z",
    fill: "#353538"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30v1h-1v-1z",
    fill: "#2d2d2f"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31h-1v-1h1z",
    fill: "#3f4044"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31v-1h1v1z",
    fill: "#5e5f64"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31h-1v-1h1z",
    fill: "#25262d"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31v-1h1v1z",
    fill: "#2e2e36"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M93 30v1h-1v-1z",
    fill: "#403e44"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30v1h-1v-1z",
    fill: "#555559",
    fillOpacity: 0.482
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32h-1v-1h1z",
    fill: "#5d5d5d",
    fillOpacity: 0.149
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32h-1v-1h1z",
    fill: "#3b3b40",
    fillOpacity: 0.651
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M42 31h1v1h-1z",
    fill: "#333238",
    fillOpacity: 0.984
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M44 31v1h-1v-1z",
    fill: "#353439"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h-1v-1h1z",
    fill: "#2b2a2f"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32v-1h1v1z",
    fill: "#2f3131"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31v1h-1v-1z",
    fill: "#4f5052"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M88 32v-1h1v1z",
    fill: "#28292d"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h-1v-1h1z",
    fill: "#626367"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M91 32h-1v-1h1z",
    fill: "#292a30"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31v1h-1v-1z",
    fill: "#2c2c33"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31h1v1h-1z",
    fill: "#3d3b41"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32v-1h1v1z",
    fill: "#4f4f53",
    fillOpacity: 0.541
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M40 33h-1v-1h1z",
    fill: "#616164",
    fillOpacity: 0.329
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32v1h-1v-1z",
    fill: "#444446",
    fillOpacity: 0.875
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32v1h-1v-1z",
    fill: "#333336"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v1h-1v-1z",
    fill: "#2e3031"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33v-1h1v1z",
    fill: "#535456"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32h1v1h-1z",
    fill: "#504f54",
    fillOpacity: 0.58
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1z",
    fill: "#555557",
    fillOpacity: 0.412
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M39 33h1v1h-1z",
    fill: "#3e3f41",
    fillOpacity: 0.961
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M71 34h-1v-1h1z",
    fill: "#5c5d5f"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h-1v-1h1z",
    fill: "#3d3b42"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h1v1h-1z",
    fill: "#514f56",
    fillOpacity: 0.616
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35h-1v-1h1z",
    fill: "#4e4e51",
    fillOpacity: 0.42
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34v1h-1v-1z",
    fill: "#3c3d3f",
    fillOpacity: 0.976
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35h-1v-1h1z",
    fill: "#5a5b5d"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h1v1h-1z",
    fill: "#56565b",
    fillOpacity: 0.659
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M37 36h-1v-1h1z",
    fill: "#59595c",
    fillOpacity: 0.302
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35v1h-1v-1z",
    fill: "#414244",
    fillOpacity: 0.961
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35v1h-1v-1z",
    fill: "#555658"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35h1v1h-1z",
    fill: "#4d4e50"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v1h-1v-1z",
    fill: "#373739"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36h-1v-1h1z",
    fill: "#5b5b5f",
    fillOpacity: 0.678
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37h-1v-1h1z",
    fill: "#6e6e6e",
    fillOpacity: 0.118
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37h-1v-1h1z",
    fill: "#4b4b4c",
    fillOpacity: 0.847
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37v-1h1v1z",
    fill: "#505153"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M41 37v-1h1v1z",
    fill: "#7f8081"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37h-1v-1h1z",
    fill: "#606162"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M43 36h1v1h-1z",
    fill: "#424344"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h1v1h-1z",
    fill: "#3e4041"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36v1h-1v-1z",
    fill: "#3a3b3c"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37h-1v-1h1z",
    fill: "#2a2c2d"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1z",
    fill: "#1d1f1f"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v-1h1v1z",
    fill: "#303233"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37h-1v-1h1z",
    fill: "#1f2122"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37h-1v-1h1z",
    fill: "#2c2c2f"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M93 37v-1h1v1z",
    fill: "#5b5b5f",
    fillOpacity: 0.698
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37h1v1h-1z",
    fill: "#575757",
    fillOpacity: 0.549
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M39 38v-1h1v1z",
    fill: "#737476"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M41 38h-1v-1h1z",
    fill: "#959698"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38h-1v-1h1z",
    fill: "#454746"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38v-1h1v1z",
    fill: "#333533"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38v-1h1v1z",
    fill: "#2b2d2c"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37h1v1h-1z",
    fill: "#262828"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h-1v-1h1z",
    fill: "#5a5a5d",
    fillOpacity: 0.718
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M34 38h1v1h-1z",
    fill: "#696969",
    fillOpacity: 0.114
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38v1h-1v-1z",
    fill: "#4d4d4d",
    fillOpacity: 0.898
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v1h-1v-1z",
    fill: "#39393a"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38h1v1h-1z",
    fill: "#808183"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39h-1v-1h1z",
    fill: "#a0a1a3"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M42 39h-1v-1h1z",
    fill: "#1f2020"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M72 39v-1h1v1z",
    fill: "#464749"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M73 38h1v1h-1z",
    fill: "#171919"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M92 38h1v1h-1z",
    fill: "#3b3a3f"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h1v1h-1z",
    fill: "#5a5a5c",
    fillOpacity: 0.733
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v-1h1v1z",
    fill: "#5f5f5f",
    fillOpacity: 0.345
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39v1h-1v-1z",
    fill: "#464646"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M39 40h-1v-1h1z",
    fill: "#a4a5a7"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39h1v1h-1z",
    fill: "#1c1d1d"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h1v1h-1z",
    fill: "#171818"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40h-1v-1h1z",
    fill: "#333534"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v-1h1v1z",
    fill: "#3a383e"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M93 40v-1h1v1z",
    fill: "#5b595d",
    fillOpacity: 0.757
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v-1h1v1z",
    fill: "#5c5c5c",
    fillOpacity: 0.541
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h-1v-1h1z",
    fill: "#3d3e3e"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M38 41h-1v-1h1z",
    fill: "#8e8f91"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40v1h-1v-1z",
    fill: "#202121"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M94 40v1h-1v-1z",
    fill: "#58585c",
    fillOpacity: 0.769
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.027
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M35 41v1h-1v-1z",
    fill: "#5a5a5b",
    fillOpacity: 0.667
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42h-1v-1h1z",
    fill: "#414143"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41h1v1h-1z",
    fill: "#49494a"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h1v1h-1z",
    fill: "#4c4d4d"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42h-1v-1h1z",
    fill: "#1b1d1e"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M93 41h1v1h-1z",
    fill: "#565559",
    fillOpacity: 0.784
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.031
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42h1v1h-1z",
    fill: "#585859",
    fillOpacity: 0.749
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42v1h-1v-1z",
    fill: "#36353a"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M93 43v-1h1v1z",
    fill: "#565558",
    fillOpacity: 0.788
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44v-1h1v1z",
    fill: "#bfbfbf",
    fillOpacity: 0.031
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43v1h-1v-1z",
    fill: "#575758",
    fillOpacity: 0.78
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v-1h1v1z",
    fill: "#1d1f20"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M91 44v-1h1v1z",
    fill: "#302f34"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M92 43h1v1h-1z",
    fill: "#353339"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M94 43v1h-1v-1z",
    fill: "#545456",
    fillOpacity: 0.796
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M34 44v1h-1v-1z",
    fill: "#b2b299",
    fillOpacity: 0.039
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v-1h1v1z",
    fill: "#525253",
    fillOpacity: 0.804
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M93 45h-1v-1h1z",
    fill: "#343338"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M94 45h-1v-1h1z",
    fill: "#515053",
    fillOpacity: 0.8
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v1h-1v-1z",
    fill: "#a2a2a2",
    fillOpacity: 0.043
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h1v1h-1z",
    fill: "#4e4e4f",
    fillOpacity: 0.82
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46v-1h1v1z",
    fill: "#333237"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M93 46v-1h1v1z",
    fill: "#4d4d50",
    fillOpacity: 0.808
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47h-1v-1h1z",
    fill: "#666",
    fillOpacity: 0.059
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47h-1v-1h1z",
    fill: "#454546",
    fillOpacity: 0.847
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v-1h1v1z",
    fill: "#181b19"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47v-1h1v1z",
    fill: "#1c1d1c"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M91 46h1v1h-1z",
    fill: "#323336"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M94 46v1h-1v-1z",
    fill: "#4b4b50",
    fillOpacity: 0.82
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47v1h-1v-1z",
    fill: "#555",
    fillOpacity: 0.071
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48h-1v-1h1z",
    fill: "#3d3d3f",
    fillOpacity: 0.867
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h1v1h-1z",
    fill: "#333337"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M94 47v1h-1v-1z",
    fill: "#4a484d",
    fillOpacity: 0.824
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49v-1h1v1z",
    fill: "#868686",
    fillOpacity: 0.075
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48h1v1h-1z",
    fill: "#434346",
    fillOpacity: 0.871
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h1v1h-1z",
    fill: "#181918"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v1h-1v-1z",
    fill: "#46454a",
    fillOpacity: 0.835
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50v-1h1v1z",
    fill: "#454546",
    fillOpacity: 0.882
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1z",
    fill: "#1f1f1e"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50v-1h1v1z",
    fill: "#1e1f1f"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50h-1v-1h1z",
    fill: "#434247",
    fillOpacity: 0.839
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50h1v1h-1z",
    fill: "#444446",
    fillOpacity: 0.894
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1z",
    fill: "#141816"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50v1h-1v-1z",
    fill: "#151817"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h1v1h-1z",
    fill: "#19191c"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50v1h-1v-1z",
    fill: "#191a19"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50v1h-1v-1z",
    fill: "#1a1b17"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51h-1v-1h1z",
    fill: "#1a1d19"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M59 51h-1v-1h1z",
    fill: "#191e19"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50h1v1h-1z",
    fill: "#1b1e1b"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51h-1v-1h1z",
    fill: "#1d1d1e"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h1v1h-1z",
    fill: "#1e1f1b"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M65 50h1v1h-1z",
    fill: "#201f21"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M71 51h-1v-1h1z",
    fill: "#1f201e"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50h1v1h-1z",
    fill: "#1c1f20"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1z",
    fill: "#1d1e1e"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1z",
    fill: "#1e1f1e"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51v-1h1v1z",
    fill: "#1c1e1e"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h-1v-1h1z",
    fill: "#1b1e1d"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50h1v1h-1z",
    fill: "#1a1e1d"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1z",
    fill: "#1a1f1f"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-1h1v1z",
    fill: "#191e1f"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51v-1h1v1z",
    fill: "#191c1e"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51h-1v-1h1z",
    fill: "#aab",
    fillOpacity: 0.059
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52h-1v-1h1z",
    fill: "#7b7b83",
    fillOpacity: 0.122
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h-1v-1h1z",
    fill: "#464647",
    fillOpacity: 0.91
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52h-1v-1h1z",
    fill: "#131916"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52v-1h1v1z",
    fill: "#141a17"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M44 51v1h-1v-1z",
    fill: "#161917"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52v-1h1v1z",
    fill: "#191818"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51v1h-1v-1z",
    fill: "#171917"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52v-1h1v1z",
    fill: "#181516"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h1v1h-1z",
    fill: "#19191a"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h-1v-1h1z",
    fill: "#151a1d"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51h1v1h-1z",
    fill: "#151a1c"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52v-1h1v1z",
    fill: "#141b1d"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M60 51v1h-1v-1z",
    fill: "#191a1f"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v-1h1v1z",
    fill: "#1e1a21"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52h-1v-1h1z",
    fill: "#1e1a1f"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51v1h-1v-1z",
    fill: "#1f1b1d"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51h1v1h-1z",
    fill: "#1f1c1b"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51h1v1h-1z",
    fill: "#1b201e"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M68 52v-1h1v1z",
    fill: "#1a201c"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51h1v1h-1z",
    fill: "#1e201a"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h-1v-1h1z",
    fill: "#1e1d21"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1z",
    fill: "#1e1c1e"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M75 52h-1v-1h1z",
    fill: "#1e1e1d"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M76 51h1v1h-1z",
    fill: "#191e1b"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h1v1h-1z",
    fill: "#181e1c"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51h1v1h-1z",
    fill: "#1a1e1f"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51h1v1h-1z",
    fill: "#1a1d1f"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51v1h-1v-1z",
    fill: "#bbb",
    fillOpacity: 0.059
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52v1h-1v-1z",
    fill: "#7f7f86",
    fillOpacity: 0.141
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1z",
    fill: "#464648",
    fillOpacity: 0.925
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h-1v-1h1z",
    fill: "#151a17"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53v-1h1v1z",
    fill: "#1c211c"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52h1v1h-1z",
    fill: "#232522"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52h1v1h-1z",
    fill: "#272624"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52v1h-1v-1z",
    fill: "#292725"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53v-1h1v1z",
    fill: "#2d2b27"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52v1h-1v-1z",
    fill: "#312d29"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h1v1h-1z",
    fill: "#39312c"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h1v1h-1z",
    fill: "#382c28"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52h1v1h-1z",
    fill: "#362927"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52v1h-1v-1z",
    fill: "#332623"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52h1v1h-1z",
    fill: "#352925"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M55 52v1h-1v-1z",
    fill: "#372b27"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M55 53v-1h1v1z",
    fill: "#352a28"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h1v1h-1z",
    fill: "#372826"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52h1v1h-1z",
    fill: "#362524"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v1h-1v-1z",
    fill: "#332724"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M61 53h-1v-1h1z",
    fill: "#302a23"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52h1v1h-1z",
    fill: "#312a23"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52h1v1h-1z",
    fill: "#2e2722"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M70 52v1h-1v-1z",
    fill: "#2a2721"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v-1h1v1z",
    fill: "#2a2622"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h-1v-1h1z",
    fill: "#2c2324"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M72 52h1v1h-1z",
    fill: "#2c2025"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1z",
    fill: "#292222"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53v-1h1v1z",
    fill: "#272422"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M75 53v-1h1v1z",
    fill: "#242320"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1z",
    fill: "#212420"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M77 52h1v1h-1z",
    fill: "#202320"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h-1v-1h1z",
    fill: "#232222"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1z",
    fill: "#232223"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53v-1h1v1z",
    fill: "#252325"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M83 52h1v1h-1z",
    fill: "#201f22"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52v1h-1v-1z",
    fill: "#424045",
    fillOpacity: 0.847
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h-1v-1h1z",
    fill: "#aaa",
    fillOpacity: 0.059
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h-1v-1h1z",
    fill: "#444446",
    fillOpacity: 0.933
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h1v1h-1z",
    fill: "#3a3b37"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h1v1h-1z",
    fill: "#363531"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M44 53v1h-1v-1z",
    fill: "#322f2b"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M45 53v1h-1v-1z",
    fill: "#2f2825"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54h-1v-1h1z",
    fill: "#322927"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53v1h-1v-1z",
    fill: "#352724"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h-1v-1h1z",
    fill: "#3c2926"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M49 54h-1v-1h1z",
    fill: "#422924"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M50 53v1h-1v-1z",
    fill: "#472922"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M51 53v1h-1v-1z",
    fill: "#4f2a25"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M51 54v-1h1v1z",
    fill: "#5b342e"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h-1v-1h1z",
    fill: "#6d473c"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54h-1v-1h1z",
    fill: "#7c5648"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54v-1h1v1z",
    fill: "#845d4c"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54h-1v-1h1z",
    fill: "#8b5a46"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53v1h-1v-1z",
    fill: "#8e5e48"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54h-1v-1h1z",
    fill: "#93664f"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M58 53h1v1h-1z",
    fill: "#956a52"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M59 53h1v1h-1z",
    fill: "#9d735d"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M60 53h1v1h-1z",
    fill: "#9e7361"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53v1h-1v-1z",
    fill: "#9d7261"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M62 54v-1h1v1z",
    fill: "#9b6f60"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53v1h-1v-1z",
    fill: "#976c5e"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54h-1v-1h1z",
    fill: "#8c665d"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M65 53h1v1h-1z",
    fill: "#85625b"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v1h-1v-1z",
    fill: "#7d5952"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53h1v1h-1z",
    fill: "#7c5750"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M69 53v1h-1v-1z",
    fill: "#75534c"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v1h-1v-1z",
    fill: "#684f48"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M71 54h-1v-1h1z",
    fill: "#654d49"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54h-1v-1h1z",
    fill: "#614b49"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h1v1h-1z",
    fill: "#5d4747"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M73 53h1v1h-1z",
    fill: "#564646"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53h1v1h-1z",
    fill: "#514544"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v1h-1v-1z",
    fill: "#4d4342"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53h1v1h-1z",
    fill: "#4a4341"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M78 53v1h-1v-1z",
    fill: "#45403d"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M80 54h-1v-1h1z",
    fill: "#403a3a"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53v1h-1v-1z",
    fill: "#40393b"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54v-1h1v1z",
    fill: "#3e363b"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53v1h-1v-1z",
    fill: "#2e2a2e"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54h-1v-1h1z",
    fill: "#424046",
    fillOpacity: 0.847
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54h1v1h-1z",
    fill: "#797979",
    fillOpacity: 0.165
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1z",
    fill: "#3f3f41",
    fillOpacity: 0.941
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54h1v1h-1z",
    fill: "#1c1e1c"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54h1v1h-1z",
    fill: "#2d2d2c"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54v1h-1v-1z",
    fill: "#1d1916"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M42 55v-1h1v1z",
    fill: "#1f1714"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M44 54v1h-1v-1z",
    fill: "#231917"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55v-1h1v1z",
    fill: "#291d1b"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54v1h-1v-1z",
    fill: "#2f1f1e"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55h-1v-1h1z",
    fill: "#3a201f"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54h1v1h-1z",
    fill: "#3e1e1a"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h1v1h-1z",
    fill: "#49201b"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M49 55v-1h1v1z",
    fill: "#582921"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M50 54h1v1h-1z",
    fill: "#632b22"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M52 55h-1v-1h1z",
    fill: "#703226"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54v1h-1v-1z",
    fill: "#7d3f30"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h1v1h-1z",
    fill: "#874a34"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M55 54v1h-1v-1z",
    fill: "#8c4f36"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54v1h-1v-1z",
    fill: "#98553d"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55v-1h1v1z",
    fill: "#9b5f44"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54v1h-1v-1z",
    fill: "#9f7051"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55v-1h1v1z",
    fill: "#ab8466"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54v1h-1v-1z",
    fill: "#91745b"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54h1v1h-1z",
    fill: "#79634f"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55h-1v-1h1z",
    fill: "#735d4c"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54v1h-1v-1z",
    fill: "#715b4d"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54h1v1h-1z",
    fill: "#755d52"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54v1h-1v-1z",
    fill: "#8b6558"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h-1v-1h1z",
    fill: "#986b5d"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55h-1v-1h1z",
    fill: "#946556"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M68 54v1h-1v-1z",
    fill: "#8d5b4c"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M69 55h-1v-1h1z",
    fill: "#895649"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55h-1v-1h1z",
    fill: "#7f4e47"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55v-1h1v1z",
    fill: "#744b44"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54v1h-1v-1z",
    fill: "#6a4942"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M73 54v1h-1v-1z",
    fill: "#61453f"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M73 55v-1h1v1z",
    fill: "#59413f"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54v1h-1v-1z",
    fill: "#543e3f"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v1h-1z",
    fill: "#4e3b3b"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M76 54h1v1h-1z",
    fill: "#473737"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v1h-1v-1z",
    fill: "#403332"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54h1v1h-1z",
    fill: "#392f30"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h-1v-1h1z",
    fill: "#382e2f"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55v-1h1v1z",
    fill: "#342a2b"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#2e2525"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54h1v1h-1z",
    fill: "#2a1e22"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54h1v1h-1z",
    fill: "#291e24"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v1h-1v-1z",
    fill: "#2d272b"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54h1v1h-1z",
    fill: "#212023"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54v1h-1v-1z",
    fill: "#3f3e42",
    fillOpacity: 0.851
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1z",
    fill: "#767676",
    fillOpacity: 0.169
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56h-1v-1h1z",
    fill: "#3e3e40",
    fillOpacity: 0.945
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M37 56h-1v-1h1z",
    fill: "#222426"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55v1h-1v-1z",
    fill: "#171c1b"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M38 56v-1h1v1z",
    fill: "#141913"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h1v1z",
    fill: "#211b1c"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55h1v1h-1z",
    fill: "#251c1c"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56h-1v-1h1z",
    fill: "#261b1b"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M43 55h1v1h-1z",
    fill: "#261a19"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55h1v1h-1z",
    fill: "#271b17"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56v-1h1v1z",
    fill: "#2e1f18"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h-1v-1h1z",
    fill: "#391f16"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55v1h-1v-1z",
    fill: "#442419"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55h1v1h-1z",
    fill: "#53281c"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56h-1v-1h1z",
    fill: "#623023"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M51 55v1h-1v-1z",
    fill: "#6c3525"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v-1h1v1z",
    fill: "#783a29"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55v1h-1v-1z",
    fill: "#884331"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55h1v1h-1z",
    fill: "#955137"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M55 56h-1v-1h1z",
    fill: "#9d5c3d"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M55 55h1v1h-1z",
    fill: "#a76043"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55h1v1h-1z",
    fill: "#b2805d"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56v-1h1v1z",
    fill: "#9d8665"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55h1v1h-1z",
    fill: "#645647"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M60 56h-1v-1h1z",
    fill: "#4f4746"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M61 55v1h-1v-1z",
    fill: "#4b4b4e"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55v1h-1v-1z",
    fill: "#494a4d"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M63 55v1h-1v-1z",
    fill: "#494c4e"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M64 55v1h-1v-1z",
    fill: "#4b4f51"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56h-1v-1h1z",
    fill: "#56514a"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55h1v1h-1z",
    fill: "#68574a"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55v1h-1v-1z",
    fill: "#91705e"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56v-1h1v1z",
    fill: "#9c6954"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M68 55h1v1h-1z",
    fill: "#955b47"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56v-1h1v1z",
    fill: "#8b5848"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M71 56h-1v-1h1z",
    fill: "#805446"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h-1v-1h1z",
    fill: "#704940"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56v-1h1v1z",
    fill: "#6a4540"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M74 55v1h-1v-1z",
    fill: "#634240"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M74 56v-1h1v1z",
    fill: "#5a3d3d"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M76 55v1h-1v-1z",
    fill: "#513b3b"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56v-1h1v1z",
    fill: "#463635"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56v-1h1v1z",
    fill: "#372b2d"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h1v1h-1z",
    fill: "#35292b"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M82 55v1h-1v-1z",
    fill: "#312527"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56h-1v-1h1z",
    fill: "#2d2123"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M85 55v1h-1v-1z",
    fill: "#221b1d"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55v1h-1v-1z",
    fill: "#211f22"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h1v1h-1z",
    fill: "#303033"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M92 55h1v1h-1z",
    fill: "#2e2c32"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M93 55h1v1h-1z",
    fill: "#3f3d42",
    fillOpacity: 0.855
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56h1v1h-1z",
    fill: "#686868",
    fillOpacity: 0.173
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v-1h1v1z",
    fill: "#3c3c3e",
    fillOpacity: 0.945
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M38 57h-1v-1h1z",
    fill: "#191c18"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56v1h-1v-1z",
    fill: "#111915"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57v-1h1v1z",
    fill: "#141b1a"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h1v1h-1z",
    fill: "#202023"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57h-1v-1h1z",
    fill: "#231a1d"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57v-1h1v1z",
    fill: "#251819"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57h-1v-1h1z",
    fill: "#2a1516"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57v-1h1v1z",
    fill: "#301516"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56h1v1h-1z",
    fill: "#391c19"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M46 56h1v1h-1z",
    fill: "#41231a"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h1v1h-1z",
    fill: "#4a261b"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56v1h-1v-1z",
    fill: "#5b2d21"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57v-1h1v1z",
    fill: "#6a3326"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v1h-1v-1z",
    fill: "#763b29"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M52 57h-1v-1h1z",
    fill: "#824129"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h-1v-1h1z",
    fill: "#964f31"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56v1h-1v-1z",
    fill: "#a05b35"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h-1v-1h1z",
    fill: "#a8683e"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56v1h-1v-1z",
    fill: "#b8825c"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M56 57v-1h1v1z",
    fill: "#a4836a"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M58 56v1h-1v-1z",
    fill: "#4a3e34"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57v-1h1v1z",
    fill: "#463f3f"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h-1v-1h1z",
    fill: "#454144"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57h-1v-1h1z",
    fill: "#434247"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57v-1h1v1z",
    fill: "#444448"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M63 57h-1v-1h1z",
    fill: "#424548"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M63 56h1v1h-1z",
    fill: "#404547"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56v1h-1v-1z",
    fill: "#474847"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M66 56v1h-1v-1z",
    fill: "#4d504a"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v-1h1v1z",
    fill: "#5b5348"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56h1v1h-1z",
    fill: "#926b5f"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M68 56h1v1h-1z",
    fill: "#a16759"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56h1v1h-1z",
    fill: "#915e4a"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57h-1v-1h1z",
    fill: "#845746"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57v-1h1v1z",
    fill: "#764d42"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h1v1h-1z",
    fill: "#6f4841"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57h-1v-1h1z",
    fill: "#65423f"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57h-1v-1h1z",
    fill: "#5c3e3c"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57h-1v-1h1z",
    fill: "#513937"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56h1v1h-1z",
    fill: "#483736"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M81 57h-1v-1h1z",
    fill: "#382c2e"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1z",
    fill: "#322628"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56v1h-1v-1z",
    fill: "#2c2022"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h-1v-1h1z",
    fill: "#231c1e"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57v-1h1v1z",
    fill: "#211f21"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M93 56h1v1h-1z",
    fill: "#3c3b41",
    fillOpacity: 0.855
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v1h-1v-1z",
    fill: "#5a5a5a",
    fillOpacity: 0.176
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58h-1v-1h1z",
    fill: "#363638",
    fillOpacity: 0.949
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57h1v1h-1z",
    fill: "#262323"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M38 58h-1v-1h1z",
    fill: "#1c1c18"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h-1v-1h1z",
    fill: "#111b19"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57h1v1h-1z",
    fill: "#141b19"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57h1v1h-1z",
    fill: "#171310"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M41 57h1v1h-1z",
    fill: "#18100e"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M43 58h-1v-1h1z",
    fill: "#1c110f"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58h-1v-1h1z",
    fill: "#24100f"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v-1h1v1z",
    fill: "#2d1110"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v-1h1v1z",
    fill: "#381613"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58h-1v-1h1z",
    fill: "#411911"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v-1h1v1z",
    fill: "#52241b"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57h1v1h-1z",
    fill: "#612c20"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57h1v1h-1z",
    fill: "#6f3327"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M50 57h1v1h-1z",
    fill: "#80412d"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h-1v-1h1z",
    fill: "#8e4c2c"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58v-1h1v1z",
    fill: "#9d5930"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h1v1h-1z",
    fill: "#a9673b"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h-1v-1h1z",
    fill: "#b1794f"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h1v1h-1z",
    fill: "#b69773"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h-1v-1h1z",
    fill: "#48392d"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58h-1v-1h1z",
    fill: "#37353c"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57h1v1h-1z",
    fill: "#3d3d44"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M59 58v-1h1v1z",
    fill: "#444345"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h1v1h-1z",
    fill: "#444445"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M62 58h-1v-1h1z",
    fill: "#434445"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58h-1v-1h1z",
    fill: "#444647"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v-1h1v1z",
    fill: "#434748"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M65 57v1h-1v-1z",
    fill: "#45474b"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-1v-1z",
    fill: "#3e4a4c"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58h-1v-1h1z",
    fill: "#434b49"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v-1h1v1z",
    fill: "#66504c"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58h-1v-1h1z",
    fill: "#9b6c60"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58v-1h1v1z",
    fill: "#9b664e"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58v-1h1v1z",
    fill: "#8c5a46"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M72 58h-1v-1h1z",
    fill: "#7f5142"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M72 57h1v1h-1z",
    fill: "#74493e"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57v1h-1v-1z",
    fill: "#67423d"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57v1h-1v-1z",
    fill: "#5d3e3b"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M75 58v-1h1v1z",
    fill: "#523936"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v-1h1v1z",
    fill: "#493634"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M77 58v-1h1v1z",
    fill: "#433433"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57h1v1h-1z",
    fill: "#3f3335"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M79 58v-1h1v1z",
    fill: "#3c3032"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v1z",
    fill: "#34282a"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58h-1v-1h1z",
    fill: "#2b1f21"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57h1v1h-1z",
    fill: "#251a1c"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v1h-1v-1z",
    fill: "#2d2e31"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M94 57v1h-1v-1z",
    fill: "#3d3c40",
    fillOpacity: 0.867
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M95 58h-1v-1h1z",
    fill: "#9b9b9b",
    fillOpacity: 0.071
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59h-1v-1h1z",
    fill: "#636369",
    fillOpacity: 0.18
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59h-1v-1h1z",
    fill: "#3c3c3e",
    fillOpacity: 0.953
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58h1v1h-1z",
    fill: "#272324"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M38 59v-1h1v1z",
    fill: "#131919"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h1v1h-1z",
    fill: "#24221b"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h-1v-1h1z",
    fill: "#655041"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M42 59h-1v-1h1z",
    fill: "#6b4e39"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h1v1h-1z",
    fill: "#6f5039"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v1h-1v-1z",
    fill: "#745139"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#765036"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58h1v1h-1z",
    fill: "#784f32"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v1h-1v-1z",
    fill: "#7d4e2e"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M47 59v-1h1v1z",
    fill: "#804f2e"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58v1h-1v-1z",
    fill: "#85502a"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58h1v1h-1z",
    fill: "#8e552d"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M51 58v1h-1v-1z",
    fill: "#935c2a"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M51 59v-1h1v1z",
    fill: "#9c6527"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h1v1h-1z",
    fill: "#a66d2a"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58h1v1h-1z",
    fill: "#ad783e"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58v1h-1v-1z",
    fill: "#c4976c"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h1v1h-1z",
    fill: "#7c6a57"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M57 59h-1v-1h1z",
    fill: "#3d3b34"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h1v1h-1z",
    fill: "#474d4f"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59h-1v-1h1z",
    fill: "#383c3c"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59v-1h1v1z",
    fill: "#424241"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v-1h1v1z",
    fill: "#434544"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v1h-1v-1z",
    fill: "#454847"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M64 58v1h-1v-1z",
    fill: "#414645"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58h1v1h-1z",
    fill: "#42444c"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v1h-1v-1z",
    fill: "#40434b"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59h-1v-1h1z",
    fill: "#49433f"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59v-1h1v1z",
    fill: "#79604b"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M69 59v-1h1v1z",
    fill: "#a06a4e"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58h1v1h-1z",
    fill: "#905b44"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h-1v-1h1z",
    fill: "#855342"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h-1v-1h1z",
    fill: "#77493b"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M74 59h-1v-1h1z",
    fill: "#69423c"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M74 58h1v1h-1z",
    fill: "#5d3c38"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v1h-1v-1z",
    fill: "#533834"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M76 59v-1h1v1z",
    fill: "#493431"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59h-1v-1h1z",
    fill: "#423230"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v-1h1v1z",
    fill: "#3e3234"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h-1v-1h1z",
    fill: "#3b2f32"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58h1v1h-1z",
    fill: "#332729"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58v1h-1v-1z",
    fill: "#291d1f"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v-1h1v1z",
    fill: "#25191b"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M93 59v-1h1v1z",
    fill: "#3b3a3f",
    fillOpacity: 0.871
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59v1h-1v-1z",
    fill: "#5f5f64",
    fillOpacity: 0.188
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59v1h-1v-1z",
    fill: "#3e3e40",
    fillOpacity: 0.957
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h1v1h-1z",
    fill: "#272326"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M39 60h-1v-1h1z",
    fill: "#131818"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M39 59h1v1h-1z",
    fill: "#292219"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M40 59h1v1h-1z",
    fill: "#8e6051"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h1v1h-1z",
    fill: "#985540"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60v-1h1v1z",
    fill: "#9a563d"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60v-1h1v1z",
    fill: "#9b583d"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h-1v-1h1z",
    fill: "#a05c41"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1z",
    fill: "#a46144"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h1v1h-1z",
    fill: "#a86a48"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h-1v-1h1z",
    fill: "#af714e"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-1h1z",
    fill: "#b2754e"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60v-1h1v1z",
    fill: "#b87a51"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M50 59h1v1h-1z",
    fill: "#ba8051"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M52 60h-1v-1h1z",
    fill: "#be884f"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M52 59h1v1h-1z",
    fill: "#cb9456"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M54 59v1h-1v-1z",
    fill: "#d09d64"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M54 60v-1h1v1z",
    fill: "#d1b182"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M55 59h1v1h-1z",
    fill: "#70685e"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60v-1h1v1z",
    fill: "#7a7d77"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59v1h-1v-1z",
    fill: "#818482"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59h1v1h-1z",
    fill: "#515350"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60h-1v-1h1z",
    fill: "#404340"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v1h-1v-1z",
    fill: "#414142"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M62 60h-1v-1h1z",
    fill: "#494a4b"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60h-1v-1h1z",
    fill: "#414243"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M64 59v1h-1v-1z",
    fill: "#666969"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v-1h1v1z",
    fill: "#818381"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M65 60v-1h1v1z",
    fill: "#46474b"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60h-1v-1h1z",
    fill: "#59585d"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h-1v-1h1z",
    fill: "#4b4a46"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60v-1h1v1z",
    fill: "#655142"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60h-1v-1h1z",
    fill: "#a87158"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v-1h1v1z",
    fill: "#9b6348"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59v1h-1v-1z",
    fill: "#8c5947"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h1v1h-1z",
    fill: "#784f40"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h1v1h-1z",
    fill: "#6a4638"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60h-1v-1h1z",
    fill: "#5e3d33"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60v-1h1v1z",
    fill: "#573a36"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M77 59v1h-1v-1z",
    fill: "#4d3635"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v1h-1v-1z",
    fill: "#453433"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60h-1v-1h1z",
    fill: "#3c2e30"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59v1h-1v-1z",
    fill: "#392c2d"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h1v1h-1z",
    fill: "#372b2c"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v-1h1v1z",
    fill: "#2f2324"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v1h-1v-1z",
    fill: "#271c1e"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59h1v1h-1z",
    fill: "#251b1c"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M85 59v1h-1v-1z",
    fill: "#241e1f"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M85 60v-1h1v1z",
    fill: "#221f21"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60h-1v-1h1z",
    fill: "#1c1b1d"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h-1v-1h1z",
    fill: "#39393e",
    fillOpacity: 0.871
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M95 60h-1v-1h1z",
    fill: "#8c8c8c",
    fillOpacity: 0.078
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61v-1h1v1z",
    fill: "#626268",
    fillOpacity: 0.192
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61h-1v-1h1z",
    fill: "#404042",
    fillOpacity: 0.961
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60h1v1h-1z",
    fill: "#252426"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60v1h-1v-1z",
    fill: "#1d1b1e"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h-1v-1h1z",
    fill: "#131a18"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61h-1v-1h1z",
    fill: "#231b13"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61v-1h1v1z",
    fill: "#6e282a"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M41 60h1v1h-1z",
    fill: "#802027"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M43 61h-1v-1h1z",
    fill: "#7c1f25"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61h-1v-1h1z",
    fill: "#791d22"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h1v1h-1z",
    fill: "#751e1d"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M48 61h-1v-1h1z",
    fill: "#741f1e"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h1v1h-1z",
    fill: "#711e1c"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1z",
    fill: "#6f1e1b"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61v-1h1v1z",
    fill: "#6f1c1b"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M52 61h-1v-1h1z",
    fill: "#6e221b"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M53 61h-1v-1h1z",
    fill: "#76291a"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61h-1v-1h1z",
    fill: "#7b331e"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M55 60v1h-1v-1z",
    fill: "#90674a"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M55 61v-1h1v1z",
    fill: "#6b655a"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60h1v1h-1z",
    fill: "#6d726f"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h-1v-1h1z",
    fill: "#514d51"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M58 60h1v1h-1z",
    fill: "#797777"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M59 60h1v1h-1z",
    fill: "#8d9490"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61h-1v-1h1z",
    fill: "#8f8f91"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M61 60h1v1h-1z",
    fill: "#9a9a9c"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61v-1h1v1z",
    fill: "#7f7e81"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v1h-1v-1z",
    fill: "#99999b"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61v-1h1v1z",
    fill: "#969794"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M66 61h-1v-1h1z",
    fill: "#868b87"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60v1h-1v-1z",
    fill: "#9a9e9b"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M67 61v-1h1v1z",
    fill: "#8e8b89"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h1v1h-1z",
    fill: "#614b47"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v1h-1v-1z",
    fill: "#a6715b"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61h-1v-1h1z",
    fill: "#a16547"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M71 60h1v1h-1z",
    fill: "#915649"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M72 60h1v1h-1z",
    fill: "#7b4e46"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M74 60v1h-1v-1z",
    fill: "#6a4636"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M75 61h-1v-1h1z",
    fill: "#5e3e32"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60v1h-1v-1z",
    fill: "#563a37"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61v-1h1v1z",
    fill: "#4d3638"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h-1v-1h1z",
    fill: "#473435"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60v1h-1v-1z",
    fill: "#403031"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60v1h-1v-1z",
    fill: "#3b2d2d"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v-1h1v1z",
    fill: "#291f1e"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M83 61h-1v-1h1z",
    fill: "#271d1e"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M83 60h1v1h-1z",
    fill: "#251d1e"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M84 61v-1h1v1z",
    fill: "#252021"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h-1v-1h1z",
    fill: "#221e21"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M86 60h1v1h-1z",
    fill: "#1c1a1d"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61v-1h1v1z",
    fill: "#38373d",
    fillOpacity: 0.878
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61h1v1h-1z",
    fill: "#666",
    fillOpacity: 0.196
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M37 62v-1h1v1z",
    fill: "#181e1e"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61h1v1h-1z",
    fill: "#121a17"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h1v1h-1z",
    fill: "#2a1b16"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M41 61v1h-1v-1z",
    fill: "#843338"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M42 61v1h-1v-1z",
    fill: "#962933"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M42 62v-1h1v1z",
    fill: "#932832"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M44 61h1v1h-1z",
    fill: "#922831"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M47 62h-1v-1h1z",
    fill: "#90262f"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1z",
    fill: "#8e272f"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62h-1v-1h1z",
    fill: "#8d272f"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62v-1h1v1z",
    fill: "#8c272f"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61h1v1h-1z",
    fill: "#8b2631"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1z",
    fill: "#882a33"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1z",
    fill: "#8b2d31"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61v1h-1v-1z",
    fill: "#8d3132"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M54 62v-1h1v1z",
    fill: "#a0655d"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h-1v-1h1z",
    fill: "#483832"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62v-1h1v1z",
    fill: "#545754"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M57 61h1v1h-1z",
    fill: "#9f9da0"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-1z",
    fill: "#a5a3a3"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h-1v-1h1z",
    fill: "#a4a9a5"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v1h-1v-1z",
    fill: "#bebdbf"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h1v1z",
    fill: "#8d8d8f"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v-1h1v1z",
    fill: "#a7a7a9"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M63 61h1v1h-1z",
    fill: "#9b9b9d"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61h1v1h-1z",
    fill: "#9b9698"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M65 61h1v1h-1z",
    fill: "#a2a1a2"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62v-1h1v1z",
    fill: "#949897"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M68 62h-1v-1h1z",
    fill: "#959695"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M69 61v1h-1v-1z",
    fill: "#6c6056"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62h-1v-1h1z",
    fill: "#a17e59"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61v1h-1v-1z",
    fill: "#986b3e"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M71 62v-1h1v1z",
    fill: "#905a42"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M73 61v1h-1v-1z",
    fill: "#825040"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M74 62h-1v-1h1z",
    fill: "#70483a"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M74 61h1v1h-1z",
    fill: "#604038"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M76 62h-1v-1h1z",
    fill: "#553937"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61h1v1h-1z",
    fill: "#4c3637"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M77 62v-1h1v1z",
    fill: "#493635"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62v-1h1v1z",
    fill: "#413132"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M80 62h-1v-1h1z",
    fill: "#352727"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v1h-1v-1z",
    fill: "#2a1d1d"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62h-1v-1h1z",
    fill: "#261b1a"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62v-1h1v1z",
    fill: "#271d1d"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62v-1h1v1z",
    fill: "#271e20"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M85 61v1h-1v-1z",
    fill: "#272223"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M86 62h-1v-1h1z",
    fill: "#231f22"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h1v1h-1z",
    fill: "#1a191c"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61h1v1h-1z",
    fill: "#39383c",
    fillOpacity: 0.886
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v1h-1v-1z",
    fill: "#7f7f8a",
    fillOpacity: 0.094
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62h1v1h-1z",
    fill: "#5f5f5f",
    fillOpacity: 0.2
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h1v1h-1z",
    fill: "#232527"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v-1h1v1z",
    fill: "#191d1f"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h-1v-1h1z",
    fill: "#131917"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h-1v-1h1z",
    fill: "#2c1a16"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62v1h-1v-1z",
    fill: "#8f3940"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62h1v1h-1z",
    fill: "#9f2b32"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63h-1v-1h1z",
    fill: "#9e2c31"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63v-1h1v1z",
    fill: "#9f2b31"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M46 62h1v1h-1z",
    fill: "#9f2934"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62v1h-1v-1z",
    fill: "#9f2a35"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62h1v1h-1z",
    fill: "#9e2b35"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63v-1h1v1z",
    fill: "#9d2b35"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v-1h1v1z",
    fill: "#9d2c34"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M51 62h1v1h-1z",
    fill: "#992f33"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62v1h-1v-1z",
    fill: "#9d3134"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h1v1h-1z",
    fill: "#9e3437"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M55 62v1h-1v-1z",
    fill: "#b06762"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M56 63h-1v-1h1z",
    fill: "#6b514f"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h1v1h-1z",
    fill: "#7b7c7a"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M58 63h-1v-1h1z",
    fill: "#565658"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M58 62h1v1h-1z",
    fill: "#4a4848"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62v1h-1v-1z",
    fill: "#949794"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h1v1h-1z",
    fill: "#808082"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v1h-1v-1z",
    fill: "#6c6c6e"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M63 62v1h-1v-1z",
    fill: "#707072"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M63 63v-1h1v1z",
    fill: "#676769"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M64 62h1v1h-1z",
    fill: "#6d696b"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h1v1h-1z",
    fill: "#636365"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62h1v1h-1z",
    fill: "#656869"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M67 63v-1h1v1z",
    fill: "#646464"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M69 63h-1v-1h1z",
    fill: "#584d44"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62v1h-1v-1z",
    fill: "#baa37a"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M71 63h-1v-1h1z",
    fill: "#c3a971"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M72 62v1h-1v-1z",
    fill: "#a9885f"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62v1h-1v-1z",
    fill: "#82613d"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62h1v1h-1z",
    fill: "#66442a"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M75 62v1h-1v-1z",
    fill: "#603f31"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63v-1h1v1z",
    fill: "#5c403b"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63v-1h1v1z",
    fill: "#503a39"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63h-1v-1h1z",
    fill: "#473534"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62h1v1h-1z",
    fill: "#3c2d2d"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v-1h1v1z",
    fill: "#332525"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M80 63v-1h1v1z",
    fill: "#2c1f1f"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v-1h1v1z",
    fill: "#281e1d"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63h-1v-1h1z",
    fill: "#291f1f"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62h1v1h-1z",
    fill: "#292121"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M84 63v-1h1v1z",
    fill: "#292425"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M85 62h1v1h-1z",
    fill: "#242023"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M87 63h-1v-1h1z",
    fill: "#1a181b"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M93 63v-1h1v1z",
    fill: "#39373c",
    fillOpacity: 0.894
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64h-1v-1h1z",
    fill: "#5d5d5d",
    fillOpacity: 0.204
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v1h-1v-1z",
    fill: "#404042",
    fillOpacity: 0.969
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63h1v1h-1z",
    fill: "#1e1b1e"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h1v1h-1z",
    fill: "#2d1b18"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h1v1h-1z",
    fill: "#964248"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M41 63h1v1h-1z",
    fill: "#a22e33"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h-1v-1h1z",
    fill: "#a32e31"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M47 63v1h-1v-1z",
    fill: "#a62d32"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h-1v-1h1z",
    fill: "#a62d33"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M48 63h1v1h-1z",
    fill: "#a63034"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v1h-1v-1z",
    fill: "#a53034"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M51 63v1h-1v-1z",
    fill: "#a73137"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64v-1h1v1z",
    fill: "#a63538"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64v-1h1v1z",
    fill: "#a8373a"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64h-1v-1h1z",
    fill: "#a93a3f"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64v-1h1v1z",
    fill: "#b1605f"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M56 64h-1v-1h1z",
    fill: "#7e5c5b"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M57 64h-1v-1h1z",
    fill: "#333230"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M57 63h1v1h-1z",
    fill: "#393b3d"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M59 63v1h-1v-1z",
    fill: "#504f4f"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64v-1h1v1z",
    fill: "#969795"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M61 64h-1v-1h1z",
    fill: "#626264"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M62 63v1h-1v-1z",
    fill: "#7e7e80"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M62 64v-1h1v1z",
    fill: "#838385"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M64 64h-1v-1h1z",
    fill: "#757577"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64h-1v-1h1z",
    fill: "#7a7d7e"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64h-1v-1h1z",
    fill: "#7e8385"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v-1h1v1z",
    fill: "#767a7c"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M68 63v1h-1v-1z",
    fill: "#625d61"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M68 64v-1h1v1z",
    fill: "#5c4044"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M70 64h-1v-1h1z",
    fill: "#7e463d"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63h1v1h-1z",
    fill: "#8a593b"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M71 64v-1h1v1z",
    fill: "#a2775d"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M73 63v1h-1v-1z",
    fill: "#bb9b7f"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M73 64v-1h1v1z",
    fill: "#a88a69"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M74 63h1v1h-1z",
    fill: "#7a5d42"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M76 64h-1v-1h1z",
    fill: "#51372a"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63v1h-1v-1z",
    fill: "#483636"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v1h-1v-1z",
    fill: "#3a2a2c"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63h1v1h-1z",
    fill: "#342526"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v1h-1v-1z",
    fill: "#2f2222"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v-1h1v1z",
    fill: "#2c2120"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63v1h-1v-1z",
    fill: "#2c2222"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M83 64v-1h1v1z",
    fill: "#2f2728"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h-1v-1h1z",
    fill: "#332e2f"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M86 64v-1h1v1z",
    fill: "#1b191c"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64h-1v-1h1z",
    fill: "#38383d",
    fillOpacity: 0.898
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M95 63v1h-1v-1z",
    fill: "#848484",
    fillOpacity: 0.106
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64v1h-1v-1z",
    fill: "#58585d",
    fillOpacity: 0.204
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64h1v1h-1z",
    fill: "#141815"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M39 64h1v1h-1z",
    fill: "#2d1a19"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64h1v1h-1z",
    fill: "#984345"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M41 65v-1h1v1z",
    fill: "#a22f30"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64v1h-1v-1z",
    fill: "#a22f33"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64h1v1h-1z",
    fill: "#a22f37"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v-1h1v1z",
    fill: "#a23034"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M45 64h1v1h-1z",
    fill: "#a33031"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h-1v-1h1z",
    fill: "#a93436"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64h1v1h-1z",
    fill: "#a83537"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64h1v1h-1z",
    fill: "#ad3e43"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v-1h1v1z",
    fill: "#af484c"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M55 65v-1h1v1z",
    fill: "#b97675"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65h-1v-1h1z",
    fill: "#54413d"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64v1h-1v-1z",
    fill: "#38423f"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64h1v1h-1z",
    fill: "#414242"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64h1v1h-1z",
    fill: "#555352"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64h1v1h-1z",
    fill: "#414442"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M61 65v-1h1v1z",
    fill: "#423f40"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65h-1v-1h1z",
    fill: "#413f42"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65h-1v-1h1z",
    fill: "#404446"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64v1h-1v-1z",
    fill: "#3e423f"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v1h-1v-1z",
    fill: "#3c4343"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v-1h1v1z",
    fill: "#3f3f43"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M68 65h-1v-1h1z",
    fill: "#50383d"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65h-1v-1h1z",
    fill: "#854c52"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v-1h1v1z",
    fill: "#9c444b"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h-1v-1h1z",
    fill: "#944143"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64v1h-1v-1z",
    fill: "#853a3c"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64h1v1h-1z",
    fill: "#7d3e3d"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65h-1v-1h1z",
    fill: "#8d5d50"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65h-1v-1h1z",
    fill: "#ac8b71"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65v-1h1v1z",
    fill: "#a89474"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M77 65h-1v-1h1z",
    fill: "#6b5e44"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M77 64h1v1h-1z",
    fill: "#3e3023"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M79 64v1h-1v-1z",
    fill: "#3f2f32"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M82 64v1h-1v-1z",
    fill: "#372e2e"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M83 65h-1v-1h1z",
    fill: "#342e2e"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M84 64v1h-1v-1z",
    fill: "#373435"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v-1h1v1z",
    fill: "#393738"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64v1h-1v-1z",
    fill: "#38373c",
    fillOpacity: 0.902
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M95 65h-1v-1h1z",
    fill: "#7f7f88",
    fillOpacity: 0.11
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h-1v-1h1z",
    fill: "#5b5b5b",
    fillOpacity: 0.208
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M38 66v-1h1v1z",
    fill: "#141814"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v-1h1v1z",
    fill: "#2d1a1a"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66v-1h1v1z",
    fill: "#933c3d"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65h1v1h-1z",
    fill: "#a62e33"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M45 66v-1h1v1z",
    fill: "#a72f33"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h1v1h-1z",
    fill: "#a83536"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v1h-1v-1z",
    fill: "#b04145"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66h-1v-1h1z",
    fill: "#af4347"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M56 66h-1v-1h1z",
    fill: "#b9615d"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65v1h-1v-1z",
    fill: "#9d6a65"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M58 66h-1v-1h1z",
    fill: "#524441"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M59 65v1h-1v-1z",
    fill: "#424542"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65v1h-1v-1z",
    fill: "#3d4141"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M60 66v-1h1v1z",
    fill: "#424245"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1z",
    fill: "#484249"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65v1h-1v-1z",
    fill: "#47414a"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65v1h-1v-1z",
    fill: "#42424a"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M64 66v-1h1v1z",
    fill: "#414546"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65h1v1h-1z",
    fill: "#523e43"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M67 65h1v1h-1z",
    fill: "#7e464c"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v1h-1v-1z",
    fill: "#a65056"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M70 65v1h-1v-1z",
    fill: "#aa464f"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M71 66h-1v-1h1z",
    fill: "#a84650"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h1v1h-1z",
    fill: "#a0464f"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M72 65h1v1h-1z",
    fill: "#97464d"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65v1h-1v-1z",
    fill: "#884241"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66h-1v-1h1z",
    fill: "#763b33"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66v-1h1v1z",
    fill: "#7e5546"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h-1v-1h1z",
    fill: "#ad947e"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66h-1v-1h1z",
    fill: "#a09075"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66v-1h1v1z",
    fill: "#534831"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65v1h-1v-1z",
    fill: "#3d362c"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65v1h-1v-1z",
    fill: "#3c393d"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65h1v1h-1z",
    fill: "#3b3840"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M82 65h1v1h-1z",
    fill: "#3b383c"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65h1v1h-1z",
    fill: "#38373c",
    fillOpacity: 0.906
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M94 65h1v1h-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.118
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66v1h-1v-1z",
    fill: "#59595e",
    fillOpacity: 0.212
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h1v1h-1z",
    fill: "#404042",
    fillOpacity: 0.976
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M37 66v1h-1v-1z",
    fill: "#282529"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67h-1v-1h1z",
    fill: "#271414"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66h1v1h-1z",
    fill: "#893233"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66v1h-1v-1z",
    fill: "#aa2f33"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M44 66v1h-1v-1z",
    fill: "#a92e2d"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h-1v-1h1z",
    fill: "#a92f34"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M51 66h1v1h-1z",
    fill: "#a93637"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M52 66h1v1h-1z",
    fill: "#ae3b3f"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67v-1h1v1z",
    fill: "#b24448"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66v1h-1v-1z",
    fill: "#b3464b"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M55 67v-1h1v1z",
    fill: "#b14b48"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M57 67h-1v-1h1z",
    fill: "#bb6361"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M57 66h1v1h-1z",
    fill: "#a06866"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M59 66v1h-1v-1z",
    fill: "#5b4843"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67v-1h1v1z",
    fill: "#454843"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M60 67v-1h1v1z",
    fill: "#3f4644"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M62 67h-1v-1h1z",
    fill: "#414847"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M62 66h1v1h-1z",
    fill: "#404748"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67h-1v-1h1z",
    fill: "#42484b"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67v-1h1v1z",
    fill: "#4f494c"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M65 67v-1h1v1z",
    fill: "#5b4245"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67v-1h1v1z",
    fill: "#81484b"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M68 66v1h-1v-1z",
    fill: "#b05359"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v-1h1v1z",
    fill: "#b94c54"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M69 66h1v1h-1z",
    fill: "#b44a54"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67h-1v-1h1z",
    fill: "#b34853"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67v-1h1v1z",
    fill: "#af4952"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66v1h-1v-1z",
    fill: "#a6484f"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67h-1v-1h1z",
    fill: "#a04548"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67h-1v-1h1z",
    fill: "#98434c"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67h-1v-1h1z",
    fill: "#863f4a"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v1h-1v-1z",
    fill: "#6f3b36"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h1v1h-1z",
    fill: "#8a674a"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v-1h1v1z",
    fill: "#baac81"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M80 66v1h-1v-1z",
    fill: "#746b52"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h-1v-1h1z",
    fill: "#36322d"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v-1h1v1z",
    fill: "#3b393e"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M83 66v1h-1v-1z",
    fill: "#3c3a3e"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M84 67h-1v-1h1z",
    fill: "#3b393a"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M85 66v1h-1v-1z",
    fill: "#3c3b3b"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M94 66v1h-1v-1z",
    fill: "#39383e",
    fillOpacity: 0.902
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M95 66v1h-1v-1z",
    fill: "#7b7b83",
    fillOpacity: 0.114
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M33 68v-1h1v1z",
    fill: "#515151",
    fillOpacity: 0.22
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M34 67h1v1h-1z",
    fill: "#39393b",
    fillOpacity: 0.98
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M36 67h1v1h-1z",
    fill: "#282629"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M39 67h1v1h-1z",
    fill: "#291616"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68v-1h1v1z",
    fill: "#8b3535"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M41 67h1v1h-1z",
    fill: "#a83034"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67v1h-1v-1z",
    fill: "#a42d2b"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67h1v1h-1z",
    fill: "#a22d24"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68h-1v-1h1z",
    fill: "#a62f2c"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67v1h-1v-1z",
    fill: "#a72f35"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67h1v1h-1z",
    fill: "#a83033"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67h1v1h-1z",
    fill: "#a93638"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M53 68h-1v-1h1z",
    fill: "#af3c41"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67h1v1h-1z",
    fill: "#b34549"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M54 67h1v1h-1z",
    fill: "#b4474c"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M56 67v1h-1v-1z",
    fill: "#b4494d"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M56 68v-1h1v1z",
    fill: "#b44849"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h-1v-1h1z",
    fill: "#ba5c58"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M58 67h1v1h-1z",
    fill: "#b16c67"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67h1v1h-1z",
    fill: "#855a55"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67v1h-1v-1z",
    fill: "#6a4d48"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67h1v1h-1z",
    fill: "#634c45"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M63 67v1h-1v-1z",
    fill: "#624946"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h-1v-1h1z",
    fill: "#694949"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v-1h1v1z",
    fill: "#794a4c"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M65 68v-1h1v1z",
    fill: "#955251"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67h1v1h-1z",
    fill: "#ae5450"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v1h-1v-1z",
    fill: "#bb4f4e"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67h1v1h-1z",
    fill: "#bb4c51"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M69 68v-1h1v1z",
    fill: "#b54c56"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68h-1v-1h1z",
    fill: "#b54a53"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67v1h-1v-1z",
    fill: "#b44b51"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67h1v1h-1z",
    fill: "#ae4c4e"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M73 67h1v1h-1z",
    fill: "#a9494a"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67v1h-1v-1z",
    fill: "#a4454c"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M75 68v-1h1v1z",
    fill: "#9b434f"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M77 67v1h-1v-1z",
    fill: "#8c4047"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v1h-1v-1z",
    fill: "#7a3936"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67h1v1h-1z",
    fill: "#6e4331"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68h-1v-1h1z",
    fill: "#bba182"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v1h-1v-1z",
    fill: "#908466"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h1v1h-1z",
    fill: "#383124"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68v-1h1v1z",
    fill: "#3a3635"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M84 68v-1h1v1z",
    fill: "#3b3a3b"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M86 68h-1v-1h1z",
    fill: "#252625"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68v-1h1v1z",
    fill: "#28282b"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M93 68v-1h1v1z",
    fill: "#38383c",
    fillOpacity: 0.906
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68h-1v-1h1z",
    fill: "#77777f",
    fillOpacity: 0.118
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v-1h1v1z",
    fill: "#565656",
    fillOpacity: 0.22
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v1h-1v-1z",
    fill: "#3a3a3c",
    fillOpacity: 0.98
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M37 69h-1v-1h1z",
    fill: "#272529"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69v-1h1v1z",
    fill: "#261517"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69h-1v-1h1z",
    fill: "#893235"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69h-1v-1h1z",
    fill: "#a63035"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v-1h1v1z",
    fill: "#a93a30"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M44 68v1h-1v-1z",
    fill: "#b44b34"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M44 69v-1h1v1z",
    fill: "#aa4033"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M45 69v-1h1v1z",
    fill: "#a53835"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M47 68v1h-1v-1z",
    fill: "#a83831"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h-1v-1h1z",
    fill: "#aa3835"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M49 68v1h-1v-1z",
    fill: "#a63332"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v1h-1v-1z",
    fill: "#a83334"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69v-1h1v1z",
    fill: "#ab3339"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69h-1v-1h1z",
    fill: "#ab353a"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M52 68h1v1h-1z",
    fill: "#aa3c3a"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h-1v-1h1z",
    fill: "#ae4743"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M55 69h-1v-1h1z",
    fill: "#b04648"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M56 69h-1v-1h1z",
    fill: "#b1474c"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M57 68v1h-1v-1z",
    fill: "#b54847"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69h-1v-1h1z",
    fill: "#b34841"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h1v1h-1z",
    fill: "#b6504a"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v-1h1v1z",
    fill: "#b65754"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M60 68h1v1h-1z",
    fill: "#ae5755"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68v1h-1v-1z",
    fill: "#ab5856"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68h1v1h-1z",
    fill: "#aa5455"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v1h-1v-1z",
    fill: "#ad5156"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h1v1h-1z",
    fill: "#aa5552"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69h-1v-1h1z",
    fill: "#ae524a"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v-1h1v1z",
    fill: "#b54c44"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69h-1v-1h1z",
    fill: "#b64e47"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69v-1h1v1z",
    fill: "#b24f4d"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69v-1h1v1z",
    fill: "#af4c50"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68v1h-1v-1z",
    fill: "#b04b4d"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M71 69v-1h1v1z",
    fill: "#b34c4e"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M73 68v1h-1v-1z",
    fill: "#b24e4e"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v-1h1v1z",
    fill: "#ae4d4b"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M74 69v-1h1v1z",
    fill: "#ab4b49"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M76 69h-1v-1h1z",
    fill: "#a6474a"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h-1v-1h1z",
    fill: "#9c414b"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M78 68v1h-1v-1z",
    fill: "#933d4c"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M79 69h-1v-1h1z",
    fill: "#823c42"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68v1h-1v-1z",
    fill: "#713f29"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M81 68v1h-1v-1z",
    fill: "#baa179"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M81 69v-1h1v1z",
    fill: "#918462"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68h1v1h-1z",
    fill: "#363124"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M84 69h-1v-1h1z",
    fill: "#39373a"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M94 69h-1v-1h1z",
    fill: "#353438",
    fillOpacity: 0.914
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68v1h-1v-1z",
    fill: "#736c73",
    fillOpacity: 0.129
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M34 69v1h-1v-1z",
    fill: "#57575c",
    fillOpacity: 0.227
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69h1v1h-1z",
    fill: "#22161a"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69v1h-1v-1z",
    fill: "#863138"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v1h-1v-1z",
    fill: "#a12f2d"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69v1h-1v-1z",
    fill: "#c76649"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69h1v1h-1z",
    fill: "#d68156"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70h-1v-1h1z",
    fill: "#c67251"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70v-1h1v1z",
    fill: "#b15b3b"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70v-1h1v1z",
    fill: "#cc7651"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69v1h-1v-1z",
    fill: "#c86e52"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h1v1h-1z",
    fill: "#9a3a25"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70h-1v-1h1z",
    fill: "#ca6b57"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69h1v1h-1z",
    fill: "#a43434"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M51 69h1v1h-1z",
    fill: "#a93635"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M53 69v1h-1v-1z",
    fill: "#ce7658"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v-1h1v1z",
    fill: "#cc815f"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h1v1h-1z",
    fill: "#cd7662"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M55 70v-1h1v1z",
    fill: "#c97059"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70h-1v-1h1z",
    fill: "#d0785f"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69v1h-1v-1z",
    fill: "#ce765d"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v1h-1v-1z",
    fill: "#c76f56"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70v-1h1v1z",
    fill: "#d07a60"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v-1h1v1z",
    fill: "#cf7c62"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70h-1v-1h1z",
    fill: "#c67159"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69v1h-1v-1z",
    fill: "#b8614b"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69h1v1h-1z",
    fill: "#c26a56"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M64 69h1v1h-1z",
    fill: "#c8725e"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v1h-1v-1z",
    fill: "#c76c5a"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M67 69v1h-1v-1z",
    fill: "#cd6e5f"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M67 70v-1h1v1z",
    fill: "#cb725f"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70h-1v-1h1z",
    fill: "#be6956"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69h1v1h-1z",
    fill: "#b96253"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h-1v-1h1z",
    fill: "#cc7263"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M72 69v1h-1v-1z",
    fill: "#b8574e"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v1h-1v-1z",
    fill: "#b54e4e"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69h1v1h-1z",
    fill: "#b44c4d"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70h-1v-1h1z",
    fill: "#b44d4d"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v-1h1v1z",
    fill: "#ae494d"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v-1h1v1z",
    fill: "#a8464c"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h1v1h-1z",
    fill: "#a1434b"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70h-1v-1h1z",
    fill: "#964347"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M80 69v1h-1v-1z",
    fill: "#884343"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h-1v-1h1z",
    fill: "#744735"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M82 69v1h-1v-1z",
    fill: "#c9b78b"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70h-1v-1h1z",
    fill: "#6e6847"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M83 69h1v1h-1z",
    fill: "#343331"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M84 70v-1h1v1z",
    fill: "#363a3d"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M85 69h1v1h-1z",
    fill: "#212724"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v-1h1v1z",
    fill: "#343338",
    fillOpacity: 0.922
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M94 70v-1h1v1z",
    fill: "#6a6a6a",
    fillOpacity: 0.141
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70v1h-1v-1z",
    fill: "#23161b"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M41 71h-1v-1h1z",
    fill: "#873238"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71h-1v-1h1z",
    fill: "#9f3129"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M42 70h1v1h-1z",
    fill: "#d07358"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70h1v1h-1z",
    fill: "#b15c3f"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h-1v-1h1z",
    fill: "#c97459"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71v-1h1v1z",
    fill: "#ca7452"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70h1v1h-1z",
    fill: "#cb7951"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h-1v-1h1z",
    fill: "#d07958"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M49 71h-1v-1h1z",
    fill: "#aa5132"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70v1h-1v-1z",
    fill: "#d5815d"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71v-1h1v1z",
    fill: "#a3402d"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M51 71v-1h1v1z",
    fill: "#a53c2b"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v1h-1v-1z",
    fill: "#d4825c"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71h-1v-1h1z",
    fill: "#d58f64"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71v-1h1v1z",
    fill: "#c97b59"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M56 71h-1v-1h1z",
    fill: "#dc8e68"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70v1h-1v-1z",
    fill: "#cd8159"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h-1v-1h1z",
    fill: "#e49770"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70h1v1h-1z",
    fill: "#da8d66"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70h1v1h-1z",
    fill: "#c67b53"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v-1h1v1z",
    fill: "#c87f55"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70v1h-1v-1z",
    fill: "#d78f64"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M62 71v-1h1v1z",
    fill: "#db9268"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M64 70v1h-1v-1z",
    fill: "#cf885d"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71v-1h1v1z",
    fill: "#de956f"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M66 71h-1v-1h1z",
    fill: "#c67656"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71h-1v-1h1z",
    fill: "#d98568"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71v-1h1v1z",
    fill: "#ca7b5b"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70v1h-1v-1z",
    fill: "#d68c68"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M69 71v-1h1v1z",
    fill: "#da8a6a"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70h1v1h-1z",
    fill: "#cf7c61"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h1v1h-1z",
    fill: "#bd6252"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M73 71h-1v-1h1z",
    fill: "#b04e4d"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70h1v1h-1z",
    fill: "#ad4a4c"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M78 70v1h-1v-1z",
    fill: "#a74848"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70v1h-1v-1z",
    fill: "#9e464a"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M79 71v-1h1v1z",
    fill: "#94474b"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70v1h-1v-1z",
    fill: "#7d453b"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h1v1h-1z",
    fill: "#8e6a4a"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70v1h-1v-1z",
    fill: "#c6b68e"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M83 71v-1h1v1z",
    fill: "#3f3c2a"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M85 70v1h-1v-1z",
    fill: "#37393b"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M86 70v1h-1v-1z",
    fill: "#222626"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M93 71v-1h1v1z",
    fill: "#313035",
    fillOpacity: 0.929
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M94 70h1v1h-1z",
    fill: "#646464",
    fillOpacity: 0.149
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71h1v1h-1z",
    fill: "#23161a"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h-1v-1h1z",
    fill: "#873138"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71v1h-1v-1z",
    fill: "#a82f33"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M42 72v-1h1v1z",
    fill: "#ac3c35"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M44 71v1h-1v-1z",
    fill: "#9a2f29"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72v-1h1v1z",
    fill: "#ae403f"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h1v1h-1z",
    fill: "#bf5247"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M47 71v1h-1v-1z",
    fill: "#a7442d"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71v1h-1v-1z",
    fill: "#c25d4c"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h1v1h-1z",
    fill: "#ba5545"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h-1v-1h1z",
    fill: "#c66851"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71h1v1h-1z",
    fill: "#b65044"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M52 71v1h-1v-1z",
    fill: "#ae3f38"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71v1h-1v-1z",
    fill: "#d2705e"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71h1v1h-1z",
    fill: "#cc765f"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v-1h1v1z",
    fill: "#c16655"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h-1v-1h1z",
    fill: "#c06855"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M57 72h-1v-1h1z",
    fill: "#ca725f"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71v1h-1v-1z",
    fill: "#d17966"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h1v1h-1z",
    fill: "#d27966"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v1h-1v-1z",
    fill: "#c96e5e"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72v-1h1v1z",
    fill: "#c56859"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72h-1v-1h1z",
    fill: "#d47b68"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71v1h-1v-1z",
    fill: "#cd7761"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71h1v1h-1z",
    fill: "#cd7a5f"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71h1v1h-1z",
    fill: "#de9270"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1z",
    fill: "#bf6d51"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72v-1h1v1z",
    fill: "#d17c64"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-1v-1h1z",
    fill: "#bb6a4d"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72h-1v-1h1z",
    fill: "#d18663"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72h-1v-1h1z",
    fill: "#da8c6c"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72h-1v-1h1z",
    fill: "#d78369"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72v-1h1v1z",
    fill: "#b45a4c"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M72 71h1v1h-1z",
    fill: "#b1504f"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72h-1v-1h1z",
    fill: "#b14e54"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M74 71h1v1h-1z",
    fill: "#b24f54"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M75 71h1v1h-1z",
    fill: "#b24d51"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M76 71h1v1h-1z",
    fill: "#b24d50"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M77 71h1v1h-1z",
    fill: "#af4a4b"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M78 72v-1h1v1z",
    fill: "#a7464c"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v-1h1v1z",
    fill: "#9d444f"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72v-1h1v1z",
    fill: "#904649"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M81 71h1v1h-1z",
    fill: "#7d4333"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M82 71h1v1h-1z",
    fill: "#d1b586"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72h-1v-1h1z",
    fill: "#6f6942"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72v-1h1v1z",
    fill: "#373634"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M85 71h1v1h-1z",
    fill: "#222428"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72h-1v-1h1z",
    fill: "#2e2d31",
    fillOpacity: 0.933
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72v-1h1v1z",
    fill: "#59595f",
    fillOpacity: 0.157
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M39 72h1v1h-1z",
    fill: "#22151a"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73v-1h1v1z",
    fill: "#853036"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h1v1h-1z",
    fill: "#a32d30"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73h-1v-1h1z",
    fill: "#aa402c"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73v-1h1v1z",
    fill: "#b95338"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72h1v1h-1z",
    fill: "#a5372d"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73v-1h1v1z",
    fill: "#a03228"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72v1h-1v-1z",
    fill: "#a54c2d"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v-1h1v1z",
    fill: "#9f4026"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M49 72v1h-1v-1z",
    fill: "#92351d"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72v1h-1v-1z",
    fill: "#934023"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73h-1v-1h1z",
    fill: "#9b452e"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M52 73h-1v-1h1z",
    fill: "#9f3c2c"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M53 73h-1v-1h1z",
    fill: "#a54533"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v1h-1v-1z",
    fill: "#9f4e37"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72v1h-1v-1z",
    fill: "#a4523c"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72h1v1h-1z",
    fill: "#a65342"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h1v1h-1z",
    fill: "#a95646"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v-1h1v1z",
    fill: "#a65343"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M59 73h-1v-1h1z",
    fill: "#a65443"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M59 72h1v1h-1z",
    fill: "#ab504a"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72h1v1h-1z",
    fill: "#b45255"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72v1h-1v-1z",
    fill: "#ae514d"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M63 72v1h-1v-1z",
    fill: "#a95448"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M64 72v1h-1v-1z",
    fill: "#a75645"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1z",
    fill: "#b45b4d"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72h1v1h-1z",
    fill: "#b75450"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72h1v1h-1z",
    fill: "#b95253"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M67 73v-1h1v1z",
    fill: "#b5544e"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72v1h-1v-1z",
    fill: "#ad5346"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72v1h-1v-1z",
    fill: "#ad5649"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M71 73h-1v-1h1z",
    fill: "#b3594d"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72v1h-1v-1z",
    fill: "#b0504b"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M72 73v-1h1v1z",
    fill: "#b34d51"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72v1h-1v-1z",
    fill: "#b25252"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M74 73v-1h1v1z",
    fill: "#ae4e4c"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72v1h-1v-1z",
    fill: "#b04d50"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M77 72v1h-1v-1z",
    fill: "#b54d55"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M77 73v-1h1v1z",
    fill: "#b24852"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v1h-1v-1z",
    fill: "#ad464d"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M79 73v-1h1v1z",
    fill: "#a84555"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72h1v1h-1z",
    fill: "#9d4653"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M82 72v1h-1v-1z",
    fill: "#8a3f3c"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73h-1v-1h1z",
    fill: "#be9a64"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73h-1v-1h1z",
    fill: "#99925c"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72h1v1h-1z",
    fill: "#35312d"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M86 72v1h-1v-1z",
    fill: "#232429"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72h1v1h-1z",
    fill: "#2c2b31",
    fillOpacity: 0.937
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72h1v1h-1z",
    fill: "#505050",
    fillOpacity: 0.161
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M39 73v1h-1v-1z",
    fill: "#141915"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74v-1h1v1z",
    fill: "#21161a"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73h1v1h-1z",
    fill: "#813034"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M42 73v1h-1v-1z",
    fill: "#9c2f2a"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h-1v-1h1z",
    fill: "#c56d3f"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74h-1v-1h1z",
    fill: "#f1a059"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74v-1h1v1z",
    fill: "#a74c2e"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h1v1h-1z",
    fill: "#b5622f"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v1h-1v-1z",
    fill: "#fdc870"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h-1v-1h1z",
    fill: "#bc7440"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M49 73v1h-1v-1z",
    fill: "#af7735"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74v-1h1v1z",
    fill: "#ebc77d"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73v1h-1v-1z",
    fill: "#efca7d"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M51 74v-1h1v1z",
    fill: "#b4834a"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h-1v-1h1z",
    fill: "#cc986a"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M54 73v1h-1v-1z",
    fill: "#e9c886"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74h-1v-1h1z",
    fill: "#e7c384"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74h-1v-1h1z",
    fill: "#dfb18b"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v1h-1v-1z",
    fill: "#a97945"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73h1v1h-1z",
    fill: "#dbbc85"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M59 74h-1v-1h1z",
    fill: "#e7c391"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M60 74h-1v-1h1z",
    fill: "#bd8b64"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74h-1v-1h1z",
    fill: "#a85d4f"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M62 73v1h-1v-1z",
    fill: "#d8a783"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M63 74h-1v-1h1z",
    fill: "#d6b47b"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v1h-1v-1z",
    fill: "#c69b6f"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1z",
    fill: "#ab5e4b"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v1h-1v-1z",
    fill: "#b84b52"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M67 74h-1v-1h1z",
    fill: "#b34b5a"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74h-1v-1h1z",
    fill: "#a8574d"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M68 73h1v1h-1z",
    fill: "#cb8564"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M69 73h1v1h-1z",
    fill: "#d49968"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M70 73h1v1h-1z",
    fill: "#b6744b"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v-1h1v1z",
    fill: "#ab5143"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74h-1v-1h1z",
    fill: "#c6715c"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74v-1h1v1z",
    fill: "#b86a53"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M75 74h-1v-1h1z",
    fill: "#b56d4a"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M75 73h1v1h-1z",
    fill: "#bb6c56"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h-1v-1h1z",
    fill: "#ae4a52"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#b14651"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74v-1h1v1z",
    fill: "#b0474d"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M80 73v1h-1v-1z",
    fill: "#ae484f"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M80 74v-1h1v1z",
    fill: "#ab4557"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M82 73v1h-1v-1z",
    fill: "#974247"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73v1h-1v-1z",
    fill: "#b58d55"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73v1h-1v-1z",
    fill: "#aea56a"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74h-1v-1h1z",
    fill: "#34322a"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v-1h1v1z",
    fill: "#222528"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M94 74h-1v-1h1z",
    fill: "#2a2a2e",
    fillOpacity: 0.933
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M94 73h1v1h-1z",
    fill: "#4a4a4a",
    fillOpacity: 0.161
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M41 74v1h-1v-1z",
    fill: "#7c2c31"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M42 74v1h-1v-1z",
    fill: "#9c2f2c"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74v1h-1v-1z",
    fill: "#c87545"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h1v1h-1z",
    fill: "#e19a49"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75h-1v-1h1z",
    fill: "#a05325"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74h1v1h-1z",
    fill: "#ce8d45"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M46 74h1v1h-1z",
    fill: "#f5c864"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74v1h-1v-1z",
    fill: "#ab7136"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h1v1h-1z",
    fill: "#ecc76e"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74h1v1h-1z",
    fill: "#ab7b3b"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v-1h1v1z",
    fill: "#b79545"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h-1v-1h1z",
    fill: "#e7be7a"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75v-1h1v1z",
    fill: "#9b5e32"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h1v1h-1z",
    fill: "#dec378"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v1h-1v-1z",
    fill: "#e0c27d"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74v1h-1v-1z",
    fill: "#ad7953"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M57 75h-1v-1h1z",
    fill: "#e3c586"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M57 74h1v1h-1z",
    fill: "#d6b980"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M58 75v-1h1v1z",
    fill: "#cea973"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h-1v-1h1z",
    fill: "#ebd39e"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75v-1h1v1z",
    fill: "#ab7a56"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1z",
    fill: "#f9e0a8"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75h-1v-1h1z",
    fill: "#c7a26f"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75v-1h1v1z",
    fill: "#edd696"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M64 74h1v1h-1z",
    fill: "#cb986c"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h1v1h-1z",
    fill: "#b04843"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74v1h-1v-1z",
    fill: "#cd966e"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M69 75h-1v-1h1z",
    fill: "#edbb82"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M70 74v1h-1v-1z",
    fill: "#dbaa69"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v1h-1v-1z",
    fill: "#edbb80"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M72 74v1h-1v-1z",
    fill: "#ac5e42"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75h-1v-1h1z",
    fill: "#ecab7d"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75v-1h1v1z",
    fill: "#c18158"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v-1h1v1z",
    fill: "#d2965e"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M75 75v-1h1v1z",
    fill: "#d48e67"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v1h-1v-1z",
    fill: "#a84647"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h1v1h-1z",
    fill: "#b1484c"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74h1v1h-1z",
    fill: "#b2494d"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M79 75v-1h1v1z",
    fill: "#b04a4d"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74v1h-1v-1z",
    fill: "#ad4556"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74h1v1h-1z",
    fill: "#954143"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v-1h1v1z",
    fill: "#b18c52"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M84 75h-1v-1h1z",
    fill: "#aca36a"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v1h-1v-1z",
    fill: "#333229"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M86 75h-1v-1h1z",
    fill: "#212527"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75h-1v-1h1z",
    fill: "#28272b",
    fillOpacity: 0.933
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75v-1h1v1z",
    fill: "#44444a",
    fillOpacity: 0.161
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M35 75v1h-1v-1z",
    fill: "#404042",
    fillOpacity: 0.988
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76v-1h1v1z",
    fill: "#7d2c32"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M41 76v-1h1v1z",
    fill: "#9e332f"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M43 76h-1v-1h1z",
    fill: "#cc7f4f"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M43 75h1v1h-1z",
    fill: "#cd8b43"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75v1h-1v-1z",
    fill: "#b27233"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M46 76h-1v-1h1z",
    fill: "#d7a052"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M47 76h-1v-1h1z",
    fill: "#e3b55e"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M48 75v1h-1v-1z",
    fill: "#a57533"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76h-1v-1h1z",
    fill: "#eecd6d"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v1h-1v-1z",
    fill: "#984626"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M51 75v1h-1v-1z",
    fill: "#c49450"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76v-1h1v1z",
    fill: "#dca671"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h1v1h-1z",
    fill: "#923a20"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M53 76v-1h1v1z",
    fill: "#e7c17f"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M55 76h-1v-1h1z",
    fill: "#cb9a67"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75v1h-1v-1z",
    fill: "#a4573b"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75h1v1h-1z",
    fill: "#f4dca2"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h-1v-1h1z",
    fill: "#b57854"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M59 75v1h-1v-1z",
    fill: "#c08b62"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M60 76h-1v-1h1z",
    fill: "#e2ce99"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h1v1h-1z",
    fill: "#b3945d"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75h1v1h-1z",
    fill: "#ead798"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v1z",
    fill: "#915339"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M64 75v1h-1v-1z",
    fill: "#d9c17b"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1z",
    fill: "#cfa371"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M66 76h-1v-1h1z",
    fill: "#ad4945"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75v1h-1v-1z",
    fill: "#ad5243"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M67 76v-1h1v1z",
    fill: "#eabf87"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v-1h1v1z",
    fill: "#bc8c57"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M70 76h-1v-1h1z",
    fill: "#ae743e"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h-1v-1h1z",
    fill: "#eebe83"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M72 76h-1v-1h1z",
    fill: "#af6d46"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M73 76h-1v-1h1z",
    fill: "#eab575"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v1h-1v-1z",
    fill: "#b07542"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M74 76v-1h1v1z",
    fill: "#dfa368"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M75 76v-1h1v1z",
    fill: "#c47b51"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M76 76v-1h1v1z",
    fill: "#aa4844"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75v1h-1v-1z",
    fill: "#b34b4b"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M79 76h-1v-1h1z",
    fill: "#b24a4d"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h-1v-1h1z",
    fill: "#ad4857"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v1h-1v-1z",
    fill: "#954740"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M83 75v1h-1v-1z",
    fill: "#c09d63"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v-1h1v1z",
    fill: "#a59b68"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M86 76h-1v-1h1z",
    fill: "#212427"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M93 76v-1h1v1z",
    fill: "#27262b",
    fillOpacity: 0.933
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h1v1h-1z",
    fill: "#5c5c5c",
    fillOpacity: 0.227
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v1h-1v-1z",
    fill: "#404043",
    fillOpacity: 0.984
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h1v1h-1z",
    fill: "#20171a"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76h1v1h-1z",
    fill: "#7f2e33"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M41 77v-1h1v1z",
    fill: "#a33c2e"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v-1h1v1z",
    fill: "#cc8049"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M44 76v1h-1v-1z",
    fill: "#c07d3d"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77h-1v-1h1z",
    fill: "#da9a4f"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1z",
    fill: "#c99248"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77v-1h1v1z",
    fill: "#dfac5f"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76v1h-1v-1z",
    fill: "#ac7737"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76v1h-1v-1z",
    fill: "#ecc864"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M49 77v-1h1v1z",
    fill: "#923622"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M50 76h1v1h-1z",
    fill: "#deb368"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76h1v1h-1z",
    fill: "#c7885c"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M52 76h1v1h-1z",
    fill: "#9c442f"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77v-1h1v1z",
    fill: "#f0d08a"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M54 77v-1h1v1z",
    fill: "#bd8057"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M56 76v1h-1v-1z",
    fill: "#b86b4c"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M56 77v-1h1v1z",
    fill: "#f9dda4"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76v1h-1v-1z",
    fill: "#ae684a"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h1v1h-1z",
    fill: "#d9a77e"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M59 77v-1h1v1z",
    fill: "#d5bc83"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M61 76v1h-1v-1z",
    fill: "#c4a56d"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M62 77h-1v-1h1z",
    fill: "#e1d691"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M63 77h-1v-1h1z",
    fill: "#b48f5f"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77h-1v-1h1z",
    fill: "#eed697"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76h1v1h-1z",
    fill: "#b77859"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M65 77v-1h1v1z",
    fill: "#af4a52"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77h-1v-1h1z",
    fill: "#ab6048"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v1h-1v-1z",
    fill: "#f1c98e"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M69 77h-1v-1h1z",
    fill: "#b0764f"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h-1v-1h1z",
    fill: "#c88a57"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77v-1h1v1z",
    fill: "#e3b77a"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h1v1h-1z",
    fill: "#ad7346"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77v-1h1v1z",
    fill: "#eab973"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77h-1v-1h1z",
    fill: "#a9713d"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77h-1v-1h1z",
    fill: "#e8ac72"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77v-1h1v1z",
    fill: "#b96d46"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76h1v1h-1z",
    fill: "#b04b4c"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h-1v-1h1z",
    fill: "#b1494c"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76v1h-1v-1z",
    fill: "#b04c4f"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M80 77v-1h1v1z",
    fill: "#ab4a56"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h1v1h-1z",
    fill: "#964e3f"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v1h-1v-1z",
    fill: "#dcbc7e"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76h1v1h-1z",
    fill: "#8f8457"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v-1h1v1z",
    fill: "#32302e"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M85 77v-1h1v1z",
    fill: "#212428"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M86 77v-1h1v1z",
    fill: "#1e1d1c"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M94 77h-1v-1h1z",
    fill: "#28272d",
    fillOpacity: 0.933
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M34 77v1h-1v-1z",
    fill: "#535353",
    fillOpacity: 0.227
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78h-1v-1h1z",
    fill: "#3c3c3e",
    fillOpacity: 0.984
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M40 77v1h-1v-1z",
    fill: "#1e1518"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M40 78v-1h1v1z",
    fill: "#7c2c30"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v1h-1v-1z",
    fill: "#a9452b"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77h1v1h-1z",
    fill: "#cd7f43"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M43 77h1v1h-1z",
    fill: "#b86d34"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77v1h-1v-1z",
    fill: "#eba158"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v-1h1v1z",
    fill: "#b77938"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1z",
    fill: "#daa359"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M48 77v1h-1v-1z",
    fill: "#c18143"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M49 78h-1v-1h1z",
    fill: "#e2b85a"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v1h-1v-1z",
    fill: "#8c381d"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M50 78v-1h1v1z",
    fill: "#eac971"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M52 77v1h-1v-1z",
    fill: "#b26f45"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M52 78v-1h1v1z",
    fill: "#a2553d"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77h1v1h-1z",
    fill: "#f3db8e"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M55 77v1h-1v-1z",
    fill: "#ae6b45"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M55 78v-1h1v1z",
    fill: "#c1825b"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M57 77v1h-1v-1z",
    fill: "#f5d39d"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h-1v-1h1z",
    fill: "#a35e42"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h-1v-1h1z",
    fill: "#e2c192"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78v-1h1v1z",
    fill: "#c5a76d"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78h-1v-1h1z",
    fill: "#d4b182"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78h-1v-1h1z",
    fill: "#e2d192"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78v-1h1v1z",
    fill: "#e9df96"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77v1h-1v-1z",
    fill: "#c1a16c"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78v-1h1v1z",
    fill: "#a95242"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M66 78h-1v-1h1z",
    fill: "#b34c55"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77v1h-1v-1z",
    fill: "#b47451"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M67 78v-1h1v1z",
    fill: "#f4cb89"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M68 77h1v1h-1z",
    fill: "#a96242"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M69 78v-1h1v1z",
    fill: "#d89d68"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h1v1h-1z",
    fill: "#d0a66b"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78h-1v-1h1z",
    fill: "#b77c50"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77h1v1h-1z",
    fill: "#e6b26f"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77v1h-1v-1z",
    fill: "#ab7142"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M74 78v-1h1v1z",
    fill: "#eaac79"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M76 77v1h-1v-1z",
    fill: "#b16241"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78v-1h1v1z",
    fill: "#b14b4e"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M77 77h1v1h-1z",
    fill: "#b34d52"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77v1h-1v-1z",
    fill: "#b24d4b"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h1v1h-1z",
    fill: "#ae4b4f"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M81 77v1h-1v-1z",
    fill: "#a64853"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M82 78h-1v-1h1z",
    fill: "#a3634a"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78h-1v-1h1z",
    fill: "#e9ce90"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v1h-1v-1z",
    fill: "#6c613b"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78v-1h1v1z",
    fill: "#373535"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78h-1v-1h1z",
    fill: "#22252a"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78v-1h1v1z",
    fill: "#28272d",
    fillOpacity: 0.929
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79v-1h1v1z",
    fill: "#474747",
    fillOpacity: 0.224
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78v1h-1v-1z",
    fill: "#373739",
    fillOpacity: 0.98
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M37 79h-1v-1h1z",
    fill: "#242528"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v1h-1v-1z",
    fill: "#1f1f1b"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78v1h-1v-1z",
    fill: "#151a13"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78h1v1h-1z",
    fill: "#201617"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M40 79v-1h1v1z",
    fill: "#7c2b2f"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M41 78h1v1h-1z",
    fill: "#b35334"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78v1h-1v-1z",
    fill: "#c87241"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78h1v1h-1z",
    fill: "#bb6731"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v1h-1v-1z",
    fill: "#d78950"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78h1v1h-1z",
    fill: "#b57836"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78v1h-1v-1z",
    fill: "#d0954f"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78h1v1h-1z",
    fill: "#cb984e"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79v-1h1v1z",
    fill: "#d0a652"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M50 79h-1v-1h1z",
    fill: "#90491f"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M51 79h-1v-1h1z",
    fill: "#f2d47b"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M52 79h-1v-1h1z",
    fill: "#a65834"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79h-1v-1h1z",
    fill: "#af6a46"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M54 78v1h-1v-1z",
    fill: "#f1d789"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79v-1h1v1z",
    fill: "#a25c36"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79h-1v-1h1z",
    fill: "#d09e71"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v-1h1v1z",
    fill: "#e6c38a"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h-1v-1h1z",
    fill: "#9d5c35"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h1v1h-1z",
    fill: "#ebdaa1"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h1v1h-1z",
    fill: "#b99360"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78v1h-1v-1z",
    fill: "#e1cc9a"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M61 79v-1h1v1z",
    fill: "#bc9162"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1z",
    fill: "#d5b57e"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M63 78h1v1h-1z",
    fill: "#c9a46d"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78h1v1h-1z",
    fill: "#ad4e42"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79h-1v-1h1z",
    fill: "#b54a55"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79v-1h1v1z",
    fill: "#c2875f"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M68 78v1h-1v-1z",
    fill: "#ecc782"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v-1h1v1z",
    fill: "#9f5937"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M70 79h-1v-1h1z",
    fill: "#e0b370"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79h-1v-1h1z",
    fill: "#c4925d"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79v-1h1v1z",
    fill: "#c98c5d"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79h-1v-1h1z",
    fill: "#d7a562"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79h-1v-1h1z",
    fill: "#b67949"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78v1h-1v-1z",
    fill: "#e5a572"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78h1v1h-1z",
    fill: "#a75837"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78h1v1h-1z",
    fill: "#af4d47"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M78 78v1h-1v-1z",
    fill: "#b44d53"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79h-1v-1h1z",
    fill: "#ad4f4a"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M80 78v1h-1v-1z",
    fill: "#b14c55"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M80 79v-1h1v1z",
    fill: "#9c4646"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M82 79h-1v-1h1z",
    fill: "#bd915c"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78v1h-1v-1z",
    fill: "#d1c489"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M83 79v-1h1v1z",
    fill: "#443e28"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78h1v1h-1z",
    fill: "#3b3738"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79h-1v-1h1z",
    fill: "#25262f"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M87 79h-1v-1h1z",
    fill: "#1a1f22"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78v1h-1v-1z",
    fill: "#1b1d1f"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78h1v1h-1z",
    fill: "#29282e",
    fillOpacity: 0.929
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M95 78v1h-1v-1z",
    fill: "#4c4c4c",
    fillOpacity: 0.157
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79h1v1h-1z",
    fill: "#5e5e5e",
    fillOpacity: 0.212
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M34 80v-1h1v1z",
    fill: "#3c3c3e",
    fillOpacity: 0.973
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M39 79h1v1h-1z",
    fill: "#1f141c"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79v1h-1v-1z",
    fill: "#7c2a31"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79h1v1h-1z",
    fill: "#bb5843"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79v1h-1v-1z",
    fill: "#b8603f"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M43 80v-1h1v1z",
    fill: "#b55f3b"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79v1h-1v-1z",
    fill: "#b15f39"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79h1v1h-1z",
    fill: "#c98451"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M47 80h-1v-1h1z",
    fill: "#c57e48"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M47 79h1v1h-1z",
    fill: "#b67e3a"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M49 79v1h-1v-1z",
    fill: "#efce79"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M49 80v-1h1v1z",
    fill: "#e6bc77"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80v-1h1v1z",
    fill: "#d9b268"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M52 80h-1v-1h1z",
    fill: "#8e3c1f"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79v1h-1v-1z",
    fill: "#c38a5e"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h-1v-1h1z",
    fill: "#ebc98b"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79h1v1h-1z",
    fill: "#9f4c3e"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v1h-1v-1z",
    fill: "#d29872"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80h-1v-1h1z",
    fill: "#efda91"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v1h-1v-1z",
    fill: "#ceae6b"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h1v1h-1z",
    fill: "#efdda0"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M60 79v1h-1v-1z",
    fill: "#a87b4d"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80v-1h1v1z",
    fill: "#f4dcac"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80h-1v-1h1z",
    fill: "#ad8054"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M63 79v1h-1v-1z",
    fill: "#cea977"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80v-1h1v1z",
    fill: "#e1bc89"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M64 80v-1h1v1z",
    fill: "#ac4b46"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M65 79h1v1h-1z",
    fill: "#b24952"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80h-1v-1h1z",
    fill: "#ca9168"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v1h-1v-1z",
    fill: "#e6c87b"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h-1v-1h1z",
    fill: "#ae8148"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h-1v-1h1z",
    fill: "#eec67e"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h-1v-1h1z",
    fill: "#b87944"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M72 79v1h-1v-1z",
    fill: "#d2a369"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79v1h-1v-1z",
    fill: "#ca9752"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79v1h-1v-1z",
    fill: "#c68b52"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v-1h1v1z",
    fill: "#daa868"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M75 79h1v1h-1z",
    fill: "#b06d40"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M76 79h1v1h-1z",
    fill: "#b5604e"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80v-1h1v1z",
    fill: "#ae4e50"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79v1h-1v-1z",
    fill: "#b04c56"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v-1h1v1z",
    fill: "#a94c53"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M81 79v1h-1v-1z",
    fill: "#9a5a40"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80h-1v-1h1z",
    fill: "#e7ce8b"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80v-1h1v1z",
    fill: "#918b5b"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79v1h-1v-1z",
    fill: "#353025"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79h1v1h-1z",
    fill: "#3c383a"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79v1h-1v-1z",
    fill: "#26262b"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80v-1h1v1z",
    fill: "#1b1f1d"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M93 79h1v1h-1z",
    fill: "#29292e",
    fillOpacity: 0.933
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M95 80h-1v-1h1z",
    fill: "#4a4a50",
    fillOpacity: 0.161
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81h-1v-1h1z",
    fill: "#696969",
    fillOpacity: 0.208
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M38 80v1h-1v-1z",
    fill: "#1e1e1a"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M38 81v-1h1v1z",
    fill: "#141819"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80v1h-1v-1z",
    fill: "#1d131b"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81v-1h1v1z",
    fill: "#7d2d2d"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M41 81v-1h1v1z",
    fill: "#a32d23"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81h-1v-1h1z",
    fill: "#9e2d25"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81v-1h1v1z",
    fill: "#9a2f27"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M45 80v1h-1v-1z",
    fill: "#9c3023"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81v-1h1v1z",
    fill: "#a33826"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81h-1v-1h1z",
    fill: "#a3362a"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81v-1h1v1z",
    fill: "#94321a"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M49 81h-1v-1h1z",
    fill: "#ab5e36"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81h-1v-1h1z",
    fill: "#b26b41"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81v-1h1v1z",
    fill: "#924221"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81h-1v-1h1z",
    fill: "#98352a"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81v-1h1v1z",
    fill: "#b36549"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81h-1v-1h1z",
    fill: "#bf795a"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h1v1h-1z",
    fill: "#b14753"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81h-1v-1h1z",
    fill: "#ad5352"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80v1h-1v-1z",
    fill: "#cb9d75"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M57 81v-1h1v1z",
    fill: "#d7aa84"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80h1v1h-1z",
    fill: "#b27763"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M60 81h-1v-1h1z",
    fill: "#a85f52"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80h1v1h-1z",
    fill: "#d5a08b"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80v1h-1v-1z",
    fill: "#a3634f"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M63 81h-1v-1h1z",
    fill: "#b87e68"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80h1v1h-1z",
    fill: "#d89d87"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h-1v-1h1z",
    fill: "#b04c52"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M65 80h1v1h-1z",
    fill: "#b14954"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80v1h-1v-1z",
    fill: "#ad664f"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81v-1h1v1z",
    fill: "#dfb17c"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M69 81h-1v-1h1z",
    fill: "#e8ba8a"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h1v1h-1z",
    fill: "#cb936a"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h1v1h-1z",
    fill: "#ab553c"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h1v1h-1z",
    fill: "#dba07f"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M72 80h1v1h-1z",
    fill: "#be7d57"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v1h-1v-1z",
    fill: "#cf895f"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80h1v1h-1z",
    fill: "#e0a770"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M76 80v1h-1v-1z",
    fill: "#e6a276"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M76 81v-1h1v1z",
    fill: "#ce7d65"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80h1v1h-1z",
    fill: "#aa4f4a"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v1h-1v-1z",
    fill: "#b04f5b"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M79 81v-1h1v1z",
    fill: "#974e45"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M81 80v1h-1v-1z",
    fill: "#c29f67"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M82 81h-1v-1h1z",
    fill: "#dad290"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81h-1v-1h1z",
    fill: "#4b482e"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81v-1h1v1z",
    fill: "#353130"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M84 80h1v1h-1z",
    fill: "#393638"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80v1h-1v-1z",
    fill: "#252425"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80h1v1h-1z",
    fill: "#1d1e1b"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M91 80h1v1h-1z",
    fill: "#27262a"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M94 81h-1v-1h1z",
    fill: "#2b2a30",
    fillOpacity: 0.933
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M94 80h1v1h-1z",
    fill: "#505057",
    fillOpacity: 0.161
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81v1h-1v-1z",
    fill: "#6b6b6b",
    fillOpacity: 0.204
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82h-1v-1h1z",
    fill: "#201f20"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h-1v-1h1z",
    fill: "#14181b"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82v-1h1v1z",
    fill: "#1e1516"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81h1v1h-1z",
    fill: "#ad5f4e"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82v-1h1v1z",
    fill: "#d95f43"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v-1h1v1z",
    fill: "#cd5741"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M44 81v1h-1v-1z",
    fill: "#c35544"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M44 82v-1h1v1z",
    fill: "#c5553e"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81h1v1h-1z",
    fill: "#c75036"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#c14935"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h-1v-1h1z",
    fill: "#be4631"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M48 81h1v1h-1z",
    fill: "#b8422e"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82h-1v-1h1z",
    fill: "#b5412b"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M51 81v1h-1v-1z",
    fill: "#b5422b"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M51 82v-1h1v1z",
    fill: "#b64532"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M53 82h-1v-1h1z",
    fill: "#b64a36"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81v1h-1v-1z",
    fill: "#b64c37"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82v-1h1v1z",
    fill: "#c3524c"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81v1h-1v-1z",
    fill: "#bc4e4a"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M57 82h-1v-1h1z",
    fill: "#aa513c"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81v1h-1v-1z",
    fill: "#ac5042"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82v-1h1v1z",
    fill: "#b24f46"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M59 82v-1h1v1z",
    fill: "#b35446"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v-1h1v1z",
    fill: "#af4d43"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h-1v-1h1z",
    fill: "#b25248"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M63 82h-1v-1h1z",
    fill: "#af5146"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M64 82h-1v-1h1z",
    fill: "#ad5045"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81v1h-1v-1z",
    fill: "#b5504a"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M66 81v1h-1v-1z",
    fill: "#b44f4a"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h-1v-1h1z",
    fill: "#af5147"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81h1v1h-1z",
    fill: "#a9543f"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M68 82v-1h1v1z",
    fill: "#ac573d"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82h-1v-1h1z",
    fill: "#aa5141"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82v-1h1v1z",
    fill: "#b14e44"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M72 81v1h-1v-1z",
    fill: "#b05046"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M73 81v1h-1v-1z",
    fill: "#a85444"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M74 82h-1v-1h1z",
    fill: "#ae5341"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M75 81v1h-1v-1z",
    fill: "#ab543c"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82v-1h1v1z",
    fill: "#af563b"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M77 81v1h-1v-1z",
    fill: "#af533f"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M78 81v1h-1v-1z",
    fill: "#ae5146"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h-1v-1h1z",
    fill: "#a24e48"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M80 81v1h-1v-1z",
    fill: "#a77353"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h-1v-1h1z",
    fill: "#efe093"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M81 81h1v1h-1z",
    fill: "#878155"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M82 82v-1h1v1z",
    fill: "#322c2d"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h-1v-1h1z",
    fill: "#323132"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M85 81v1h-1v-1z",
    fill: "#353334"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M85 82v-1h1v1z",
    fill: "#252224"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M87 82h-1v-1h1z",
    fill: "#1e1b1d"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M93 81h1v1h-1z",
    fill: "#2d2c31",
    fillOpacity: 0.937
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M94 81h1v1h-1z",
    fill: "#554e55",
    fillOpacity: 0.165
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M33 83v-1h1v1z",
    fill: "#6b6b6b",
    fillOpacity: 0.196
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M38 83v-1h1v1z",
    fill: "#15191a"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h1v1h-1z",
    fill: "#1d1514"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M41 83h-1v-1h1z",
    fill: "#bb6f50"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v1h-1v-1z",
    fill: "#e97d4c"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82h1v1h-1z",
    fill: "#e7a17f"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M44 83h-1v-1h1z",
    fill: "#ebbaa0"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82v1h-1v-1z",
    fill: "#eda17a"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82h1v1h-1z",
    fill: "#e17c52"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M47 83h-1v-1h1z",
    fill: "#e59d7b"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M48 83h-1v-1h1z",
    fill: "#eb9679"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h1v1h-1z",
    fill: "#ea7951"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82v1h-1v-1z",
    fill: "#eb8b6f"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83v-1h1v1z",
    fill: "#e7957b"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M52 82v1h-1v-1z",
    fill: "#e98d6a"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83v-1h1v1z",
    fill: "#f17f5d"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M53 83v-1h1v1z",
    fill: "#f18363"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82h1v1h-1z",
    fill: "#e68d70"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M55 82h1v1h-1z",
    fill: "#de9578"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M56 82h1v1h-1z",
    fill: "#e48e72"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83h-1v-1h1z",
    fill: "#e58b6a"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h1v1h-1z",
    fill: "#e68766"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v1h-1v-1z",
    fill: "#e28769"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82h1v1h-1z",
    fill: "#e3846b"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M61 82h1v1h-1z",
    fill: "#e18361"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h1v1h-1z",
    fill: "#eb7d5f"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83v-1h1v1z",
    fill: "#eb7960"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M64 83v-1h1v1z",
    fill: "#da7e60"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83h-1v-1h1z",
    fill: "#d88067"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M66 82h1v1h-1z",
    fill: "#dd7862"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h1v1h-1z",
    fill: "#dd775f"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M69 82v1h-1v-1z",
    fill: "#d57b62"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83v-1h1v1z",
    fill: "#d17c63"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M70 83v-1h1v1z",
    fill: "#dc775f"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M72 83h-1v-1h1z",
    fill: "#e37259"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M72 82h1v1h-1z",
    fill: "#d77759"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M73 82h1v1h-1z",
    fill: "#d77459"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83v-1h1v1z",
    fill: "#da7158"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82h1v1h-1z",
    fill: "#db7157"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M76 82h1v1h-1z",
    fill: "#db7359"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M78 83h-1v-1h1z",
    fill: "#cf7058"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82v1h-1v-1z",
    fill: "#ab6d4a"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h1v1h-1z",
    fill: "#e3c486"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h-1v-1h1z",
    fill: "#c6be7d"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h1v1h-1z",
    fill: "#3d3824"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83h-1v-1h1z",
    fill: "#343035"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82v1h-1v-1z",
    fill: "#333231"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h1v1h-1z",
    fill: "#343233"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M86 83v-1h1v1z",
    fill: "#1d1c20"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M93 83v-1h1v1z",
    fill: "#302e34",
    fillOpacity: 0.937
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M94 82h1v1h-1z",
    fill: "#555",
    fillOpacity: 0.165
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M33 84v-1h1v1z",
    fill: "#6d6d6d",
    fillOpacity: 0.192
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h-1v-1h1z",
    fill: "#424244",
    fillOpacity: 0.957
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84v-1h1v1z",
    fill: "#20201d"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h-1v-1h1z",
    fill: "#b66947"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83v1h-1v-1z",
    fill: "#e27e4d"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83h1v1h-1z",
    fill: "#f5cfb8"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M44 84h-1v-1h1z",
    fill: "#d1c2b3"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M45 84h-1v-1h1z",
    fill: "#e2ae90"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M45 83h1v1h-1z",
    fill: "#d5896a"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M46 84v-1h1v1z",
    fill: "#ead7bd"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M47 84v-1h1v1z",
    fill: "#ead0ba"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v-1h1v1z",
    fill: "#cd8555"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M49 83h1v1h-1z",
    fill: "#f2d2b3"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83h1v1h-1z",
    fill: "#decab9"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M51 83h1v1h-1z",
    fill: "#e4b28b"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83h1v1h-1z",
    fill: "#e88549"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84v-1h1v1z",
    fill: "#e38d5d"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M55 83v1h-1v-1z",
    fill: "#f2c8b2"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84v-1h1v1z",
    fill: "#e2d2b8"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84v-1h1v1z",
    fill: "#dbb59b"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83v1h-1v-1z",
    fill: "#e8c19b"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83v1h-1v-1z",
    fill: "#dfb493"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83h1v1h-1z",
    fill: "#f2ccb2"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84v-1h1v1z",
    fill: "#d5b190"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84h-1v-1h1z",
    fill: "#f1c49f"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M62 83h1v1h-1z",
    fill: "#e8916e"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83h1v1h-1z",
    fill: "#e98a65"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M65 84h-1v-1h1z",
    fill: "#eeba96"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83v1h-1v-1z",
    fill: "#eeccb6"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84v-1h1v1z",
    fill: "#e8b79f"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v1h-1v-1z",
    fill: "#dca485"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M69 84h-1v-1h1z",
    fill: "#efc9b0"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83h1v1h-1z",
    fill: "#efc0a6"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M71 83v1h-1v-1z",
    fill: "#ea9270"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84v-1h1v1z",
    fill: "#f5895e"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M72 84v-1h1v1z",
    fill: "#f38c5b"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84v-1h1v1z",
    fill: "#f18d5c"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83h1v1h-1z",
    fill: "#f7895e"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M76 83v1h-1v-1z",
    fill: "#fb8761"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84v-1h1v1z",
    fill: "#ef8a63"
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v-1h1v1z",
    fill: "#d08558"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84h-1v-1h1z",
    fill: "#bc985b"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M79 83h1v1h-1z",
    fill: "#e4d591"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M80 84v-1h1v1z",
    fill: "#575333"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83v1h-1v-1z",
    fill: "#302f2d"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84h-1v-1h1z",
    fill: "#2d2c2a"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M85 84h-1v-1h1z",
    fill: "#2e2d2d"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M93 83h1v1h-1z",
    fill: "#313135",
    fillOpacity: 0.937
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M94 84v-1h1v1z",
    fill: "#585858",
    fillOpacity: 0.169
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84v1h-1v-1z",
    fill: "#747474",
    fillOpacity: 0.188
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v1h-1v-1z",
    fill: "#21201d"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84v1h-1v-1z",
    fill: "#b46846"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h1v1h-1z",
    fill: "#e0895a"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84v1h-1v-1z",
    fill: "#d6b59d"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84h1v1h-1z",
    fill: "#d7c9b9"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85h-1v-1h1z",
    fill: "#dfbba5"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85h-1v-1h1z",
    fill: "#ddb19e"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M47 85h-1v-1h1z",
    fill: "#e1cab8"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v1h-1v-1z",
    fill: "#e4d1c3"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85v-1h1v1z",
    fill: "#ca947b"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85h-1v-1h1z",
    fill: "#e8ddcc"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M50 84h1v1h-1z",
    fill: "#d4bea7"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M51 84h1v1h-1z",
    fill: "#dd9c77"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M53 85h-1v-1h1z",
    fill: "#f47857"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84h1v1h-1z",
    fill: "#ea8968"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85v-1h1v1z",
    fill: "#e9c9ad"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84h1v1h-1z",
    fill: "#e2d0c1"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84h1v1h-1z",
    fill: "#d7b6a3"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M58 84v1h-1v-1z",
    fill: "#e0c7b5"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M59 85h-1v-1h1z",
    fill: "#dec7c0"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M60 85h-1v-1h1z",
    fill: "#eaded2"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M61 85h-1v-1h1z",
    fill: "#d6cdba"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84v1h-1v-1z",
    fill: "#eac8ba"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85v-1h1v1z",
    fill: "#de9382"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M63 85v-1h1v1z",
    fill: "#e19371"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v-1h1v1z",
    fill: "#dbac91"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M66 85h-1v-1h1z",
    fill: "#dec4bd"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84h1v1h-1z",
    fill: "#e2c4bd"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v-1h1v1z",
    fill: "#e9c5b2"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M68 84h1v1h-1z",
    fill: "#d1b6a7"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v-1h1v1z",
    fill: "#edd3c4"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M71 85h-1v-1h1z",
    fill: "#e69e7d"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84h1v1h-1z",
    fill: "#f08958"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M72 85v-1h1v1z",
    fill: "#f48951"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84h1v1h-1z",
    fill: "#f18953"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M75 84v1h-1v-1z",
    fill: "#f68657"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85v-1h1v1z",
    fill: "#f6865d"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v1h-1v-1z",
    fill: "#d08153"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v-1h1v1z",
    fill: "#caa168"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84v1h-1v-1z",
    fill: "#efdf9d"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v-1h1v1z",
    fill: "#777249"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85h-1v-1h1z",
    fill: "#2a2c21"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85v-1h1v1z",
    fill: "#2c3131"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M82 85v-1h1v1z",
    fill: "#2b2a29"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84v1h-1v-1z",
    fill: "#2a2525"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85v-1h1v1z",
    fill: "#2a2727"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M93 85v-1h1v1z",
    fill: "#313035",
    fillOpacity: 0.941
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M94 84h1v1h-1z",
    fill: "#565656",
    fillOpacity: 0.173
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M34 86h-1v-1h1z",
    fill: "#797979",
    fillOpacity: 0.18
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86h-1v-1h1z",
    fill: "#1e1416"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v-1h1v1z",
    fill: "#b36745"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M41 85h1v1h-1z",
    fill: "#e1905f"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M43 86h-1v-1h1z",
    fill: "#ecc6a5"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M44 86h-1v-1h1z",
    fill: "#e6c8aa"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85v1h-1v-1z",
    fill: "#ddb193"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85v1h-1v-1z",
    fill: "#ecc5ae"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M47 86h-1v-1h1z",
    fill: "#dab497"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86h-1v-1h1z",
    fill: "#f0cfbb"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85h1v1h-1z",
    fill: "#d6a791"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85v1h-1v-1z",
    fill: "#ebe0cc"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h-1v-1h1z",
    fill: "#d8bca2"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86v-1h1v1z",
    fill: "#db946a"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86v-1h1v1z",
    fill: "#f07b47"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86h-1v-1h1z",
    fill: "#e99267"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85h1v1h-1z",
    fill: "#debea8"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M55 85h1v1h-1z",
    fill: "#dec7b7"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M57 85v1h-1v-1z",
    fill: "#e1bd9c"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86v-1h1v1z",
    fill: "#e2cab3"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M58 85h1v1h-1z",
    fill: "#f1dad1"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M59 86v-1h1v1z",
    fill: "#d6ccb9"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M61 86h-1v-1h1z",
    fill: "#ecebd1"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M62 86h-1v-1h1z",
    fill: "#d4b399"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85h1v1h-1z",
    fill: "#efba9d"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v1h-1v-1z",
    fill: "#dfaf86"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86h-1v-1h1z",
    fill: "#d6b292"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M66 86h-1v-1h1z",
    fill: "#e5ccba"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v1h-1v-1z",
    fill: "#ddbda7"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85h1v1h-1z",
    fill: "#f0d2b5"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v1h-1v-1z",
    fill: "#c7b39f"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85h1v1h-1z",
    fill: "#f0d2bf"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M70 85h1v1h-1z",
    fill: "#df946b"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v-1h1v1z",
    fill: "#f28854"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M73 85v1h-1v-1z",
    fill: "#f68756"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v-1h1v1z",
    fill: "#f28a58"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M74 85h1v1h-1z",
    fill: "#ed8a59"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85h1v1h-1z",
    fill: "#db895c"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v1h-1v-1z",
    fill: "#a7774b"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M78 86h-1v-1h1z",
    fill: "#cab985"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v1h-1v-1z",
    fill: "#8b865e"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85h1v1h-1z",
    fill: "#2b2922"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M80 85h1v1h-1z",
    fill: "#2f3233"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M81 86v-1h1v1z",
    fill: "#2e312e"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M83 86h-1v-1h1z",
    fill: "#312d2c"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M83 85h1v1h-1z",
    fill: "#312b2b"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85h1v1h-1z",
    fill: "#2f2b2c"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v-1h1v1z",
    fill: "#232022"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M86 85h1v1h-1z",
    fill: "#1e1d20"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M94 85v1h-1v-1z",
    fill: "#323137",
    fillOpacity: 0.945
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M94 85h1v1h-1z",
    fill: "#55555a",
    fillOpacity: 0.176
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86h1v1h-1z",
    fill: "#828282",
    fillOpacity: 0.169
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M34 87v-1h1v1z",
    fill: "#454547",
    fillOpacity: 0.941
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v1h-1v-1z",
    fill: "#1d1517"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M41 86v1h-1v-1z",
    fill: "#b56948"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v-1h1v1z",
    fill: "#e57c46"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v-1h1v1z",
    fill: "#d47d50"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v-1h1v1z",
    fill: "#d67f51"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M44 87v-1h1v1z",
    fill: "#d87a4a"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v-1h1v1z",
    fill: "#d97d56"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87v-1h1v1z",
    fill: "#d47844"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86v1h-1v-1z",
    fill: "#e0815a"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M49 86v1h-1v-1z",
    fill: "#dd865f"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87h-1v-1h1z",
    fill: "#db9771"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M50 86h1v1h-1z",
    fill: "#e39974"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h1v1h-1z",
    fill: "#e5855a"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86h1v1h-1z",
    fill: "#f17b43"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86v1h-1v-1z",
    fill: "#e98a5c"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M55 86v1h-1v-1z",
    fill: "#ebae96"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87v-1h1v1z",
    fill: "#ebaf99"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87h-1v-1h1z",
    fill: "#dd9565"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86v1h-1v-1z",
    fill: "#e7ac86"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86h1v1h-1z",
    fill: "#ebac94"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87v-1h1v1z",
    fill: "#e2a78a"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M60 87v-1h1v1z",
    fill: "#f3be9f"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M62 87h-1v-1h1z",
    fill: "#e19569"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M63 86v1h-1v-1z",
    fill: "#e88c60"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87v-1h1v1z",
    fill: "#e09c74"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86v1h-1v-1z",
    fill: "#f2c8ac"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M65 87v-1h1v1z",
    fill: "#ecc1a8"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h-1v-1h1z",
    fill: "#db9e7a"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M68 86v1h-1v-1z",
    fill: "#eebd9c"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M68 87v-1h1v1z",
    fill: "#efcebb"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M70 86v1h-1v-1z",
    fill: "#e6ae91"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v1h-1v-1z",
    fill: "#e58a5a"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M72 86v1h-1v-1z",
    fill: "#f68652"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v1h-1v-1z",
    fill: "#f4855e"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87h-1v-1h1z",
    fill: "#e8845b"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87h-1v-1h1z",
    fill: "#de9061"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87v-1h1v1z",
    fill: "#b6855a"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87v-1h1v1z",
    fill: "#a58d66"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M77 86h1v1h-1z",
    fill: "#847655"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M79 87h-1v-1h1z",
    fill: "#373028"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M79 86h1v1h-1z",
    fill: "#332f3b"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M82 86v1h-1v-1z",
    fill: "#312f26"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M83 87h-1v-1h1z",
    fill: "#393231"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M84 87h-1v-1h1z",
    fill: "#3a3334"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v1h-1v-1z",
    fill: "#383334"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86h1v1h-1z",
    fill: "#262124"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87h-1v-1h1z",
    fill: "#333236",
    fillOpacity: 0.949
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87v-1h1v1z",
    fill: "#56565c",
    fillOpacity: 0.184
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88v-1h1v1z",
    fill: "#828289",
    fillOpacity: 0.145
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88h-1v-1h1z",
    fill: "#444447",
    fillOpacity: 0.929
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M40 88h-1v-1h1z",
    fill: "#1d1612"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v1h-1v-1z",
    fill: "#b36847"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v1h-1v-1z",
    fill: "#df8752"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v1h-1v-1z",
    fill: "#e9ab7c"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M43 88v-1h1v1z",
    fill: "#e1a782"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v1h-1v-1z",
    fill: "#e0a37d"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88v-1h1v1z",
    fill: "#e39e76"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h-1v-1h1z",
    fill: "#e49870"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88h-1v-1h1z",
    fill: "#e29268"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M49 88h-1v-1h1z",
    fill: "#dc8a5e"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87v1h-1v-1z",
    fill: "#df8e64"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88v-1h1v1z",
    fill: "#e08761"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M51 87h1v1h-1z",
    fill: "#df845a"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M53 87v1h-1v-1z",
    fill: "#e48f63"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M53 88v-1h1v1z",
    fill: "#df936c"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M55 88h-1v-1h1z",
    fill: "#dd986c"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87h1v1h-1z",
    fill: "#e19171"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87v1h-1v-1z",
    fill: "#e59670"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M57 88v-1h1v1z",
    fill: "#e19168"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88h-1v-1h1z",
    fill: "#e68f65"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87h1v1h-1z",
    fill: "#e48e67"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M60 88v-1h1v1z",
    fill: "#e08e6a"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M61 87h1v1h-1z",
    fill: "#e78f67"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M62 88v-1h1v1z",
    fill: "#ed8c5f"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M64 87v1h-1v-1z",
    fill: "#ec8856"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M64 88v-1h1v1z",
    fill: "#e7895f"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v-1h1v1z",
    fill: "#e78961"
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87v1h-1v-1z",
    fill: "#ea8b64"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87h1v1h-1z",
    fill: "#eb855f"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87v1h-1v-1z",
    fill: "#f68557"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87h1v1h-1z",
    fill: "#f58654"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M72 87h1v1h-1z",
    fill: "#e58252"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87v1h-1v-1z",
    fill: "#d68e52"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88v-1h1v1z",
    fill: "#d5a66d"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M75 88v-1h1v1z",
    fill: "#b3996b"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87h1v1h-1z",
    fill: "#786d4b"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M78 88h-1v-1h1z",
    fill: "#342c21"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h-1v-1h1z",
    fill: "#393235"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88v-1h1v1z",
    fill: "#3b3539"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M80 87h1v1h-1z",
    fill: "#363132"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M82 88h-1v-1h1z",
    fill: "#363131"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M83 88h-1v-1h1z",
    fill: "#3d3637"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M84 87v1h-1v-1z",
    fill: "#3e3737"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M85 87v1h-1v-1z",
    fill: "#3d3738"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M86 88h-1v-1h1z",
    fill: "#272125"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M93 87h1v1h-1z",
    fill: "#343337",
    fillOpacity: 0.953
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87h1v1h-1z",
    fill: "#5c5c61",
    fillOpacity: 0.184
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M34 88v1h-1v-1z",
    fill: "#717171",
    fillOpacity: 0.141
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v1h-1v-1z",
    fill: "#3d3d3f",
    fillOpacity: 0.929
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h-1v-1h1z",
    fill: "#b26747"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89h-1v-1h1z",
    fill: "#e18556"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89v-1h1v1z",
    fill: "#dc946b"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M44 88v1h-1v-1z",
    fill: "#dea27f"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M45 89h-1v-1h1z",
    fill: "#e3ab86"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88h1v1h-1z",
    fill: "#e3a983"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88v1h-1v-1z",
    fill: "#ebb79c"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h1v1h-1z",
    fill: "#deac8d"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v-1h1v1z",
    fill: "#deae8c"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89v-1h1v1z",
    fill: "#e3b494"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88v1h-1v-1z",
    fill: "#f0bf9f"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88h1v1h-1z",
    fill: "#cc9971"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h-1v-1h1z",
    fill: "#edc19d"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v-1h1v1z",
    fill: "#e4bfa3"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89h-1v-1h1z",
    fill: "#e2bf9e"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h-1v-1h1z",
    fill: "#e1b39a"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89v-1h1v1z",
    fill: "#e4b79d"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89h-1v-1h1z",
    fill: "#ebbd9e"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88v1h-1v-1z",
    fill: "#efbd9b"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v-1h1v1z",
    fill: "#d5a281"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v-1h1v1z",
    fill: "#e8c09d"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M62 89h-1v-1h1z",
    fill: "#e3ba93"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M63 89h-1v-1h1z",
    fill: "#e6a37a"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M63 88h1v1h-1z",
    fill: "#f0875d"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v1h-1v-1z",
    fill: "#f6855c"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M66 88v1h-1v-1z",
    fill: "#f5855d"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h-1v-1h1z",
    fill: "#f48458"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89v-1h1v1z",
    fill: "#ed805e"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M71 88h1v1h-1z",
    fill: "#d47c52"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M73 88v1h-1v-1z",
    fill: "#ce904f"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M74 89h-1v-1h1z",
    fill: "#e5c26e"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88h1v1h-1z",
    fill: "#c8b074"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M76 88v1h-1v-1z",
    fill: "#615134"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M76 88h1v1h-1z",
    fill: "#3a3121"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v-1h1v1z",
    fill: "#372d2b"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h1v1h-1z",
    fill: "#3a3233"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89v-1h1v1z",
    fill: "#372e30"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M81 88h1v1h-1z",
    fill: "#342c2d"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M82 88h1v1h-1z",
    fill: "#382f30"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89h-1v-1h1z",
    fill: "#393131"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M85 88v1h-1v-1z",
    fill: "#373133"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89h-1v-1h1z",
    fill: "#353439",
    fillOpacity: 0.953
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89v-1h1v1z",
    fill: "#5f5f5f",
    fillOpacity: 0.188
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M34 90h-1v-1h1z",
    fill: "#6f6f77",
    fillOpacity: 0.125
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M34 89h1v1h-1z",
    fill: "#3c3c3d",
    fillOpacity: 0.914
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M40 89v1h-1v-1z",
    fill: "#1f1712"
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90v-1h1v1z",
    fill: "#b26846"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h1v1h-1z",
    fill: "#f47544"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M43 90h-1v-1h1z",
    fill: "#ee6f40"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89v1h-1v-1z",
    fill: "#e67345"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h-1v-1h1z",
    fill: "#e27645"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M46 89v1h-1v-1z",
    fill: "#e27745"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M47 89v1h-1v-1z",
    fill: "#e37646"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v1h-1v-1z",
    fill: "#e27944"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M48 90v-1h1v1z",
    fill: "#e07c45"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89h1v1h-1z",
    fill: "#df7e4a"
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M50 89h1v1h-1z",
    fill: "#e48153"
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M52 90h-1v-1h1z",
    fill: "#e38050"
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v1h-1v-1z",
    fill: "#e8895e"
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h1v1h-1z",
    fill: "#e78b6b"
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89v1h-1v-1z",
    fill: "#e8906b"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M55 90v-1h1v1z",
    fill: "#e3936c"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h1v1h-1z",
    fill: "#e1966d"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89v1h-1v-1z",
    fill: "#e39a6f"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v1h-1v-1z",
    fill: "#e3986d"
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v1h-1v-1z",
    fill: "#e4926e"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90v-1h1v1z",
    fill: "#e59b7c"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M61 89h1v1h-1z",
    fill: "#dca27a"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90h-1v-1h1z",
    fill: "#e59e71"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v-1h1v1z",
    fill: "#f4865b"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M65 89v1h-1v-1z",
    fill: "#fa8356"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89v1h-1v-1z",
    fill: "#f78457"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89h1v1h-1z",
    fill: "#f08356"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90v-1h1v1z",
    fill: "#e78055"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h-1v-1h1z",
    fill: "#e07d50"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v-1h1v1z",
    fill: "#d97d52"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h1v1h-1z",
    fill: "#ca7c5d"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M71 89h1v1h-1z",
    fill: "#c08f64"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M72 90v-1h1v1z",
    fill: "#cdb468"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M73 89h1v1h-1z",
    fill: "#d4c873"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M74 90v-1h1v1z",
    fill: "#7d7244"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M76 89v1h-1v-1z",
    fill: "#342b22"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v1h-1v-1z",
    fill: "#372d2d"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M77 90v-1h1v1z",
    fill: "#392d30"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M79 90v-1h1v1z",
    fill: "#3b3131"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M82 90h-1v-1h1z",
    fill: "#382e2e"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90h-1v-1h1z",
    fill: "#332728"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89v1h-1v-1z",
    fill: "#352a2b"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89h1v1h-1z",
    fill: "#332c2e"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M85 89h1v1h-1z",
    fill: "#222022"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M93 89v1h-1v-1z",
    fill: "#2d2b31"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M93 90v-1h1v1z",
    fill: "#36353a",
    fillOpacity: 0.957
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M33 91v-1h1v1z",
    fill: "#93939c",
    fillOpacity: 0.102
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M35 90v1h-1v-1z",
    fill: "#4c4c4f",
    fillOpacity: 0.898
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M36 90v1h-1v-1z",
    fill: "#343437"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90v1h-1v-1z",
    fill: "#222021"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90h1v1h-1z",
    fill: "#b16746"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M42 91h-1v-1h1z",
    fill: "#ef7840"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90h1v1h-1z",
    fill: "#ee7439"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v-1h1v1z",
    fill: "#ee7538"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90h1v1h-1z",
    fill: "#eb7639"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h1v1h-1z",
    fill: "#eb763c"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M47 90v1h-1v-1z",
    fill: "#ee7540"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91h-1v-1h1z",
    fill: "#ee753d"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M49 90v1h-1v-1z",
    fill: "#ec733c"
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v-1h1v1z",
    fill: "#ef7444"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M50 91v-1h1v1z",
    fill: "#f07744"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91v-1h1v1z",
    fill: "#f07a3c"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90v1h-1v-1z",
    fill: "#ef7b40"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90v1h-1v-1z",
    fill: "#f4814f"
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90h1v1h-1z",
    fill: "#f5824b"
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91h-1v-1h1z",
    fill: "#f8814e"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90v1h-1v-1z",
    fill: "#f4824f"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91h-1v-1h1z",
    fill: "#f38552"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v-1h1v1z",
    fill: "#f38551"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M59 90h1v1h-1z",
    fill: "#f78454"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90h1v1h-1z",
    fill: "#f68358"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M62 90v1h-1v-1z",
    fill: "#f1885d"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v1h-1v-1z",
    fill: "#eb895b"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M64 91h-1v-1h1z",
    fill: "#eb8858"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91h-1v-1h1z",
    fill: "#df8457"
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v-1h1v1z",
    fill: "#d28055"
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M66 90h1v1h-1z",
    fill: "#d0895f"
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90h1v1h-1z",
    fill: "#ca8f68"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v1h-1v-1z",
    fill: "#c5916e"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h1v1h-1z",
    fill: "#bb9273"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M71 90v1h-1v-1z",
    fill: "#a4865d"
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M71 91v-1h1v1z",
    fill: "#ae9a60"
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M72 91v-1h1v1z",
    fill: "#ded088"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M73 91v-1h1v1z",
    fill: "#8b7c49"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91h-1v-1h1z",
    fill: "#3e3120"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M75 90h1v1h-1z",
    fill: "#38302e"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M77 91h-1v-1h1z",
    fill: "#37302f"
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M78 90v1h-1v-1z",
    fill: "#3a2f33"
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M79 91h-1v-1h1z",
    fill: "#3f3232"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M80 90v1h-1v-1z",
    fill: "#3f3332"
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M80 91v-1h1v1z",
    fill: "#3f3231"
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M81 90h1v1h-1z",
    fill: "#3b2e2d"
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90v1h-1v-1z",
    fill: "#392a2b"
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M83 91v-1h1v1z",
    fill: "#392b2e"
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91h-1v-1h1z",
    fill: "#342c2e"
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M87 91h-1v-1h1z",
    fill: "#181d1e"
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M93 90h1v1h-1z",
    fill: "#37363b",
    fillOpacity: 0.957
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M33 91h1v1h-1z",
    fill: "#949494",
    fillOpacity: 0.094
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M34 92v-1h1v1z",
    fill: "#4e4e50",
    fillOpacity: 0.89
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M36 92h-1v-1h1z",
    fill: "#373738"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M39 92h-1v-1h1z",
    fill: "#15181a"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M40 91h1v1h-1z",
    fill: "#af6545"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92v-1h1v1z",
    fill: "#ee7747"
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-1v-1z",
    fill: "#ed7340"
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92h-1v-1h1z",
    fill: "#ed743e"
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92v-1h1v1z",
    fill: "#ed7440"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M45 91h1v1h-1z",
    fill: "#ec7541"
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M46 92v-1h1v1z",
    fill: "#e8773a"
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91v1h-1v-1z",
    fill: "#ea763b"
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v1h-1v-1z",
    fill: "#ed763e"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92h-1v-1h1z",
    fill: "#ee753f"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M51 92h-1v-1h1z",
    fill: "#ef7643"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91h1v1h-1z",
    fill: "#f17844"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M53 91v1h-1v-1z",
    fill: "#f37a49"
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#f57c4f"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M55 91v1h-1v-1z",
    fill: "#f57f4f"
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91v1h-1v-1z",
    fill: "#f28254"
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92v-1h1v1z",
    fill: "#f08456"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v-1z",
    fill: "#ef8556"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91v1h-1v-1z",
    fill: "#f08754"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91h1v1h-1z",
    fill: "#e4844a"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v-1h1v1z",
    fill: "#d37b46"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92h-1v-1h1z",
    fill: "#c87f4e"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92v-1h1v1z",
    fill: "#c3865a"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v1h-1v-1z",
    fill: "#b98c69"
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M66 91v1h-1v-1z",
    fill: "#ac896a"
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M67 92h-1v-1h1z",
    fill: "#94785b"
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M67 91h1v1h-1z",
    fill: "#847054"
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h-1v-1h1z",
    fill: "#857759"
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M70 92h-1v-1h1z",
    fill: "#92866a"
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M71 91v1h-1v-1z",
    fill: "#b2a56a"
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M72 91v1h-1v-1z",
    fill: "#e8dd8c"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M72 92v-1h1v1z",
    fill: "#b09f67"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M73 91h1v1h-1z",
    fill: "#533f30"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91v1h-1v-1z",
    fill: "#402f2f"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92h-1v-1h1z",
    fill: "#3d3231"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M77 92h-1v-1h1z",
    fill: "#3a312c"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h-1v-1h1z",
    fill: "#3c3030"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M78 91h1v1h-1z",
    fill: "#413231"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92v-1h1v1z",
    fill: "#443434"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M81 91v1h-1v-1z",
    fill: "#3f302f"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M82 91v1h-1v-1z",
    fill: "#3a2a29"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M82 92v-1h1v1z",
    fill: "#392829"
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M83 91h1v1h-1z",
    fill: "#392b2d"
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M85 92h-1v-1h1z",
    fill: "#322b2d"
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M87 92h-1v-1h1z",
    fill: "#181d1f"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M94 91v1h-1v-1z",
    fill: "#39383c",
    fillOpacity: 0.957
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93v-1h1v1z",
    fill: "#a2a2a2",
    fillOpacity: 0.086
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M35 92v1h-1v-1z",
    fill: "#515151",
    fillOpacity: 0.878
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93v-1h1v1z",
    fill: "#383837"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92h1v1h-1z",
    fill: "#ee7746"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h-1v-1h1z",
    fill: "#ed743f"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93v-1h1v1z",
    fill: "#eb753e"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92v1h-1v-1z",
    fill: "#ec763f"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92h1v1h-1z",
    fill: "#ee763f"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93h-1v-1h1z",
    fill: "#f0743d"
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M48 93h-1v-1h1z",
    fill: "#ef7543"
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93h-1v-1h1z",
    fill: "#ef7544"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92v1h-1v-1z",
    fill: "#f0753e"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M50 93v-1h1v1z",
    fill: "#ef773d"
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h-1v-1h1z",
    fill: "#ef7841"
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M52 92h1v1h-1z",
    fill: "#f37b48"
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M54 93h-1v-1h1z",
    fill: "#f27d4c"
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M55 93h-1v-1h1z",
    fill: "#f0804f"
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M56 93h-1v-1h1z",
    fill: "#f0824f"
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92h1v1h-1z",
    fill: "#f18351"
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93h-1v-1h1z",
    fill: "#ef8654"
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92h1v1h-1z",
    fill: "#e88653"
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M59 92h1v1h-1z",
    fill: "#dd905a"
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v1h-1v-1z",
    fill: "#d3aa6e"
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h-1v-1h1z",
    fill: "#bda86a"
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93v-1h1v1z",
    fill: "#ae9f6c"
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M64 92v1h-1v-1z",
    fill: "#a18c6d"
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93h-1v-1h1z",
    fill: "#948268"
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M65 92h1v1h-1z",
    fill: "#a5987f"
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M66 92h1v1h-1z",
    fill: "#cbc2a7"
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M67 93v-1h1v1z",
    fill: "#e4dbba"
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92v1h-1v-1z",
    fill: "#f0e6bc"
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h1v1h-1z",
    fill: "#f2e9ac"
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M70 92h1v1h-1z",
    fill: "#f9e994"
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M71 92h1v1h-1z",
    fill: "#ccba68"
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92v1h-1v-1z",
    fill: "#594629"
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92h1v1h-1z",
    fill: "#3d2f2e"
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M74 92h1v1h-1z",
    fill: "#3f3431"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93v-1h1v1z",
    fill: "#3e312f"
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93v-1h1v1z",
    fill: "#40312e"
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93h-1v-1h1z",
    fill: "#402f2d"
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h1v1h-1z",
    fill: "#443030"
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92h1v1h-1z",
    fill: "#43302f"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92v1h-1v-1z",
    fill: "#422e2d"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92h1v1h-1z",
    fill: "#3c2828"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M84 92v1h-1v-1z",
    fill: "#322524"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M84 92h1v1h-1z",
    fill: "#2f2628"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M86 92v1h-1v-1z",
    fill: "#201e22"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M86 92h1v1h-1z",
    fill: "#1a1b21"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M91 93v-1h1v1z",
    fill: "#2a2a2d"
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M93 92h1v1h-1z",
    fill: "#3a393e",
    fillOpacity: 0.953
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M94 92h1v1h-1z",
    fill: "#646464",
    fillOpacity: 0.188
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h1v1h-1z",
    fill: "#a5a5a5",
    fillOpacity: 0.078
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94h-1v-1h1z",
    fill: "#575757",
    fillOpacity: 0.871
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94v-1h1v1z",
    fill: "#ec7946"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94v-1h1v1z",
    fill: "#ee743e"
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h1v1h-1z",
    fill: "#f1723b"
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M45 94h-1v-1h1z",
    fill: "#f17440"
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h-1v-1h1z",
    fill: "#ef794b"
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93v1h-1v-1z",
    fill: "#da7451"
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M48 94h-1v-1h1z",
    fill: "#c56e4c"
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93v1h-1v-1z",
    fill: "#c26d4c"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M50 94h-1v-1h1z",
    fill: "#d97654"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M51 93v1h-1v-1z",
    fill: "#e77d4f"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93v1h-1v-1z",
    fill: "#ec7d48"
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h1v1h-1z",
    fill: "#f27b47"
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94h-1v-1h1z",
    fill: "#f37e4a"
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h-1v-1h1z",
    fill: "#f0814c"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h-1v-1h1z",
    fill: "#f57f49"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94v-1h1v1z",
    fill: "#f5804d"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93v1h-1v-1z",
    fill: "#e58350"
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M59 93v1h-1v-1z",
    fill: "#d49357"
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94h-1v-1h1z",
    fill: "#a78754"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M60 93h1v1h-1z",
    fill: "#8c8559"
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M61 93h1v1h-1z",
    fill: "#aaaa75"
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h1v1h-1z",
    fill: "#c1c287"
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M64 93v1h-1v-1z",
    fill: "#d9d29c"
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93v1h-1v-1z",
    fill: "#ece6bc"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M65 94v-1h1v1z",
    fill: "#f1efca"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94h-1v-1h1z",
    fill: "#ebeac4"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h-1v-1h1z",
    fill: "#ebe8be"
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94v-1h1v1z",
    fill: "#eae2ad"
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M70 93v1h-1v-1z",
    fill: "#e7de84"
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M71 93v1h-1v-1z",
    fill: "#d7cb69"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93v1h-1v-1z",
    fill: "#7f6b3d"
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94h-1v-1h1z",
    fill: "#453533"
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M75 94h-1v-1h1z",
    fill: "#433232"
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93h1v1h-1z",
    fill: "#423030"
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93h1v1h-1z",
    fill: "#453132"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93v1h-1v-1z",
    fill: "#442e2f"
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M80 93v1h-1v-1z",
    fill: "#45302d"
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94v-1h1v1z",
    fill: "#3f2a28"
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93h1v1h-1z",
    fill: "#392523"
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M83 94v-1h1v1z",
    fill: "#322322"
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M84 93h1v1h-1z",
    fill: "#2f2425"
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94v-1h1v1z",
    fill: "#221d21"
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M94 94h-1v-1h1z",
    fill: "#3b3a40",
    fillOpacity: 0.953
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M95 93v1h-1v-1z",
    fill: "#67676c",
    fillOpacity: 0.184
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M34 94v1h-1v-1z",
    fill: "#afafaf",
    fillOpacity: 0.063
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94v1h-1v-1z",
    fill: "#595959",
    fillOpacity: 0.859
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v1h-1v-1z",
    fill: "#3c3c3c"
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95v-1h1v1z",
    fill: "#ec7742"
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94h1v1h-1z",
    fill: "#ef723c"
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95h-1v-1h1z",
    fill: "#ec7445"
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M44 94h1v1h-1z",
    fill: "#dd7b56"
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v-1h1v1z",
    fill: "#9b573e"
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h1v1h-1z",
    fill: "#5f3d31"
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95h-1v-1h1z",
    fill: "#554037"
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95v-1h1v1z",
    fill: "#4c3931"
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M49 94h1v1h-1z",
    fill: "#5a3c33"
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h-1v-1h1z",
    fill: "#854b37"
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v-1h1v1z",
    fill: "#cc7555"
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M53 94v1h-1v-1z",
    fill: "#ed7f57"
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1z",
    fill: "#f37c4d"
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94v1h-1v-1z",
    fill: "#f17e4b"
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h1v1h-1z",
    fill: "#e67d4b"
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h1v1h-1z",
    fill: "#d97f4a"
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M58 94v1h-1v-1z",
    fill: "#ce8f54"
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h-1v-1h1z",
    fill: "#ad8c4e"
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94v1h-1v-1z",
    fill: "#bdaa62"
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M60 95v-1h1v1z",
    fill: "#eede91"
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M61 94h1v1h-1z",
    fill: "#f5eeac"
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M63 94v1h-1v-1z",
    fill: "#efedb5"
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M63 95v-1h1v1z",
    fill: "#ebeab8"
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M64 94h1v1h-1z",
    fill: "#e9e8b0"
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M66 94v1h-1v-1z",
    fill: "#e7e8ae"
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94v1h-1v-1z",
    fill: "#eae9af"
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M67 95v-1h1v1z",
    fill: "#e1dc9f"
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h1v1h-1z",
    fill: "#d9ce8c"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M69 94h1v1h-1z",
    fill: "#cdbe6d"
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95h-1v-1h1z",
    fill: "#a29150"
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M71 94h1v1h-1z",
    fill: "#483321"
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M72 94h1v1h-1z",
    fill: "#453232"
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94v1h-1v-1z",
    fill: "#483532"
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M74 95v-1h1v1z",
    fill: "#483331"
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "M76 94v1h-1v-1z",
    fill: "#46302e"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95v-1h1v1z",
    fill: "#4a3231"
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "M77 95v-1h1v1z",
    fill: "#4a3130"
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "M79 94v1h-1v-1z",
    fill: "#4a322f"
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94h1v1h-1z",
    fill: "#422a27"
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "M83 95h-1v-1h1z",
    fill: "#3c2623"
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "M84 94v1h-1v-1z",
    fill: "#352320"
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "M84 95v-1h1v1z",
    fill: "#322625"
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94h1v1h-1z",
    fill: "#241c1f"
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "M87 94v1h-1v-1z",
    fill: "#1c191e"
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95v-1h1v1z",
    fill: "#3d3c40",
    fillOpacity: 0.949
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "M94 95v-1h1v1z",
    fill: "#69696e",
    fillOpacity: 0.18
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "M35 95v1h-1v-1z",
    fill: "#5e5e5e",
    fillOpacity: 0.847
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h-1v-1h1z",
    fill: "#3f3f3f"
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95h1v1h-1z",
    fill: "#f1763d"
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "M43 96h-1v-1h1z",
    fill: "#f1733e"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95v1h-1v-1z",
    fill: "#de7753"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v1h-1v-1z",
    fill: "#794437"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95h1v1h-1z",
    fill: "#423736"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "M47 95v1h-1v-1z",
    fill: "#535351"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v-1h1v1z",
    fill: "#737276"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v-1h1v1z",
    fill: "#7c7a80"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "M50 95v1h-1v-1z",
    fill: "#636362"
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v1h-1v-1z",
    fill: "#4b4642"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h1v1h-1z",
    fill: "#613f33"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96h-1v-1h1z",
    fill: "#bc6e51"
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95v1h-1v-1z",
    fill: "#e27a4e"
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95h1v1h-1z",
    fill: "#e27945"
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96h-1v-1h1z",
    fill: "#c17a3c"
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96v-1h1v1z",
    fill: "#c0964d"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "M57 95h1v1h-1z",
    fill: "#ceba66"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "M58 95h1v1h-1z",
    fill: "#dbcd72"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h1v1h-1z",
    fill: "#ebdc8e"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h-1v-1h1z",
    fill: "#f3e6ae"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95v1h-1v-1z",
    fill: "#d7cc9a"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95h1v1h-1z",
    fill: "#d6cd9a"
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "M64 96h-1v-1h1z",
    fill: "#f0e9ad"
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96h-1v-1h1z",
    fill: "#e9e39a"
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h-1v-1h1z",
    fill: "#dfd98d"
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96v-1h1v1z",
    fill: "#eee697"
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96h-1v-1h1z",
    fill: "#e5d685"
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96v-1h1v1z",
    fill: "#b09a51"
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "M69 95h1v1h-1z",
    fill: "#8c734a"
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95v1h-1v-1z",
    fill: "#50372a"
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "M71 96v-1h1v1z",
    fill: "#463228"
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h-1v-1h1z",
    fill: "#47352f"
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "M74 96h-1v-1h1z",
    fill: "#4b3631"
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "M74 95h1v1h-1z",
    fill: "#4b332c"
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "M75 95h1v1h-1z",
    fill: "#4a312b"
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95h1v1h-1z",
    fill: "#4c312b"
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v-1h1v1z",
    fill: "#4f332f"
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96v-1h1v1z",
    fill: "#4d3430"
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96h-1v-1h1z",
    fill: "#4e3531"
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "M81 95h1v1h-1z",
    fill: "#472f2b"
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "M83 95v1h-1v-1z",
    fill: "#402824"
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "M84 96h-1v-1h1z",
    fill: "#372320"
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "M85 95v1h-1v-1z",
    fill: "#352525"
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "M85 96v-1h1v1z",
    fill: "#251c1d"
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "M86 95h1v1h-1z",
    fill: "#1d191c"
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95v1h-1v-1z",
    fill: "#333238"
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95h1v1h-1z",
    fill: "#3e3d42",
    fillOpacity: 0.949
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "M94 95h1v1h-1z",
    fill: "#6e6e6e",
    fillOpacity: 0.18
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "M34 97v-1h1v1z",
    fill: "#626263",
    fillOpacity: 0.831
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96v1h-1v-1z",
    fill: "#404042"
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h1v1h-1z",
    fill: "#262528"
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "M39 96h1v1h-1z",
    fill: "#201411"
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96v1h-1v-1z",
    fill: "#ae6244"
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h1v1h-1z",
    fill: "#f0733a"
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97v-1h1v1z",
    fill: "#e97644"
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97v-1h1v1z",
    fill: "#965440"
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97h-1v-1h1z",
    fill: "#4f3f43"
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "M46 96v1h-1v-1z",
    fill: "#68696f"
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v1h-1v-1z",
    fill: "#c4c5c5"
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v1h-1v-1z",
    fill: "#adacae"
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97v-1h1v1z",
    fill: "#aaa8aa"
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97v-1h1v1z",
    fill: "#adaeae"
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "M51 96v1h-1v-1z",
    fill: "#999e9b"
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "M52 97h-1v-1h1z",
    fill: "#4b4142"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96v1h-1v-1z",
    fill: "#633a35"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "M54 96v1h-1v-1z",
    fill: "#af724c"
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "M55 96v1h-1v-1z",
    fill: "#d69a52"
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97v-1h1v1z",
    fill: "#debe6a"
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "M57 96v1h-1v-1z",
    fill: "#decf7f"
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "M58 96v1h-1v-1z",
    fill: "#e7de97"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "M58 97v-1h1v1z",
    fill: "#dbcd7d"
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96v1h-1v-1z",
    fill: "#c5b76f"
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "M60 97v-1h1v1z",
    fill: "#9d935d"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h1v1h-1z",
    fill: "#c8ba7c"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "M63 96v1h-1v-1z",
    fill: "#866f3f"
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "M63 97v-1h1v1z",
    fill: "#94784d"
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96v1h-1v-1z",
    fill: "#d2bf77"
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "M65 97v-1h1v1z",
    fill: "#c0b259"
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h1v1h-1z",
    fill: "#cfbf67"
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "M67 96h1v1h-1z",
    fill: "#c5ab62"
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97h-1v-1h1z",
    fill: "#8c6d3d"
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "M70 96v1h-1v-1z",
    fill: "#5f4635"
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97v-1h1v1z",
    fill: "#4d3331"
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96v1h-1v-1z",
    fill: "#4e3633"
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96h1v1h-1z",
    fill: "#624b46"
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h1v1h-1z",
    fill: "#553e39"
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v-1h1v1z",
    fill: "#513731"
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "M75 97v-1h1v1z",
    fill: "#54362f"
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v1h-1v-1z",
    fill: "#54372e"
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "M77 97v-1h1v1z",
    fill: "#54372d"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96h1v1h-1z",
    fill: "#563832"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v-1h1v1z",
    fill: "#513632"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "M81 96h1v1h-1z",
    fill: "#4b3132"
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "M83 97h-1v-1h1z",
    fill: "#422827"
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "M83 96h1v1h-1z",
    fill: "#382321"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "M86 96v1h-1v-1z",
    fill: "#231c1c"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97h-1v-1h1z",
    fill: "#403f44",
    fillOpacity: 0.949
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97v-1h1v1z",
    fill: "#777177",
    fillOpacity: 0.176
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98h-1v-1h1z",
    fill: "#d0d0d0",
    fillOpacity: 0.043
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "M35 97v1h-1v-1z",
    fill: "#666668",
    fillOpacity: 0.82
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v-1h1v1z",
    fill: "#424144"
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "M36 98v-1h1v1z",
    fill: "#232626"
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97v1h-1v-1z",
    fill: "#21221f"
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "M39 98v-1h1v1z",
    fill: "#1f1314"
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v-1h1v1z",
    fill: "#aa5f4a"
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "M41 98v-1h1v1z",
    fill: "#e17241"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97h1v1h-1z",
    fill: "#ce7044"
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97h1v1h-1z",
    fill: "#633928"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97v1h-1v-1z",
    fill: "#51514d"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "M46 98h-1v-1h1z",
    fill: "#c8cbc7"
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "M47 97v1h-1v-1z",
    fill: "#e8e8e8"
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h-1v-1h1z",
    fill: "#aeaeae"
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97h1v1h-1z",
    fill: "#8e8e8e"
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97h1v1h-1z",
    fill: "#a6a6a6"
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "M50 97h1v1h-1z",
    fill: "#f5f9f6"
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v-1h1v1z",
    fill: "#8a8b8d"
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97v1h-1v-1z",
    fill: "#4a3d3d"
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97h1v1h-1z",
    fill: "#8d7a52"
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "M54 97h1v1h-1z",
    fill: "#dfca77"
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97h1v1h-1z",
    fill: "#d7c671"
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "M57 97v1h-1v-1z",
    fill: "#d6cb72"
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h-1v-1h1z",
    fill: "#ede29a"
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "M59 97v1h-1v-1z",
    fill: "#b4a170"
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "M60 98h-1v-1h1z",
    fill: "#93813e"
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "M61 98h-1v-1h1z",
    fill: "#dacf6a"
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "M62 97v1h-1v-1z",
    fill: "#dfce6f"
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98h-1v-1h1z",
    fill: "#b29656"
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v-1h1v1z",
    fill: "#957444"
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98h-1v-1h1z",
    fill: "#ae974f"
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "M66 97v1h-1v-1z",
    fill: "#c6b36b"
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "M67 97v1h-1v-1z",
    fill: "#a3905b"
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98v-1h1v1z",
    fill: "#846b4b"
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97v1h-1v-1z",
    fill: "#5f4330"
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h-1v-1h1z",
    fill: "#4c3225"
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97h1v1h-1z",
    fill: "#503630"
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "M71 97h1v1h-1z",
    fill: "#533836"
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98h-1v-1h1z",
    fill: "#543934"
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v1h-1v-1z",
    fill: "#553a33"
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97h1v1h-1z",
    fill: "#573935"
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "M78 97v1h-1v-1z",
    fill: "#573833"
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v1h-1v-1z",
    fill: "#51332e"
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "M80 98h-1v-1h1z",
    fill: "#4c312d"
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "M80 98v-1h1v1z",
    fill: "#4d3431"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98v-1h1v1z",
    fill: "#4b2e2e"
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "M82 97h1v1h-1z",
    fill: "#46292a"
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "M83 98v-1h1v1z",
    fill: "#3b2523"
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97h1v1h-1z",
    fill: "#3c2e2d"
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "M93 97h1v1h-1z",
    fill: "#424246",
    fillOpacity: 0.945
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97h1v1h-1z",
    fill: "#77777c",
    fillOpacity: 0.176
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98v1h-1v-1z",
    fill: "#e2e2e2",
    fillOpacity: 0.035
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v1h-1v-1z",
    fill: "#666668",
    fillOpacity: 0.792
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h-1v-1h1z",
    fill: "#232625"
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "M38 99h-1v-1h1z",
    fill: "#22221e"
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v1h-1v-1z",
    fill: "#1f171b"
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98h1v1h-1z",
    fill: "#995a49"
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v-1h1v1z",
    fill: "#bb6646"
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99v-1h1v1z",
    fill: "#a86148"
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "M43 99v-1h1v1z",
    fill: "#553833"
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "M44 99v-1h1v1z",
    fill: "#686e72"
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "M45 98h1v1h-1z",
    fill: "#999f9f"
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "M46 99v-1h1v1z",
    fill: "#9a9b9a"
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98v1h-1v-1z",
    fill: "#989898"
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h1v1h-1z",
    fill: "#919191"
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99h-1v-1h1z",
    fill: "#a9a9a9"
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v1h-1v-1z",
    fill: "#979897"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "M51 99v-1h1v1z",
    fill: "#97979c"
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99h-1v-1h1z",
    fill: "#484546"
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99h-1v-1h1z",
    fill: "#74724d"
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99v-1h1v1z",
    fill: "#e4e593"
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v-1h1v1z",
    fill: "#d7d069"
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99v-1h1v1z",
    fill: "#ddd279"
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "M58 99h-1v-1h1z",
    fill: "#c8b77b"
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h1v1h-1z",
    fill: "#7f6c3a"
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "M59 99v-1h1v1z",
    fill: "#e2d276"
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v-1h1v1z",
    fill: "#e9dc63"
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99v-1h1v1z",
    fill: "#dfcd62"
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v1h-1v-1z",
    fill: "#b39b4e"
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "M64 99h-1v-1h1z",
    fill: "#bfa262"
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98v1h-1v-1z",
    fill: "#937646"
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "M66 98v1h-1v-1z",
    fill: "#543a23"
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h-1v-1h1z",
    fill: "#453026"
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98h1v1h-1z",
    fill: "#4b382e"
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "M68 99v-1h1v1z",
    fill: "#755e4e"
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "M69 98h1v1h-1z",
    fill: "#5c4132"
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h1v1h-1z",
    fill: "#573a34"
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "M72 98v1h-1v-1z",
    fill: "#563836"
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98v1h-1v-1z",
    fill: "#573b33"
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99h-1v-1h1z",
    fill: "#5c3c33"
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99h-1v-1h1z",
    fill: "#5c3a34"
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99v-1h1v1z",
    fill: "#5c3938"
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98v1h-1v-1z",
    fill: "#533537"
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98h1v1h-1z",
    fill: "#533c3e"
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h-1v-1h1z",
    fill: "#72615e"
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99h-1v-1h1z",
    fill: "#5e4e4a"
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99v-1h1v1z",
    fill: "#4a3634"
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98h1v1h-1z",
    fill: "#503434"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "M82 98h1v1h-1z",
    fill: "#4c2e2f"
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "M86 99h-1v-1h1z",
    fill: "#251f1f"
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "M93 98h1v1h-1z",
    fill: "#444349",
    fillOpacity: 0.945
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "M95 98v1h-1v-1z",
    fill: "#79797f",
    fillOpacity: 0.173
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99h1v1h-1z",
    fill: "#58585a",
    fillOpacity: 0.765
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99v1h-1v-1z",
    fill: "#464648"
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "M39 100h-1v-1h1z",
    fill: "#1c171c"
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h1v1h-1z",
    fill: "#191915"
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v1h-1v-1z",
    fill: "#71472b"
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "M41 100v-1h1v1z",
    fill: "#ab6f48"
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99h1v1h-1z",
    fill: "#8e5a3f"
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "M44 100h-1v-1h1z",
    fill: "#4b3834"
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "M45 100h-1v-1h1z",
    fill: "#777d87"
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "M46 100h-1v-1h1z",
    fill: "#a9a9b0"
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100v-1h1v1z",
    fill: "#8c8988"
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "M52 99v1h-1v-1z",
    fill: "#958f97"
  })), _path3209 || (_path3209 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99v1h-1v-1z",
    fill: "#554f56"
  })), _path3210 || (_path3210 = /*#__PURE__*/React.createElement("path", {
    d: "M53 100v-1h1v1z",
    fill: "#67644e"
  })), _path3211 || (_path3211 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v1h-1v-1z",
    fill: "#dcdd9a"
  })), _path3212 || (_path3212 = /*#__PURE__*/React.createElement("path", {
    d: "M55 100v-1h1v1z",
    fill: "#e2e185"
  })), _path3213 || (_path3213 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99h1v1h-1z",
    fill: "#ded18f"
  })), _path3214 || (_path3214 = /*#__PURE__*/React.createElement("path", {
    d: "M57 99h1v1h-1z",
    fill: "#91794d"
  })), _path3215 || (_path3215 = /*#__PURE__*/React.createElement("path", {
    d: "M58 100v-1h1v1z",
    fill: "#d3c370"
  })), _path3216 || (_path3216 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v1h-1v-1z",
    fill: "#ddd160"
  })), _path3217 || (_path3217 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100v-1h1v1z",
    fill: "#ddcc64"
  })), _path3218 || (_path3218 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99h1v1h-1z",
    fill: "#c1af5b"
  })), _path3219 || (_path3219 = /*#__PURE__*/React.createElement("path", {
    d: "M63 99v1h-1v-1z",
    fill: "#ab925e"
  })), _path3220 || (_path3220 = /*#__PURE__*/React.createElement("path", {
    d: "M63 100v-1h1v1z",
    fill: "#94794d"
  })), _path3221 || (_path3221 = /*#__PURE__*/React.createElement("path", {
    d: "M65 99v1h-1v-1z",
    fill: "#4c2d22"
  })), _path3222 || (_path3222 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99v1h-1v-1z",
    fill: "#503435"
  })), _path3223 || (_path3223 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99h1v1h-1z",
    fill: "#51383a"
  })), _path3224 || (_path3224 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h1v1h-1z",
    fill: "#52392f"
  })), _path3225 || (_path3225 = /*#__PURE__*/React.createElement("path", {
    d: "M69 99v1h-1v-1z",
    fill: "#6a4e3b"
  })), _path3226 || (_path3226 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100v-1h1v1z",
    fill: "#745647"
  })), _path3227 || (_path3227 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100v-1h1v1z",
    fill: "#63443e"
  })), _path3228 || (_path3228 = /*#__PURE__*/React.createElement("path", {
    d: "M71 99h1v1h-1z",
    fill: "#5e3f3b"
  })), _path3229 || (_path3229 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100h-1v-1h1z",
    fill: "#604138"
  })), _path3230 || (_path3230 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99v1h-1v-1z",
    fill: "#613e33"
  })), _path3231 || (_path3231 = /*#__PURE__*/React.createElement("path", {
    d: "M74 100v-1h1v1z",
    fill: "#5f3b33"
  })), _path3232 || (_path3232 = /*#__PURE__*/React.createElement("path", {
    d: "M75 100v-1h1v1z",
    fill: "#523735"
  })), _path3233 || (_path3233 = /*#__PURE__*/React.createElement("path", {
    d: "M76 100v-1h1v1z",
    fill: "#897b7e"
  })), _path3234 || (_path3234 = /*#__PURE__*/React.createElement("path", {
    d: "M77 99h1v1h-1z",
    fill: "#bdbcc0"
  })), _path3235 || (_path3235 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99v1h-1v-1z",
    fill: "#bfc6c7"
  })), _path3236 || (_path3236 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h1v1h-1z",
    fill: "#c4c9c9"
  })), _path3237 || (_path3237 = /*#__PURE__*/React.createElement("path", {
    d: "M81 99v1h-1v-1z",
    fill: "#b9b5b6"
  })), _path3238 || (_path3238 = /*#__PURE__*/React.createElement("path", {
    d: "M82 100h-1v-1h1z",
    fill: "#5b4a4d"
  })), _path3239 || (_path3239 = /*#__PURE__*/React.createElement("path", {
    d: "M82 100v-1h1v1z",
    fill: "#493032"
  })), _path3240 || (_path3240 = /*#__PURE__*/React.createElement("path", {
    d: "M84 99v1h-1v-1z",
    fill: "#412b29"
  })), _path3241 || (_path3241 = /*#__PURE__*/React.createElement("path", {
    d: "M85 99h1v1h-1z",
    fill: "#25201f"
  })), _path3242 || (_path3242 = /*#__PURE__*/React.createElement("path", {
    d: "M87 100v-1h1v1z",
    fill: "#1b1b1c"
  })), _path3243 || (_path3243 = /*#__PURE__*/React.createElement("path", {
    d: "M92 100v-1h1v1z",
    fill: "#39383e"
  })), _path3244 || (_path3244 = /*#__PURE__*/React.createElement("path", {
    d: "M93 100v-1h1v1z",
    fill: "#47464b",
    fillOpacity: 0.941
  })), _path3245 || (_path3245 = /*#__PURE__*/React.createElement("path", {
    d: "M95 100h-1v-1h1z",
    fill: "#7c7c82",
    fillOpacity: 0.169
  })), _path3246 || (_path3246 = /*#__PURE__*/React.createElement("path", {
    d: "M35 100v1h-1v-1z",
    fill: "#616164",
    fillOpacity: 0.706
  })), _path3247 || (_path3247 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101h-1v-1h1z",
    fill: "#49494b"
  })), _path3248 || (_path3248 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h-1v-1h1z",
    fill: "#242326"
  })), _path3249 || (_path3249 = /*#__PURE__*/React.createElement("path", {
    d: "M38 100v1h-1v-1z",
    fill: "#271f22"
  })), _path3250 || (_path3250 = /*#__PURE__*/React.createElement("path", {
    d: "M38 101v-1h1v1z",
    fill: "#1d171c"
  })), _path3251 || (_path3251 = /*#__PURE__*/React.createElement("path", {
    d: "M40 100v1h-1v-1z",
    fill: "#181b14"
  })), _path3252 || (_path3252 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101h-1v-1h1z",
    fill: "#907a46"
  })), _path3253 || (_path3253 = /*#__PURE__*/React.createElement("path", {
    d: "M42 101h-1v-1h1z",
    fill: "#c49d47"
  })), _path3254 || (_path3254 = /*#__PURE__*/React.createElement("path", {
    d: "M42 100h1v1h-1z",
    fill: "#be9e50"
  })), _path3255 || (_path3255 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101h-1v-1h1z",
    fill: "#584c2e"
  })), _path3256 || (_path3256 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101v-1h1v1z",
    fill: "#5c5d5d"
  })), _path3257 || (_path3257 = /*#__PURE__*/React.createElement("path", {
    d: "M45 101v-1h1v1z",
    fill: "#989596"
  })), _path3258 || (_path3258 = /*#__PURE__*/React.createElement("path", {
    d: "M46 101v-1h1v1z",
    fill: "#7f7f7f"
  })), _path3259 || (_path3259 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101v-1h1v1z",
    fill: "#7d7d7f"
  })), _path3260 || (_path3260 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100h1v1h-1z",
    fill: "#878889"
  })), _path3261 || (_path3261 = /*#__PURE__*/React.createElement("path", {
    d: "M49 101v-1h1v1z",
    fill: "#7f8080"
  })), _path3262 || (_path3262 = /*#__PURE__*/React.createElement("path", {
    d: "M51 100v1h-1v-1z",
    fill: "#959592"
  })), _path3263 || (_path3263 = /*#__PURE__*/React.createElement("path", {
    d: "M52 100v1h-1v-1z",
    fill: "#a5a4a9"
  })), _path3264 || (_path3264 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101h-1v-1h1z",
    fill: "#48484f"
  })), _path3265 || (_path3265 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101h-1v-1h1z",
    fill: "#6d6e5c"
  })), _path3266 || (_path3266 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101h-1v-1h1z",
    fill: "#e7e6b7"
  })), _path3267 || (_path3267 = /*#__PURE__*/React.createElement("path", {
    d: "M56 100v1h-1v-1z",
    fill: "#e6deb6"
  })), _path3268 || (_path3268 = /*#__PURE__*/React.createElement("path", {
    d: "M56 101v-1h1v1z",
    fill: "#8c7b4f"
  })), _path3269 || (_path3269 = /*#__PURE__*/React.createElement("path", {
    d: "M58 101h-1v-1h1z",
    fill: "#ccb779"
  })), _path3270 || (_path3270 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h-1v-1h1z",
    fill: "#dcce71"
  })), _path3271 || (_path3271 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v-1h1v1z",
    fill: "#cec259"
  })), _path3272 || (_path3272 = /*#__PURE__*/React.createElement("path", {
    d: "M61 100v1h-1v-1z",
    fill: "#cfbf69"
  })), _path3273 || (_path3273 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101v-1h1v1z",
    fill: "#a18b53"
  })), _path3274 || (_path3274 = /*#__PURE__*/React.createElement("path", {
    d: "M62 101v-1h1v1z",
    fill: "#6e5541"
  })), _path3275 || (_path3275 = /*#__PURE__*/React.createElement("path", {
    d: "M64 101h-1v-1h1z",
    fill: "#472c26"
  })), _path3276 || (_path3276 = /*#__PURE__*/React.createElement("path", {
    d: "M64 100h1v1h-1z",
    fill: "#503632"
  })), _path3277 || (_path3277 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h-1v-1h1z",
    fill: "#533935"
  })), _path3278 || (_path3278 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101v-1h1v1z",
    fill: "#563b36"
  })), _path3279 || (_path3279 = /*#__PURE__*/React.createElement("path", {
    d: "M68 100v1h-1v-1z",
    fill: "#5f3f39"
  })), _path3280 || (_path3280 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h-1v-1h1z",
    fill: "#6d4940"
  })), _path3281 || (_path3281 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100h1v1h-1z",
    fill: "#78564a"
  })), _path3282 || (_path3282 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100h1v1h-1z",
    fill: "#67453e"
  })), _path3283 || (_path3283 = /*#__PURE__*/React.createElement("path", {
    d: "M71 100h1v1h-1z",
    fill: "#64413b"
  })), _path3284 || (_path3284 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100v1h-1v-1z",
    fill: "#624037"
  })), _path3285 || (_path3285 = /*#__PURE__*/React.createElement("path", {
    d: "M74 101v-1h1v1z",
    fill: "#5a382f"
  })), _path3286 || (_path3286 = /*#__PURE__*/React.createElement("path", {
    d: "M76 101h-1v-1h1z",
    fill: "#7a6665"
  })), _path3287 || (_path3287 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100v1h-1v-1z",
    fill: "#cacacd"
  })), _path3288 || (_path3288 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100h1v1h-1z",
    fill: "#a0b0b3"
  })), _path3289 || (_path3289 = /*#__PURE__*/React.createElement("path", {
    d: "M79 101h-1v-1h1z",
    fill: "#a2b7bb"
  })), _path3290 || (_path3290 = /*#__PURE__*/React.createElement("path", {
    d: "M79 100h1v1h-1z",
    fill: "#b5c8ca"
  })), _path3291 || (_path3291 = /*#__PURE__*/React.createElement("path", {
    d: "M80 101v-1h1v1z",
    fill: "#bbc4c7"
  })), _path3292 || (_path3292 = /*#__PURE__*/React.createElement("path", {
    d: "M81 100h1v1h-1z",
    fill: "#b0acb0"
  })), _path3293 || (_path3293 = /*#__PURE__*/React.createElement("path", {
    d: "M83 100v1h-1v-1z",
    fill: "#493638"
  })), _path3294 || (_path3294 = /*#__PURE__*/React.createElement("path", {
    d: "M84 101h-1v-1h1z",
    fill: "#442d2b"
  })), _path3295 || (_path3295 = /*#__PURE__*/React.createElement("path", {
    d: "M85 101h-1v-1h1z",
    fill: "#423433"
  })), _path3296 || (_path3296 = /*#__PURE__*/React.createElement("path", {
    d: "M85 101v-1h1v1z",
    fill: "#252020"
  })), _path3297 || (_path3297 = /*#__PURE__*/React.createElement("path", {
    d: "M92 100h1v1h-1z",
    fill: "#3b3a40"
  })), _path3298 || (_path3298 = /*#__PURE__*/React.createElement("path", {
    d: "M94 101h-1v-1h1z",
    fill: "#48474d",
    fillOpacity: 0.933
  })), _path3299 || (_path3299 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102v-1h1v1z",
    fill: "#737374",
    fillOpacity: 0.651
  })), _path3300 || (_path3300 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101v1h-1v-1z",
    fill: "#4c4c4e"
  })), _path3301 || (_path3301 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102v-1h1v1z",
    fill: "#212526"
  })), _path3302 || (_path3302 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h1v1h-1z",
    fill: "#212320"
  })), _path3303 || (_path3303 = /*#__PURE__*/React.createElement("path", {
    d: "M39 102h-1v-1h1z",
    fill: "#1d181d"
  })), _path3304 || (_path3304 = /*#__PURE__*/React.createElement("path", {
    d: "M39 101h1v1h-1z",
    fill: "#1b1918"
  })), _path3305 || (_path3305 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101v1h-1v-1z",
    fill: "#c4b96d"
  })), _path3306 || (_path3306 = /*#__PURE__*/React.createElement("path", {
    d: "M41 102v-1h1v1z",
    fill: "#f6e664"
  })), _path3307 || (_path3307 = /*#__PURE__*/React.createElement("path", {
    d: "M43 101v1h-1v-1z",
    fill: "#ede762"
  })), _path3308 || (_path3308 = /*#__PURE__*/React.createElement("path", {
    d: "M43 102v-1h1v1z",
    fill: "#8d8a4e"
  })), _path3309 || (_path3309 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102h-1v-1h1z",
    fill: "#353234"
  })), _path3310 || (_path3310 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102h-1v-1h1z",
    fill: "#575754"
  })), _path3311 || (_path3311 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102v-1h1v1z",
    fill: "#bfbfb9"
  })), _path3312 || (_path3312 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101h1v1h-1z",
    fill: "#b7b6b7"
  })), _path3313 || (_path3313 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v-1h1v1z",
    fill: "#abaaae"
  })), _path3314 || (_path3314 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102h-1v-1h1z",
    fill: "#a5a4a3"
  })), _path3315 || (_path3315 = /*#__PURE__*/React.createElement("path", {
    d: "M50 101h1v1h-1z",
    fill: "#959591"
  })), _path3316 || (_path3316 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101v1h-1v-1z",
    fill: "#3e3f3e"
  })), _path3317 || (_path3317 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101v1h-1v-1z",
    fill: "#a6a491"
  })), _path3318 || (_path3318 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101v1h-1v-1z",
    fill: "#f1ebc7"
  })), _path3319 || (_path3319 = /*#__PURE__*/React.createElement("path", {
    d: "M55 102v-1h1v1z",
    fill: "#917e60"
  })), _path3320 || (_path3320 = /*#__PURE__*/React.createElement("path", {
    d: "M57 102h-1v-1h1z",
    fill: "#ac9b69"
  })), _path3321 || (_path3321 = /*#__PURE__*/React.createElement("path", {
    d: "M58 102h-1v-1h1z",
    fill: "#cec071"
  })), _path3322 || (_path3322 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v1h-1v-1z",
    fill: "#dcd26f"
  })), _path3323 || (_path3323 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h1v1h-1z",
    fill: "#b7a951"
  })), _path3324 || (_path3324 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102v-1h1v1z",
    fill: "#a99258"
  })), _path3325 || (_path3325 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101h1v1h-1z",
    fill: "#806948"
  })), _path3326 || (_path3326 = /*#__PURE__*/React.createElement("path", {
    d: "M63 101v1h-1v-1z",
    fill: "#5b4533"
  })), _path3327 || (_path3327 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v-1h1v1z",
    fill: "#48332c"
  })), _path3328 || (_path3328 = /*#__PURE__*/React.createElement("path", {
    d: "M65 102v-1h1v1z",
    fill: "#553b34"
  })), _path3329 || (_path3329 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h1v1h-1z",
    fill: "#5b3e36"
  })), _path3330 || (_path3330 = /*#__PURE__*/React.createElement("path", {
    d: "M68 102h-1v-1h1z",
    fill: "#61413a"
  })), _path3331 || (_path3331 = /*#__PURE__*/React.createElement("path", {
    d: "M68 101h1v1h-1z",
    fill: "#65433a"
  })), _path3332 || (_path3332 = /*#__PURE__*/React.createElement("path", {
    d: "M75 101v1h-1v-1z",
    fill: "#563932"
  })), _path3333 || (_path3333 = /*#__PURE__*/React.createElement("path", {
    d: "M75 102v-1h1v1z",
    fill: "#bcb5b3"
  })), _path3334 || (_path3334 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102h-1v-1h1z",
    fill: "#c2caca"
  })), _path3335 || (_path3335 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102v-1h1v1z",
    fill: "#a3b2b4"
  })), _path3336 || (_path3336 = /*#__PURE__*/React.createElement("path", {
    d: "M79 101v1h-1v-1z",
    fill: "#a5b3b6"
  })), _path3337 || (_path3337 = /*#__PURE__*/React.createElement("path", {
    d: "M80 102h-1v-1h1z",
    fill: "#a8b9bb"
  })), _path3338 || (_path3338 = /*#__PURE__*/React.createElement("path", {
    d: "M80 101h1v1h-1z",
    fill: "#b8c6c8"
  })), _path3339 || (_path3339 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102h-1v-1h1z",
    fill: "#cbd0d4"
  })), _path3340 || (_path3340 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102v-1h1v1z",
    fill: "#66595b"
  })), _path3341 || (_path3341 = /*#__PURE__*/React.createElement("path", {
    d: "M84 101v1h-1v-1z",
    fill: "#3d2624"
  })), _path3342 || (_path3342 = /*#__PURE__*/React.createElement("path", {
    d: "M84 102v-1h1v1z",
    fill: "#40302f"
  })), _path3343 || (_path3343 = /*#__PURE__*/React.createElement("path", {
    d: "M86 101v1h-1v-1z",
    fill: "#262020"
  })), _path3344 || (_path3344 = /*#__PURE__*/React.createElement("path", {
    d: "M92 101v1h-1v-1z",
    fill: "#2d2d30"
  })), _path3345 || (_path3345 = /*#__PURE__*/React.createElement("path", {
    d: "M92 102v-1h1v1z",
    fill: "#3e3d43"
  })), _path3346 || (_path3346 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102v-1h1v1z",
    fill: "#4b4a4e",
    fillOpacity: 0.925
  })), _path3347 || (_path3347 = /*#__PURE__*/React.createElement("path", {
    d: "M94 102v-1h1v1z",
    fill: "#7c7c7c",
    fillOpacity: 0.145
  })), _path3348 || (_path3348 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102h1v1h-1z",
    fill: "#737376",
    fillOpacity: 0.624
  })), _path3349 || (_path3349 = /*#__PURE__*/React.createElement("path", {
    d: "M35 103v-1h1v1z",
    fill: "#4e4e50"
  })), _path3350 || (_path3350 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102h1v1h-1z",
    fill: "#222527"
  })), _path3351 || (_path3351 = /*#__PURE__*/React.createElement("path", {
    d: "M37 102h1v1h-1z",
    fill: "#232421"
  })), _path3352 || (_path3352 = /*#__PURE__*/React.createElement("path", {
    d: "M39 103v-1h1v1z",
    fill: "#191a13"
  })), _path3353 || (_path3353 = /*#__PURE__*/React.createElement("path", {
    d: "M40 103v-1h1v1z",
    fill: "#beb868"
  })), _path3354 || (_path3354 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v-1h1v1z",
    fill: "#f5e760"
  })), _path3355 || (_path3355 = /*#__PURE__*/React.createElement("path", {
    d: "M42 102h1v1h-1z",
    fill: "#f2e862"
  })), _path3356 || (_path3356 = /*#__PURE__*/React.createElement("path", {
    d: "M44 102v1h-1v-1z",
    fill: "#dcd686"
  })), _path3357 || (_path3357 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102v1h-1v-1z",
    fill: "#555141"
  })), _path3358 || (_path3358 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h-1v-1h1z",
    fill: "#55564e"
  })), _path3359 || (_path3359 = /*#__PURE__*/React.createElement("path", {
    d: "M47 103h-1v-1h1z",
    fill: "#8f8f84"
  })), _path3360 || (_path3360 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v1h-1v-1z",
    fill: "#bfbebd"
  })), _path3361 || (_path3361 = /*#__PURE__*/React.createElement("path", {
    d: "M49 102v1h-1v-1z",
    fill: "#cfcdd1"
  })), _path3362 || (_path3362 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102v1h-1v-1z",
    fill: "#bdbbbe"
  })), _path3363 || (_path3363 = /*#__PURE__*/React.createElement("path", {
    d: "M51 103h-1v-1h1z",
    fill: "#868786"
  })), _path3364 || (_path3364 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h-1v-1h1z",
    fill: "#32312c"
  })), _path3365 || (_path3365 = /*#__PURE__*/React.createElement("path", {
    d: "M53 103h-1v-1h1z",
    fill: "#6b6455"
  })), _path3366 || (_path3366 = /*#__PURE__*/React.createElement("path", {
    d: "M53 102h1v1h-1z",
    fill: "#e7d7b6"
  })), _path3367 || (_path3367 = /*#__PURE__*/React.createElement("path", {
    d: "M54 102h1v1h-1z",
    fill: "#a28b5a"
  })), _path3368 || (_path3368 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103h-1v-1h1z",
    fill: "#c2ab6f"
  })), _path3369 || (_path3369 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103v-1h1v1z",
    fill: "#d9c47e"
  })), _path3370 || (_path3370 = /*#__PURE__*/React.createElement("path", {
    d: "M57 103v-1h1v1z",
    fill: "#d3c16d"
  })), _path3371 || (_path3371 = /*#__PURE__*/React.createElement("path", {
    d: "M59 103h-1v-1h1z",
    fill: "#e9da77"
  })), _path3372 || (_path3372 = /*#__PURE__*/React.createElement("path", {
    d: "M60 103h-1v-1h1z",
    fill: "#bcab53"
  })), _path3373 || (_path3373 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102h1v1h-1z",
    fill: "#a4905b"
  })), _path3374 || (_path3374 = /*#__PURE__*/React.createElement("path", {
    d: "M62 102v1h-1v-1z",
    fill: "#614b30"
  })), _path3375 || (_path3375 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v1h-1v-1z",
    fill: "#483324"
  })), _path3376 || (_path3376 = /*#__PURE__*/React.createElement("path", {
    d: "M64 102v1h-1v-1z",
    fill: "#493430"
  })), _path3377 || (_path3377 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103h-1v-1h1z",
    fill: "#4e3431"
  })), _path3378 || (_path3378 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h-1v-1h1z",
    fill: "#543732"
  })), _path3379 || (_path3379 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103v-1h1v1z",
    fill: "#5b3d36"
  })), _path3380 || (_path3380 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h-1v-1h1z",
    fill: "#5e3d35"
  })), _path3381 || (_path3381 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102v1h-1v-1z",
    fill: "#634138"
  })), _path3382 || (_path3382 = /*#__PURE__*/React.createElement("path", {
    d: "M73 102v1h-1v-1z",
    fill: "#643d34"
  })), _path3383 || (_path3383 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102v1h-1v-1z",
    fill: "#64392f"
  })), _path3384 || (_path3384 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h1v1h-1z",
    fill: "#553d34"
  })), _path3385 || (_path3385 = /*#__PURE__*/React.createElement("path", {
    d: "M76 103h-1v-1h1z",
    fill: "#afb5af"
  })), _path3386 || (_path3386 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103h-1v-1h1z",
    fill: "#a9b8b7"
  })), _path3387 || (_path3387 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103h-1v-1h1z",
    fill: "#adb9bd"
  })), _path3388 || (_path3388 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103v-1h1v1z",
    fill: "#a4afb3"
  })), _path3389 || (_path3389 = /*#__PURE__*/React.createElement("path", {
    d: "M79 102h1v1h-1z",
    fill: "#9eafb0"
  })), _path3390 || (_path3390 = /*#__PURE__*/React.createElement("path", {
    d: "M80 103v-1h1v1z",
    fill: "#aabcbb"
  })), _path3391 || (_path3391 = /*#__PURE__*/React.createElement("path", {
    d: "M81 102h1v1h-1z",
    fill: "#b8c4c4"
  })), _path3392 || (_path3392 = /*#__PURE__*/React.createElement("path", {
    d: "M83 103h-1v-1h1z",
    fill: "#625958"
  })), _path3393 || (_path3393 = /*#__PURE__*/React.createElement("path", {
    d: "M84 102v1h-1v-1z",
    fill: "#3c2523"
  })), _path3394 || (_path3394 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103h-1v-1h1z",
    fill: "#3c2d2c"
  })), _path3395 || (_path3395 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102v1h-1v-1z",
    fill: "#3f3e44"
  })), _path3396 || (_path3396 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102h1v1h-1z",
    fill: "#4b4a4e",
    fillOpacity: 0.914
  })), _path3397 || (_path3397 = /*#__PURE__*/React.createElement("path", {
    d: "M95 102v1h-1v-1z",
    fill: "#838383",
    fillOpacity: 0.129
  })), _path3398 || (_path3398 = /*#__PURE__*/React.createElement("path", {
    d: "M35 104h-1v-1h1z",
    fill: "#737375",
    fillOpacity: 0.596
  })), _path3399 || (_path3399 = /*#__PURE__*/React.createElement("path", {
    d: "M35 103h1v1h-1z",
    fill: "#4f4f51"
  })), _path3400 || (_path3400 = /*#__PURE__*/React.createElement("path", {
    d: "M37 103v1h-1v-1z",
    fill: "#232528"
  })), _path3401 || (_path3401 = /*#__PURE__*/React.createElement("path", {
    d: "M37 104v-1h1v1z",
    fill: "#242322"
  })), _path3402 || (_path3402 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h-1v-1h1z",
    fill: "#1c1919"
  })), _path3403 || (_path3403 = /*#__PURE__*/React.createElement("path", {
    d: "M40 104h-1v-1h1z",
    fill: "#181c17"
  })), _path3404 || (_path3404 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v1h-1v-1z",
    fill: "#b1af69"
  })), _path3405 || (_path3405 = /*#__PURE__*/React.createElement("path", {
    d: "M42 103v1h-1v-1z",
    fill: "#deca50"
  })), _path3406 || (_path3406 = /*#__PURE__*/React.createElement("path", {
    d: "M43 104h-1v-1h1z",
    fill: "#cdb137"
  })), _path3407 || (_path3407 = /*#__PURE__*/React.createElement("path", {
    d: "M44 103v1h-1v-1z",
    fill: "#b99e3b"
  })), _path3408 || (_path3408 = /*#__PURE__*/React.createElement("path", {
    d: "M44 103h1v1h-1z",
    fill: "#b39c61"
  })), _path3409 || (_path3409 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103v1h-1v-1z",
    fill: "#756850"
  })), _path3410 || (_path3410 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h1v1h-1z",
    fill: "#5e5e59"
  })), _path3411 || (_path3411 = /*#__PURE__*/React.createElement("path", {
    d: "M48 103v1h-1v-1z",
    fill: "#626064"
  })), _path3412 || (_path3412 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104h-1v-1h1z",
    fill: "#66656b"
  })), _path3413 || (_path3413 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104v-1h1v1z",
    fill: "#5c5b5f"
  })), _path3414 || (_path3414 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h-1v-1h1z",
    fill: "#676363"
  })), _path3415 || (_path3415 = /*#__PURE__*/React.createElement("path", {
    d: "M52 104h-1v-1h1z",
    fill: "#766c5f"
  })), _path3416 || (_path3416 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h1v1h-1z",
    fill: "#b3a47c"
  })), _path3417 || (_path3417 = /*#__PURE__*/React.createElement("path", {
    d: "M54 103v1h-1v-1z",
    fill: "#9f8b4b"
  })), _path3418 || (_path3418 = /*#__PURE__*/React.createElement("path", {
    d: "M54 104v-1h1v1z",
    fill: "#cbb66b"
  })), _path3419 || (_path3419 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104v-1h1v1z",
    fill: "#dcc87e"
  })), _path3420 || (_path3420 = /*#__PURE__*/React.createElement("path", {
    d: "M56 104v-1h1v1z",
    fill: "#c7b26c"
  })), _path3421 || (_path3421 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103v1h-1v-1z",
    fill: "#c3af65"
  })), _path3422 || (_path3422 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103h1v1h-1z",
    fill: "#ad9843"
  })), _path3423 || (_path3423 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104v-1h1v1z",
    fill: "#af9d51"
  })), _path3424 || (_path3424 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104v-1h1v1z",
    fill: "#86744b"
  })), _path3425 || (_path3425 = /*#__PURE__*/React.createElement("path", {
    d: "M62 104h-1v-1h1z",
    fill: "#6a5441"
  })), _path3426 || (_path3426 = /*#__PURE__*/React.createElement("path", {
    d: "M62 103h1v1h-1z",
    fill: "#4e382d"
  })), _path3427 || (_path3427 = /*#__PURE__*/React.createElement("path", {
    d: "M63 103h1v1h-1z",
    fill: "#47322e"
  })), _path3428 || (_path3428 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103v1h-1v-1z",
    fill: "#503633"
  })), _path3429 || (_path3429 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104v-1h1v1z",
    fill: "#573934"
  })), _path3430 || (_path3430 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h1v1h-1z",
    fill: "#5c3b35"
  })), _path3431 || (_path3431 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103v1h-1v-1z",
    fill: "#623f37"
  })), _path3432 || (_path3432 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h1v1h-1z",
    fill: "#644037"
  })), _path3433 || (_path3433 = /*#__PURE__*/React.createElement("path", {
    d: "M72 103h1v1h-1z",
    fill: "#623b32"
  })), _path3434 || (_path3434 = /*#__PURE__*/React.createElement("path", {
    d: "M73 103h1v1h-1z",
    fill: "#643930"
  })), _path3435 || (_path3435 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104h-1v-1h1z",
    fill: "#533931"
  })), _path3436 || (_path3436 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104v-1h1v1z",
    fill: "#a6a8a3"
  })), _path3437 || (_path3437 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103v1h-1v-1z",
    fill: "#b2bfbf"
  })), _path3438 || (_path3438 = /*#__PURE__*/React.createElement("path", {
    d: "M77 104v-1h1v1z",
    fill: "#bdc7cb"
  })), _path3439 || (_path3439 = /*#__PURE__*/React.createElement("path", {
    d: "M79 104h-1v-1h1z",
    fill: "#abb6bb"
  })), _path3440 || (_path3440 = /*#__PURE__*/React.createElement("path", {
    d: "M80 103v1h-1v-1z",
    fill: "#b2c2c2"
  })), _path3441 || (_path3441 = /*#__PURE__*/React.createElement("path", {
    d: "M80 104v-1h1v1z",
    fill: "#adbcba"
  })), _path3442 || (_path3442 = /*#__PURE__*/React.createElement("path", {
    d: "M81 103h1v1h-1z",
    fill: "#bec6c4"
  })), _path3443 || (_path3443 = /*#__PURE__*/React.createElement("path", {
    d: "M83 104h-1v-1h1z",
    fill: "#544845"
  })), _path3444 || (_path3444 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104h-1v-1h1z",
    fill: "#3b2422"
  })), _path3445 || (_path3445 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104h-1v-1h1z",
    fill: "#231e1d"
  })), _path3446 || (_path3446 = /*#__PURE__*/React.createElement("path", {
    d: "M93 104h-1v-1h1z",
    fill: "#403f45"
  })), _path3447 || (_path3447 = /*#__PURE__*/React.createElement("path", {
    d: "M94 103v1h-1v-1z",
    fill: "#4c4b50",
    fillOpacity: 0.91
  })), _path3448 || (_path3448 = /*#__PURE__*/React.createElement("path", {
    d: "M95 103v1h-1v-1z",
    fill: "#838383",
    fillOpacity: 0.122
  })), _path3449 || (_path3449 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104h1v1h-1z",
    fill: "#737375",
    fillOpacity: 0.573
  })), _path3450 || (_path3450 = /*#__PURE__*/React.createElement("path", {
    d: "M35 105v-1h1v1z",
    fill: "#505052"
  })), _path3451 || (_path3451 = /*#__PURE__*/React.createElement("path", {
    d: "M36 105v-1h1v1z",
    fill: "#242629"
  })), _path3452 || (_path3452 = /*#__PURE__*/React.createElement("path", {
    d: "M38 105h-1v-1h1z",
    fill: "#252321"
  })), _path3453 || (_path3453 = /*#__PURE__*/React.createElement("path", {
    d: "M38 104h1v1h-1z",
    fill: "#1c191a"
  })), _path3454 || (_path3454 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h1v1h-1z",
    fill: "#14191d"
  })), _path3455 || (_path3455 = /*#__PURE__*/React.createElement("path", {
    d: "M41 104v1h-1v-1z",
    fill: "#bcba89"
  })), _path3456 || (_path3456 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105h-1v-1h1z",
    fill: "#efe48d"
  })), _path3457 || (_path3457 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105v-1h1v1z",
    fill: "#e3cd72"
  })), _path3458 || (_path3458 = /*#__PURE__*/React.createElement("path", {
    d: "M43 105v-1h1v1z",
    fill: "#d3b74f"
  })), _path3459 || (_path3459 = /*#__PURE__*/React.createElement("path", {
    d: "M45 105h-1v-1h1z",
    fill: "#e2cd71"
  })), _path3460 || (_path3460 = /*#__PURE__*/React.createElement("path", {
    d: "M45 104h1v1h-1z",
    fill: "#daca9a"
  })), _path3461 || (_path3461 = /*#__PURE__*/React.createElement("path", {
    d: "M46 104h1v1h-1z",
    fill: "#876"
  })), _path3462 || (_path3462 = /*#__PURE__*/React.createElement("path", {
    d: "M48 104v1h-1v-1z",
    fill: "#685748"
  })), _path3463 || (_path3463 = /*#__PURE__*/React.createElement("path", {
    d: "M49 105h-1v-1h1z",
    fill: "#6b5b48"
  })), _path3464 || (_path3464 = /*#__PURE__*/React.createElement("path", {
    d: "M50 104v1h-1v-1z",
    fill: "#6d5e42"
  })), _path3465 || (_path3465 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105v-1h1v1z",
    fill: "#85764d"
  })), _path3466 || (_path3466 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h1v1h-1z",
    fill: "#93814a"
  })), _path3467 || (_path3467 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104v1h-1v-1z",
    fill: "#bbaa62"
  })), _path3468 || (_path3468 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104h1v1h-1z",
    fill: "#e4d78c"
  })), _path3469 || (_path3469 = /*#__PURE__*/React.createElement("path", {
    d: "M55 105h-1v-1h1z",
    fill: "#d9d08c"
  })), _path3470 || (_path3470 = /*#__PURE__*/React.createElement("path", {
    d: "M56 105h-1v-1h1z",
    fill: "#bfb477"
  })), _path3471 || (_path3471 = /*#__PURE__*/React.createElement("path", {
    d: "M57 104v1h-1v-1z",
    fill: "#c0b17d"
  })), _path3472 || (_path3472 = /*#__PURE__*/React.createElement("path", {
    d: "M58 104v1h-1v-1z",
    fill: "#aa9662"
  })), _path3473 || (_path3473 = /*#__PURE__*/React.createElement("path", {
    d: "M58 105v-1h1v1z",
    fill: "#bca663"
  })), _path3474 || (_path3474 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104h1v1h-1z",
    fill: "#b6a367"
  })), _path3475 || (_path3475 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104h1v1h-1z",
    fill: "#514027"
  })), _path3476 || (_path3476 = /*#__PURE__*/React.createElement("path", {
    d: "M61 104h1v1h-1z",
    fill: "#4c382a"
  })), _path3477 || (_path3477 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105h-1v-1h1z",
    fill: "#463227"
  })), _path3478 || (_path3478 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h-1v-1h1z",
    fill: "#47332a"
  })), _path3479 || (_path3479 = /*#__PURE__*/React.createElement("path", {
    d: "M65 105h-1v-1h1z",
    fill: "#4f322e"
  })), _path3480 || (_path3480 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104h1v1h-1z",
    fill: "#553632"
  })), _path3481 || (_path3481 = /*#__PURE__*/React.createElement("path", {
    d: "M66 104h1v1h-1z",
    fill: "#5b3933"
  })), _path3482 || (_path3482 = /*#__PURE__*/React.createElement("path", {
    d: "M68 105h-1v-1h1z",
    fill: "#613c36"
  })), _path3483 || (_path3483 = /*#__PURE__*/React.createElement("path", {
    d: "M74 104v1h-1v-1z",
    fill: "#633a30"
  })), _path3484 || (_path3484 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105h-1v-1h1z",
    fill: "#5d3934"
  })), _path3485 || (_path3485 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v-1h1v1z",
    fill: "#5a4749"
  })), _path3486 || (_path3486 = /*#__PURE__*/React.createElement("path", {
    d: "M76 105v-1h1v1z",
    fill: "#c4c5c9"
  })), _path3487 || (_path3487 = /*#__PURE__*/React.createElement("path", {
    d: "M77 104h1v1h-1z",
    fill: "#b7c6c9"
  })), _path3488 || (_path3488 = /*#__PURE__*/React.createElement("path", {
    d: "M79 104v1h-1v-1z",
    fill: "#b2c2c5"
  })), _path3489 || (_path3489 = /*#__PURE__*/React.createElement("path", {
    d: "M80 105h-1v-1h1z",
    fill: "#a5b5b5"
  })), _path3490 || (_path3490 = /*#__PURE__*/React.createElement("path", {
    d: "M81 104v1h-1v-1z",
    fill: "#cdd4d3"
  })), _path3491 || (_path3491 = /*#__PURE__*/React.createElement("path", {
    d: "M82 104v1h-1v-1z",
    fill: "#736c6b"
  })), _path3492 || (_path3492 = /*#__PURE__*/React.createElement("path", {
    d: "M82 105v-1h1v1z",
    fill: "#392524"
  })), _path3493 || (_path3493 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104v1h-1v-1z",
    fill: "#211c1b"
  })), _path3494 || (_path3494 = /*#__PURE__*/React.createElement("path", {
    d: "M93 104v1h-1v-1z",
    fill: "#434248"
  })), _path3495 || (_path3495 = /*#__PURE__*/React.createElement("path", {
    d: "M93 104h1v1h-1z",
    fill: "#4f4e54",
    fillOpacity: 0.902
  })), _path3496 || (_path3496 = /*#__PURE__*/React.createElement("path", {
    d: "M95 105h-1v-1h1z",
    fill: "#888",
    fillOpacity: 0.11
  })), _path3497 || (_path3497 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h-1v-1h1z",
    fill: "#777",
    fillOpacity: 0.537
  })), _path3498 || (_path3498 = /*#__PURE__*/React.createElement("path", {
    d: "M36 106h-1v-1h1z",
    fill: "#525252"
  })), _path3499 || (_path3499 = /*#__PURE__*/React.createElement("path", {
    d: "M38 106h-1v-1h1z",
    fill: "#242224"
  })), _path3500 || (_path3500 = /*#__PURE__*/React.createElement("path", {
    d: "M39 105v1h-1v-1z",
    fill: "#1b1a1d"
  })), _path3501 || (_path3501 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h-1v-1h1z",
    fill: "#b7b89e"
  })), _path3502 || (_path3502 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106h-1v-1h1z",
    fill: "#d9dab9"
  })), _path3503 || (_path3503 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106v-1h1v1z",
    fill: "#d5d5ad"
  })), _path3504 || (_path3504 = /*#__PURE__*/React.createElement("path", {
    d: "M44 105v1h-1v-1z",
    fill: "#dad99b"
  })), _path3505 || (_path3505 = /*#__PURE__*/React.createElement("path", {
    d: "M44 106v-1h1v1z",
    fill: "#e4e3a0"
  })), _path3506 || (_path3506 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h-1v-1h1z",
    fill: "#e8e3ae"
  })), _path3507 || (_path3507 = /*#__PURE__*/React.createElement("path", {
    d: "M47 105v1h-1v-1z",
    fill: "#dbcea0"
  })), _path3508 || (_path3508 = /*#__PURE__*/React.createElement("path", {
    d: "M47 106v-1h1v1z",
    fill: "#c6b383"
  })), _path3509 || (_path3509 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106h-1v-1h1z",
    fill: "#bba56e"
  })), _path3510 || (_path3510 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106v-1h1v1z",
    fill: "#bca868"
  })), _path3511 || (_path3511 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105h1v1h-1z",
    fill: "#c9bc76"
  })), _path3512 || (_path3512 = /*#__PURE__*/React.createElement("path", {
    d: "M52 105v1h-1v-1z",
    fill: "#e2d894"
  })), _path3513 || (_path3513 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h-1v-1h1z",
    fill: "#f0e8ac"
  })), _path3514 || (_path3514 = /*#__PURE__*/React.createElement("path", {
    d: "M54 105v1h-1v-1z",
    fill: "#e9e3b1"
  })), _path3515 || (_path3515 = /*#__PURE__*/React.createElement("path", {
    d: "M54 106v-1h1v1z",
    fill: "#dbd7af"
  })), _path3516 || (_path3516 = /*#__PURE__*/React.createElement("path", {
    d: "M56 106h-1v-1h1z",
    fill: "#b1a78b"
  })), _path3517 || (_path3517 = /*#__PURE__*/React.createElement("path", {
    d: "M57 105v1h-1v-1z",
    fill: "#706449"
  })), _path3518 || (_path3518 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106h-1v-1h1z",
    fill: "#988a64"
  })), _path3519 || (_path3519 = /*#__PURE__*/React.createElement("path", {
    d: "M59 105v1h-1v-1z",
    fill: "#baa97a"
  })), _path3520 || (_path3520 = /*#__PURE__*/React.createElement("path", {
    d: "M59 106v-1h1v1z",
    fill: "#61502f"
  })), _path3521 || (_path3521 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v-1h1v1z",
    fill: "#503f31"
  })), _path3522 || (_path3522 = /*#__PURE__*/React.createElement("path", {
    d: "M61 106v-1h1v1z",
    fill: "#624e44"
  })), _path3523 || (_path3523 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105v1h-1v-1z",
    fill: "#4a342b"
  })), _path3524 || (_path3524 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105h1v1h-1z",
    fill: "#493128"
  })), _path3525 || (_path3525 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h1v1h-1z",
    fill: "#52332e"
  })), _path3526 || (_path3526 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v-1h1v1z",
    fill: "#583631"
  })), _path3527 || (_path3527 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105v1h-1v-1z",
    fill: "#5e3b33"
  })), _path3528 || (_path3528 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105h1v1h-1z",
    fill: "#623c32"
  })), _path3529 || (_path3529 = /*#__PURE__*/React.createElement("path", {
    d: "M69 105v1h-1v-1z",
    fill: "#653f33"
  })), _path3530 || (_path3530 = /*#__PURE__*/React.createElement("path", {
    d: "M70 106h-1v-1h1z",
    fill: "#673f34"
  })), _path3531 || (_path3531 = /*#__PURE__*/React.createElement("path", {
    d: "M70 105h1v1h-1z",
    fill: "#663f34"
  })), _path3532 || (_path3532 = /*#__PURE__*/React.createElement("path", {
    d: "M71 106v-1h1v1z",
    fill: "#633e31"
  })), _path3533 || (_path3533 = /*#__PURE__*/React.createElement("path", {
    d: "M72 105h1v1h-1z",
    fill: "#633f32"
  })), _path3534 || (_path3534 = /*#__PURE__*/React.createElement("path", {
    d: "M73 106v-1h1v1z",
    fill: "#663b33"
  })), _path3535 || (_path3535 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v1h-1v-1z",
    fill: "#673837"
  })), _path3536 || (_path3536 = /*#__PURE__*/React.createElement("path", {
    d: "M76 106h-1v-1h1z",
    fill: "#593335"
  })), _path3537 || (_path3537 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106h-1v-1h1z",
    fill: "#655152"
  })), _path3538 || (_path3538 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106v-1h1v1z",
    fill: "#908e8b"
  })), _path3539 || (_path3539 = /*#__PURE__*/React.createElement("path", {
    d: "M78 105h1v1h-1z",
    fill: "#b1bbb6"
  })), _path3540 || (_path3540 = /*#__PURE__*/React.createElement("path", {
    d: "M80 105v1h-1v-1z",
    fill: "#999e99"
  })), _path3541 || (_path3541 = /*#__PURE__*/React.createElement("path", {
    d: "M81 106h-1v-1h1z",
    fill: "#665f5a"
  })), _path3542 || (_path3542 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106h-1v-1h1z",
    fill: "#412d2a"
  })), _path3543 || (_path3543 = /*#__PURE__*/React.createElement("path", {
    d: "M82 105h1v1h-1z",
    fill: "#472d2a"
  })), _path3544 || (_path3544 = /*#__PURE__*/React.createElement("path", {
    d: "M83 106v-1h1v1z",
    fill: "#412927"
  })), _path3545 || (_path3545 = /*#__PURE__*/React.createElement("path", {
    d: "M85 105v1h-1v-1z",
    fill: "#372726"
  })), _path3546 || (_path3546 = /*#__PURE__*/React.createElement("path", {
    d: "M86 106h-1v-1h1z",
    fill: "#221b1b"
  })), _path3547 || (_path3547 = /*#__PURE__*/React.createElement("path", {
    d: "M92 105h1v1h-1z",
    fill: "#45444a"
  })), _path3548 || (_path3548 = /*#__PURE__*/React.createElement("path", {
    d: "M94 106h-1v-1h1z",
    fill: "#525056",
    fillOpacity: 0.89
  })), _path3549 || (_path3549 = /*#__PURE__*/React.createElement("path", {
    d: "M95 105v1h-1v-1z",
    fill: "#8e8e8e",
    fillOpacity: 0.098
  })), _path3550 || (_path3550 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107h-1v-1h1z",
    fill: "#7b7b7b",
    fillOpacity: 0.486
  })), _path3551 || (_path3551 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h1v1h-1z",
    fill: "#535353"
  })), _path3552 || (_path3552 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106v1h-1v-1z",
    fill: "#252526"
  })), _path3553 || (_path3553 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h1v1h-1z",
    fill: "#232226"
  })), _path3554 || (_path3554 = /*#__PURE__*/React.createElement("path", {
    d: "M39 107h-1v-1h1z",
    fill: "#1a1a1d"
  })), _path3555 || (_path3555 = /*#__PURE__*/React.createElement("path", {
    d: "M40 107h-1v-1h1z",
    fill: "#181914"
  })), _path3556 || (_path3556 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106v1h-1v-1z",
    fill: "#afb2a3"
  })), _path3557 || (_path3557 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h1v1h-1z",
    fill: "#cdcfc3"
  })), _path3558 || (_path3558 = /*#__PURE__*/React.createElement("path", {
    d: "M43 106v1h-1v-1z",
    fill: "#bcbfb9"
  })), _path3559 || (_path3559 = /*#__PURE__*/React.createElement("path", {
    d: "M44 106v1h-1v-1z",
    fill: "#c1c5bc"
  })), _path3560 || (_path3560 = /*#__PURE__*/React.createElement("path", {
    d: "M45 107h-1v-1h1z",
    fill: "#daddc2"
  })), _path3561 || (_path3561 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106v1h-1v-1z",
    fill: "#e5e5b7"
  })), _path3562 || (_path3562 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h1v1h-1z",
    fill: "#e8e6b1"
  })), _path3563 || (_path3563 = /*#__PURE__*/React.createElement("path", {
    d: "M48 106v1h-1v-1z",
    fill: "#ece5b2"
  })), _path3564 || (_path3564 = /*#__PURE__*/React.createElement("path", {
    d: "M48 107v-1h1v1z",
    fill: "#ede1ae"
  })), _path3565 || (_path3565 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106h1v1h-1z",
    fill: "#eee4b0"
  })), _path3566 || (_path3566 = /*#__PURE__*/React.createElement("path", {
    d: "M51 106v1h-1v-1z",
    fill: "#efe9b3"
  })), _path3567 || (_path3567 = /*#__PURE__*/React.createElement("path", {
    d: "M51 107v-1h1v1z",
    fill: "#e6e2b2"
  })), _path3568 || (_path3568 = /*#__PURE__*/React.createElement("path", {
    d: "M52 106h1v1h-1z",
    fill: "#d7d1af"
  })), _path3569 || (_path3569 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h1v1h-1z",
    fill: "#aba58e"
  })), _path3570 || (_path3570 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v-1h1v1z",
    fill: "#6e6655"
  })), _path3571 || (_path3571 = /*#__PURE__*/React.createElement("path", {
    d: "M55 107v-1h1v1z",
    fill: "#362a1f"
  })), _path3572 || (_path3572 = /*#__PURE__*/React.createElement("path", {
    d: "M57 107h-1v-1h1z",
    fill: "#544833"
  })), _path3573 || (_path3573 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106v1h-1v-1z",
    fill: "#a89b7e"
  })), _path3574 || (_path3574 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h-1v-1h1z",
    fill: "#5c4d33"
  })), _path3575 || (_path3575 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v1h-1v-1z",
    fill: "#392818"
  })), _path3576 || (_path3576 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107v-1h1v1z",
    fill: "#54433a"
  })), _path3577 || (_path3577 = /*#__PURE__*/React.createElement("path", {
    d: "M62 106h1v1h-1z",
    fill: "#452e26"
  })), _path3578 || (_path3578 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107h-1v-1h1z",
    fill: "#4b322b"
  })), _path3579 || (_path3579 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v1h-1v-1z",
    fill: "#52342e"
  })), _path3580 || (_path3580 = /*#__PURE__*/React.createElement("path", {
    d: "M65 107v-1h1v1z",
    fill: "#583831"
  })), _path3581 || (_path3581 = /*#__PURE__*/React.createElement("path", {
    d: "M66 106h1v1h-1z",
    fill: "#5a392f"
  })), _path3582 || (_path3582 = /*#__PURE__*/React.createElement("path", {
    d: "M68 106v1h-1v-1z",
    fill: "#59382c"
  })), _path3583 || (_path3583 = /*#__PURE__*/React.createElement("path", {
    d: "M68 107v-1h1v1z",
    fill: "#5e3a30"
  })), _path3584 || (_path3584 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v-1h1v1z",
    fill: "#653b35"
  })), _path3585 || (_path3585 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107v-1h1v1z",
    fill: "#633b34"
  })), _path3586 || (_path3586 = /*#__PURE__*/React.createElement("path", {
    d: "M71 106h1v1h-1z",
    fill: "#613b34"
  })), _path3587 || (_path3587 = /*#__PURE__*/React.createElement("path", {
    d: "M73 106v1h-1v-1z",
    fill: "#613d35"
  })), _path3588 || (_path3588 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h-1v-1h1z",
    fill: "#5f3b34"
  })), _path3589 || (_path3589 = /*#__PURE__*/React.createElement("path", {
    d: "M75 106v1h-1v-1z",
    fill: "#5e3834"
  })), _path3590 || (_path3590 = /*#__PURE__*/React.createElement("path", {
    d: "M75 107v-1h1v1z",
    fill: "#5c3836"
  })), _path3591 || (_path3591 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106v1h-1v-1z",
    fill: "#503331"
  })), _path3592 || (_path3592 = /*#__PURE__*/React.createElement("path", {
    d: "M77 107v-1h1v1z",
    fill: "#44302d"
  })), _path3593 || (_path3593 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h-1v-1h1z",
    fill: "#443432"
  })), _path3594 || (_path3594 = /*#__PURE__*/React.createElement("path", {
    d: "M79 106h1v1h-1z",
    fill: "#442f2e"
  })), _path3595 || (_path3595 = /*#__PURE__*/React.createElement("path", {
    d: "M80 106h1v1h-1z",
    fill: "#472d2b"
  })), _path3596 || (_path3596 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106v1h-1v-1z",
    fill: "#492b29"
  })), _path3597 || (_path3597 = /*#__PURE__*/React.createElement("path", {
    d: "M82 107v-1h1v1z",
    fill: "#482a27"
  })), _path3598 || (_path3598 = /*#__PURE__*/React.createElement("path", {
    d: "M83 106h1v1h-1z",
    fill: "#422b27"
  })), _path3599 || (_path3599 = /*#__PURE__*/React.createElement("path", {
    d: "M85 106v1h-1v-1z",
    fill: "#392a29"
  })), _path3600 || (_path3600 = /*#__PURE__*/React.createElement("path", {
    d: "M85 106h1v1h-1z",
    fill: "#231d1c"
  })), _path3601 || (_path3601 = /*#__PURE__*/React.createElement("path", {
    d: "M92 107v-1h1v1z",
    fill: "#48464c"
  })), _path3602 || (_path3602 = /*#__PURE__*/React.createElement("path", {
    d: "M93 107v-1h1v1z",
    fill: "#535257",
    fillOpacity: 0.882
  })), _path3603 || (_path3603 = /*#__PURE__*/React.createElement("path", {
    d: "M95 107h-1v-1h1z",
    fill: "#909090",
    fillOpacity: 0.09
  })), _path3604 || (_path3604 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107v1h-1v-1z",
    fill: "#7a7a7a",
    fillOpacity: 0.408
  })), _path3605 || (_path3605 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108v-1h1v1z",
    fill: "#545454"
  })), _path3606 || (_path3606 = /*#__PURE__*/React.createElement("path", {
    d: "M38 108v-1h1v1z",
    fill: "#1b1a1f"
  })), _path3607 || (_path3607 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v-1h1v1z",
    fill: "#141513"
  })), _path3608 || (_path3608 = /*#__PURE__*/React.createElement("path", {
    d: "M40 108v-1h1v1z",
    fill: "#818376"
  })), _path3609 || (_path3609 = /*#__PURE__*/React.createElement("path", {
    d: "M42 108h-1v-1h1z",
    fill: "#eaecde"
  })), _path3610 || (_path3610 = /*#__PURE__*/React.createElement("path", {
    d: "M42 107h1v1h-1z",
    fill: "#dcdde2"
  })), _path3611 || (_path3611 = /*#__PURE__*/React.createElement("path", {
    d: "M43 107h1v1h-1z",
    fill: "#e1e0e9"
  })), _path3612 || (_path3612 = /*#__PURE__*/React.createElement("path", {
    d: "M45 107v1h-1v-1z",
    fill: "#e5e5c4"
  })), _path3613 || (_path3613 = /*#__PURE__*/React.createElement("path", {
    d: "M46 108h-1v-1h1z",
    fill: "#e9e9a2"
  })), _path3614 || (_path3614 = /*#__PURE__*/React.createElement("path", {
    d: "M47 107v1h-1v-1z",
    fill: "#eee9a5"
  })), _path3615 || (_path3615 = /*#__PURE__*/React.createElement("path", {
    d: "M47 108v-1h1v1z",
    fill: "#f2e8ac"
  })), _path3616 || (_path3616 = /*#__PURE__*/React.createElement("path", {
    d: "M49 107v1h-1v-1z",
    fill: "#ede1af"
  })), _path3617 || (_path3617 = /*#__PURE__*/React.createElement("path", {
    d: "M50 107v1h-1v-1z",
    fill: "#dcd2a4"
  })), _path3618 || (_path3618 = /*#__PURE__*/React.createElement("path", {
    d: "M50 108v-1h1v1z",
    fill: "#c2bc94"
  })), _path3619 || (_path3619 = /*#__PURE__*/React.createElement("path", {
    d: "M51 108v-1h1v1z",
    fill: "#aba586"
  })), _path3620 || (_path3620 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108h-1v-1h1z",
    fill: "#746b58"
  })), _path3621 || (_path3621 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v1h-1v-1z",
    fill: "#342a22"
  })), _path3622 || (_path3622 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107h1v1h-1z",
    fill: "#322723"
  })), _path3623 || (_path3623 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108h-1v-1h1z",
    fill: "#60534a"
  })), _path3624 || (_path3624 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108v-1h1v1z",
    fill: "#726457"
  })), _path3625 || (_path3625 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108v-1h1v1z",
    fill: "#443529"
  })), _path3626 || (_path3626 = /*#__PURE__*/React.createElement("path", {
    d: "M59 108h-1v-1h1z",
    fill: "#311f17"
  })), _path3627 || (_path3627 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h1v1h-1z",
    fill: "#4a3831"
  })), _path3628 || (_path3628 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107h1v1h-1z",
    fill: "#46342d"
  })), _path3629 || (_path3629 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107v1h-1v-1z",
    fill: "#3f2b24"
  })), _path3630 || (_path3630 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107h1v1h-1z",
    fill: "#422b25"
  })), _path3631 || (_path3631 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107v1h-1v-1z",
    fill: "#4c322d"
  })), _path3632 || (_path3632 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108v-1h1v1z",
    fill: "#4f312d"
  })), _path3633 || (_path3633 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108h-1v-1h1z",
    fill: "#634641"
  })), _path3634 || (_path3634 = /*#__PURE__*/React.createElement("path", {
    d: "M66 107h1v1h-1z",
    fill: "#6d514c"
  })), _path3635 || (_path3635 = /*#__PURE__*/React.createElement("path", {
    d: "M67 107h1v1h-1z",
    fill: "#816860"
  })), _path3636 || (_path3636 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v1h-1v-1z",
    fill: "#907671"
  })), _path3637 || (_path3637 = /*#__PURE__*/React.createElement("path", {
    d: "M69 108v-1h1v1z",
    fill: "#745959"
  })), _path3638 || (_path3638 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107h1v1h-1z",
    fill: "#907675"
  })), _path3639 || (_path3639 = /*#__PURE__*/React.createElement("path", {
    d: "M71 108v-1h1v1z",
    fill: "#7f6866"
  })), _path3640 || (_path3640 = /*#__PURE__*/React.createElement("path", {
    d: "M72 108v-1h1v1z",
    fill: "#7a6362"
  })), _path3641 || (_path3641 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107v1h-1v-1z",
    fill: "#7b6b63"
  })), _path3642 || (_path3642 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h1v1h-1z",
    fill: "#88776f"
  })), _path3643 || (_path3643 = /*#__PURE__*/React.createElement("path", {
    d: "M75 107h1v1h-1z",
    fill: "#67524f"
  })), _path3644 || (_path3644 = /*#__PURE__*/React.createElement("path", {
    d: "M77 108h-1v-1h1z",
    fill: "#7f6b6a"
  })), _path3645 || (_path3645 = /*#__PURE__*/React.createElement("path", {
    d: "M78 107v1h-1v-1z",
    fill: "#786565"
  })), _path3646 || (_path3646 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107v1h-1v-1z",
    fill: "#887174"
  })), _path3647 || (_path3647 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h1v1h-1z",
    fill: "#675052"
  })), _path3648 || (_path3648 = /*#__PURE__*/React.createElement("path", {
    d: "M81 107v1h-1v-1z",
    fill: "#4e3938"
  })), _path3649 || (_path3649 = /*#__PURE__*/React.createElement("path", {
    d: "M81 107h1v1h-1z",
    fill: "#6a5653"
  })), _path3650 || (_path3650 = /*#__PURE__*/React.createElement("path", {
    d: "M83 107v1h-1v-1z",
    fill: "#715d58"
  })), _path3651 || (_path3651 = /*#__PURE__*/React.createElement("path", {
    d: "M83 108v-1h1v1z",
    fill: "#422f2a"
  })), _path3652 || (_path3652 = /*#__PURE__*/React.createElement("path", {
    d: "M84 107h1v1h-1z",
    fill: "#372a28"
  })), _path3653 || (_path3653 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108v-1h1v1z",
    fill: "#211e1c"
  })), _path3654 || (_path3654 = /*#__PURE__*/React.createElement("path", {
    d: "M91 107h1v1h-1z",
    fill: "#2f2f32"
  })), _path3655 || (_path3655 = /*#__PURE__*/React.createElement("path", {
    d: "M93 107h1v1h-1z",
    fill: "#56555a",
    fillOpacity: 0.867
  })), _path3656 || (_path3656 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108v1h-1v-1z",
    fill: "#7c7c7c",
    fillOpacity: 0.329
  })), _path3657 || (_path3657 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108h1v1h-1z",
    fill: "#555"
  })), _path3658 || (_path3658 = /*#__PURE__*/React.createElement("path", {
    d: "M37 108v1h-1v-1z",
    fill: "#262625"
  })), _path3659 || (_path3659 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v1h-1v-1z",
    fill: "#1d1b21"
  })), _path3660 || (_path3660 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109v-1h1v1z",
    fill: "#151516"
  })), _path3661 || (_path3661 = /*#__PURE__*/React.createElement("path", {
    d: "M41 108v1h-1v-1z",
    fill: "#83837d"
  })), _path3662 || (_path3662 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v-1h1v1z",
    fill: "#b2b5ad"
  })), _path3663 || (_path3663 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v-1h1v1z",
    fill: "#a2a2a8"
  })), _path3664 || (_path3664 = /*#__PURE__*/React.createElement("path", {
    d: "M44 108v1h-1v-1z",
    fill: "#b7b5b8"
  })), _path3665 || (_path3665 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v-1h1v1z",
    fill: "#c0bd98"
  })), _path3666 || (_path3666 = /*#__PURE__*/React.createElement("path", {
    d: "M46 108v1h-1v-1z",
    fill: "#a19c55"
  })), _path3667 || (_path3667 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v-1h1v1z",
    fill: "#b2a45f"
  })), _path3668 || (_path3668 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h-1v-1h1z",
    fill: "#ab995e"
  })), _path3669 || (_path3669 = /*#__PURE__*/React.createElement("path", {
    d: "M49 108v1h-1v-1z",
    fill: "#a39060"
  })), _path3670 || (_path3670 = /*#__PURE__*/React.createElement("path", {
    d: "M50 109h-1v-1h1z",
    fill: "#9a8c63"
  })), _path3671 || (_path3671 = /*#__PURE__*/React.createElement("path", {
    d: "M51 109h-1v-1h1z",
    fill: "#776e55"
  })), _path3672 || (_path3672 = /*#__PURE__*/React.createElement("path", {
    d: "M51 108h1v1h-1z",
    fill: "#382f24"
  })), _path3673 || (_path3673 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108v1h-1v-1z",
    fill: "#332a1f"
  })), _path3674 || (_path3674 = /*#__PURE__*/React.createElement("path", {
    d: "M53 109v-1h1v1z",
    fill: "#776c67"
  })), _path3675 || (_path3675 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h-1v-1h1z",
    fill: "#877a7a"
  })), _path3676 || (_path3676 = /*#__PURE__*/React.createElement("path", {
    d: "M55 108h1v1h-1z",
    fill: "#4c3f3a"
  })), _path3677 || (_path3677 = /*#__PURE__*/React.createElement("path", {
    d: "M57 109h-1v-1h1z",
    fill: "#2d1e19"
  })), _path3678 || (_path3678 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108h1v1h-1z",
    fill: "#342320"
  })), _path3679 || (_path3679 = /*#__PURE__*/React.createElement("path", {
    d: "M58 109v-1h1v1z",
    fill: "#3a2626"
  })), _path3680 || (_path3680 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109v-1h1v1z",
    fill: "#3a2726"
  })), _path3681 || (_path3681 = /*#__PURE__*/React.createElement("path", {
    d: "M60 109v-1h1v1z",
    fill: "#3b2a24"
  })), _path3682 || (_path3682 = /*#__PURE__*/React.createElement("path", {
    d: "M62 109h-1v-1h1z",
    fill: "#3e2925"
  })), _path3683 || (_path3683 = /*#__PURE__*/React.createElement("path", {
    d: "M63 108v1h-1v-1z",
    fill: "#432a28"
  })), _path3684 || (_path3684 = /*#__PURE__*/React.createElement("path", {
    d: "M63 109v-1h1v1z",
    fill: "#482e2c"
  })), _path3685 || (_path3685 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108h1v1h-1z",
    fill: "#4d312e"
  })), _path3686 || (_path3686 = /*#__PURE__*/React.createElement("path", {
    d: "M65 108h1v1h-1z",
    fill: "#5e4541"
  })), _path3687 || (_path3687 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108h1v1h-1z",
    fill: "#745e5b"
  })), _path3688 || (_path3688 = /*#__PURE__*/React.createElement("path", {
    d: "M68 108v1h-1v-1z",
    fill: "#9f8d89"
  })), _path3689 || (_path3689 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109h-1v-1h1z",
    fill: "#948583"
  })), _path3690 || (_path3690 = /*#__PURE__*/React.createElement("path", {
    d: "M69 108h1v1h-1z",
    fill: "#706563"
  })), _path3691 || (_path3691 = /*#__PURE__*/React.createElement("path", {
    d: "M71 108v1h-1v-1z",
    fill: "#a09694"
  })), _path3692 || (_path3692 = /*#__PURE__*/React.createElement("path", {
    d: "M71 109v-1h1v1z",
    fill: "#9d9492"
  })), _path3693 || (_path3693 = /*#__PURE__*/React.createElement("path", {
    d: "M72 109v-1h1v1z",
    fill: "#a19a97"
  })), _path3694 || (_path3694 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109v-1h1v1z",
    fill: "#a09b93"
  })), _path3695 || (_path3695 = /*#__PURE__*/React.createElement("path", {
    d: "M74 108h1v1h-1z",
    fill: "#8f8681"
  })), _path3696 || (_path3696 = /*#__PURE__*/React.createElement("path", {
    d: "M76 109h-1v-1h1z",
    fill: "#655855"
  })), _path3697 || (_path3697 = /*#__PURE__*/React.createElement("path", {
    d: "M77 108v1h-1v-1z",
    fill: "#928687"
  })), _path3698 || (_path3698 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109v-1h1v1z",
    fill: "#a79e9e"
  })), _path3699 || (_path3699 = /*#__PURE__*/React.createElement("path", {
    d: "M78 108h1v1h-1z",
    fill: "#ada7a6"
  })), _path3700 || (_path3700 = /*#__PURE__*/React.createElement("path", {
    d: "M80 108v1h-1v-1z",
    fill: "#6d6866"
  })), _path3701 || (_path3701 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h-1v-1h1z",
    fill: "#9d9995"
  })), _path3702 || (_path3702 = /*#__PURE__*/React.createElement("path", {
    d: "M81 108h1v1h-1z",
    fill: "#928f88"
  })), _path3703 || (_path3703 = /*#__PURE__*/React.createElement("path", {
    d: "M82 109v-1h1v1z",
    fill: "#746863"
  })), _path3704 || (_path3704 = /*#__PURE__*/React.createElement("path", {
    d: "M83 108h1v1h-1z",
    fill: "#43312c"
  })), _path3705 || (_path3705 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108h1v1h-1z",
    fill: "#201f1d"
  })), _path3706 || (_path3706 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109h-1v-1h1z",
    fill: "#171d1c"
  })), _path3707 || (_path3707 = /*#__PURE__*/React.createElement("path", {
    d: "M92 109h-1v-1h1z",
    fill: "#2e2e31"
  })), _path3708 || (_path3708 = /*#__PURE__*/React.createElement("path", {
    d: "M94 108v1h-1v-1z",
    fill: "#5a585d",
    fillOpacity: 0.843
  })), _path3709 || (_path3709 = /*#__PURE__*/React.createElement("path", {
    d: "M94 109v-1h1v1z",
    fill: "#999",
    fillOpacity: 0.059
  })), _path3710 || (_path3710 = /*#__PURE__*/React.createElement("path", {
    d: "M34 110v-1h1v1z",
    fill: "#787878",
    fillOpacity: 0.29
  })), _path3711 || (_path3711 = /*#__PURE__*/React.createElement("path", {
    d: "M36 110h-1v-1h1z",
    fill: "#525253",
    fillOpacity: 0.996
  })), _path3712 || (_path3712 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109h1v1h-1z",
    fill: "#131316"
  })), _path3713 || (_path3713 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v1h-1v-1z",
    fill: "#8f908d"
  })), _path3714 || (_path3714 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v1h-1v-1z",
    fill: "#b1b3ae"
  })), _path3715 || (_path3715 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h-1v-1h1z",
    fill: "#828385"
  })), _path3716 || (_path3716 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v1h-1v-1z",
    fill: "#c0bdc2"
  })), _path3717 || (_path3717 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109h1v1h-1z",
    fill: "#a89e98"
  })), _path3718 || (_path3718 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v1h-1v-1z",
    fill: "#594e3b"
  })), _path3719 || (_path3719 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h-1v-1h1z",
    fill: "#63553d"
  })), _path3720 || (_path3720 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110v-1h1v1z",
    fill: "#675743"
  })), _path3721 || (_path3721 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h1v1h-1z",
    fill: "#5a4b3e"
  })), _path3722 || (_path3722 = /*#__PURE__*/React.createElement("path", {
    d: "M49 109h1v1h-1z",
    fill: "#2e241d"
  })), _path3723 || (_path3723 = /*#__PURE__*/React.createElement("path", {
    d: "M50 110v-1h1v1z",
    fill: "#2b231e"
  })), _path3724 || (_path3724 = /*#__PURE__*/React.createElement("path", {
    d: "M52 110h-1v-1h1z",
    fill: "#807770"
  })), _path3725 || (_path3725 = /*#__PURE__*/React.createElement("path", {
    d: "M52 110v-1h1v1z",
    fill: "#b9b0a5"
  })), _path3726 || (_path3726 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110h-1v-1h1z",
    fill: "#746862"
  })), _path3727 || (_path3727 = /*#__PURE__*/React.createElement("path", {
    d: "M54 109h1v1h-1z",
    fill: "#2a1d1a"
  })), _path3728 || (_path3728 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h1v1h-1z",
    fill: "#2c1d1c"
  })), _path3729 || (_path3729 = /*#__PURE__*/React.createElement("path", {
    d: "M56 109h1v1h-1z",
    fill: "#312221"
  })), _path3730 || (_path3730 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109h1v1h-1z",
    fill: "#392624"
  })), _path3731 || (_path3731 = /*#__PURE__*/React.createElement("path", {
    d: "M60 109h1v1h-1z",
    fill: "#392724"
  })), _path3732 || (_path3732 = /*#__PURE__*/React.createElement("path", {
    d: "M62 110h-1v-1h1z",
    fill: "#3e2927"
  })), _path3733 || (_path3733 = /*#__PURE__*/React.createElement("path", {
    d: "M62 109h1v1h-1z",
    fill: "#412a29"
  })), _path3734 || (_path3734 = /*#__PURE__*/React.createElement("path", {
    d: "M64 109v1h-1v-1z",
    fill: "#452c2b"
  })), _path3735 || (_path3735 = /*#__PURE__*/React.createElement("path", {
    d: "M65 110h-1v-1h1z",
    fill: "#472e2a"
  })), _path3736 || (_path3736 = /*#__PURE__*/React.createElement("path", {
    d: "M65 109h1v1h-1z",
    fill: "#58423d"
  })), _path3737 || (_path3737 = /*#__PURE__*/React.createElement("path", {
    d: "M66 109h1v1h-1z",
    fill: "#6c5a58"
  })), _path3738 || (_path3738 = /*#__PURE__*/React.createElement("path", {
    d: "M67 110v-1h1v1z",
    fill: "#988a89"
  })), _path3739 || (_path3739 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109v1h-1v-1z",
    fill: "#998c8b"
  })), _path3740 || (_path3740 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109h1v1h-1z",
    fill: "#7b6b69"
  })), _path3741 || (_path3741 = /*#__PURE__*/React.createElement("path", {
    d: "M71 110h-1v-1h1z",
    fill: "#a1928f"
  })), _path3742 || (_path3742 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109h1v1h-1z",
    fill: "#a09691"
  })), _path3743 || (_path3743 = /*#__PURE__*/React.createElement("path", {
    d: "M74 110v-1h1v1z",
    fill: "#897e7a"
  })), _path3744 || (_path3744 = /*#__PURE__*/React.createElement("path", {
    d: "M75 110v-1h1v1z",
    fill: "#605553"
  })), _path3745 || (_path3745 = /*#__PURE__*/React.createElement("path", {
    d: "M76 110v-1h1v1z",
    fill: "#898281"
  })), _path3746 || (_path3746 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109h1v1h-1z",
    fill: "#8d8a89"
  })), _path3747 || (_path3747 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109v1h-1v-1z",
    fill: "#9e9998"
  })), _path3748 || (_path3748 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109h1v1h-1z",
    fill: "#797270"
  })), _path3749 || (_path3749 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109v1h-1v-1z",
    fill: "#918885"
  })), _path3750 || (_path3750 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h1v1h-1z",
    fill: "#908782"
  })), _path3751 || (_path3751 = /*#__PURE__*/React.createElement("path", {
    d: "M83 110h-1v-1h1z",
    fill: "#867671"
  })), _path3752 || (_path3752 = /*#__PURE__*/React.createElement("path", {
    d: "M84 109v1h-1v-1z",
    fill: "#40302a"
  })), _path3753 || (_path3753 = /*#__PURE__*/React.createElement("path", {
    d: "M90 110v-1h1v1z",
    fill: "#1f2023"
  })), _path3754 || (_path3754 = /*#__PURE__*/React.createElement("path", {
    d: "M93 109v1h-1v-1z",
    fill: "#4c4b51"
  })), _path3755 || (_path3755 = /*#__PURE__*/React.createElement("path", {
    d: "M93 109h1v1h-1z",
    fill: "#5c5b60",
    fillOpacity: 0.812
  })), _path3756 || (_path3756 = /*#__PURE__*/React.createElement("path", {
    d: "M95 110h-1v-1h1z",
    fill: "#b9b9b9",
    fillOpacity: 0.043
  })), _path3757 || (_path3757 = /*#__PURE__*/React.createElement("path", {
    d: "M34 110h1v1h-1z",
    fill: "#595959",
    fillOpacity: 0.29
  })), _path3758 || (_path3758 = /*#__PURE__*/React.createElement("path", {
    d: "M35 111v-1h1v1z",
    fill: "#505050",
    fillOpacity: 0.988
  })), _path3759 || (_path3759 = /*#__PURE__*/React.createElement("path", {
    d: "M36 111v-1h1v1z",
    fill: "#262727"
  })), _path3760 || (_path3760 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110h1v1h-1z",
    fill: "#121315"
  })), _path3761 || (_path3761 = /*#__PURE__*/React.createElement("path", {
    d: "M41 111v-1h1v1z",
    fill: "#c4c5c6"
  })), _path3762 || (_path3762 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110v1h-1v-1z",
    fill: "#bdbdbf"
  })), _path3763 || (_path3763 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h1v1h-1z",
    fill: "#d7d5d6"
  })), _path3764 || (_path3764 = /*#__PURE__*/React.createElement("path", {
    d: "M45 110v1h-1v-1z",
    fill: "#797374"
  })), _path3765 || (_path3765 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111h-1v-1h1z",
    fill: "#120c0c"
  })), _path3766 || (_path3766 = /*#__PURE__*/React.createElement("path", {
    d: "M47 111h-1v-1h1z",
    fill: "#1a1511"
  })), _path3767 || (_path3767 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h1v1h-1z",
    fill: "#17120d"
  })), _path3768 || (_path3768 = /*#__PURE__*/React.createElement("path", {
    d: "M49 111h-1v-1h1z",
    fill: "#18130f"
  })), _path3769 || (_path3769 = /*#__PURE__*/React.createElement("path", {
    d: "M49 111v-1h1v1z",
    fill: "#57524e"
  })), _path3770 || (_path3770 = /*#__PURE__*/React.createElement("path", {
    d: "M51 110v1h-1v-1z",
    fill: "#aea8a0"
  })), _path3771 || (_path3771 = /*#__PURE__*/React.createElement("path", {
    d: "M51 111v-1h1v1z",
    fill: "#8e857c"
  })), _path3772 || (_path3772 = /*#__PURE__*/React.createElement("path", {
    d: "M53 111h-1v-1h1z",
    fill: "#362d28"
  })), _path3773 || (_path3773 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110v1h-1v-1z",
    fill: "#211716"
  })), _path3774 || (_path3774 = /*#__PURE__*/React.createElement("path", {
    d: "M54 111v-1h1v1z",
    fill: "#2a1f1f"
  })), _path3775 || (_path3775 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111v-1h1v1z",
    fill: "#372524"
  })), _path3776 || (_path3776 = /*#__PURE__*/React.createElement("path", {
    d: "M62 111h-1v-1h1z",
    fill: "#3a2725"
  })), _path3777 || (_path3777 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110v1h-1v-1z",
    fill: "#3c2928"
  })), _path3778 || (_path3778 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110h1v1h-1z",
    fill: "#3e2a29"
  })), _path3779 || (_path3779 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111h-1v-1h1z",
    fill: "#472f2a"
  })), _path3780 || (_path3780 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111v-1h1v1z",
    fill: "#4c332d"
  })), _path3781 || (_path3781 = /*#__PURE__*/React.createElement("path", {
    d: "M68 110v1h-1v-1z",
    fill: "#5a433e"
  })), _path3782 || (_path3782 = /*#__PURE__*/React.createElement("path", {
    d: "M69 111h-1v-1h1z",
    fill: "#5d4440"
  })), _path3783 || (_path3783 = /*#__PURE__*/React.createElement("path", {
    d: "M70 110v1h-1v-1z",
    fill: "#5c3f3c"
  })), _path3784 || (_path3784 = /*#__PURE__*/React.createElement("path", {
    d: "M71 110v1h-1v-1z",
    fill: "#604340"
  })), _path3785 || (_path3785 = /*#__PURE__*/React.createElement("path", {
    d: "M71 111v-1h1v1z",
    fill: "#5e403d"
  })), _path3786 || (_path3786 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h1v1h-1z",
    fill: "#5b3e3b"
  })), _path3787 || (_path3787 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111h-1v-1h1z",
    fill: "#5a413c"
  })), _path3788 || (_path3788 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111v-1h1v1z",
    fill: "#553f3a"
  })), _path3789 || (_path3789 = /*#__PURE__*/React.createElement("path", {
    d: "M76 110h1v1h-1z",
    fill: "#5d4a44"
  })), _path3790 || (_path3790 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111h-1v-1h1z",
    fill: "#4a3932"
  })), _path3791 || (_path3791 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111h-1v-1h1z",
    fill: "#523d38"
  })), _path3792 || (_path3792 = /*#__PURE__*/React.createElement("path", {
    d: "M80 110v1h-1v-1z",
    fill: "#4c3732"
  })), _path3793 || (_path3793 = /*#__PURE__*/React.createElement("path", {
    d: "M80 111v-1h1v1z",
    fill: "#483431"
  })), _path3794 || (_path3794 = /*#__PURE__*/React.createElement("path", {
    d: "M82 111h-1v-1h1z",
    fill: "#473532"
  })), _path3795 || (_path3795 = /*#__PURE__*/React.createElement("path", {
    d: "M82 110h1v1h-1z",
    fill: "#584541"
  })), _path3796 || (_path3796 = /*#__PURE__*/React.createElement("path", {
    d: "M83 110h1v1h-1z",
    fill: "#3a2925"
  })), _path3797 || (_path3797 = /*#__PURE__*/React.createElement("path", {
    d: "M85 110v1h-1v-1z",
    fill: "#382e2c"
  })), _path3798 || (_path3798 = /*#__PURE__*/React.createElement("path", {
    d: "M86 111h-1v-1h1z",
    fill: "#211f1f"
  })), _path3799 || (_path3799 = /*#__PURE__*/React.createElement("path", {
    d: "M92 111h-1v-1h1z",
    fill: "#2d2d34"
  })), _path3800 || (_path3800 = /*#__PURE__*/React.createElement("path", {
    d: "M93 111h-1v-1h1z",
    fill: "#4f4e53"
  })), _path3801 || (_path3801 = /*#__PURE__*/React.createElement("path", {
    d: "M93 110h1v1h-1z",
    fill: "#5f5f63",
    fillOpacity: 0.753
  })), _path3802 || (_path3802 = /*#__PURE__*/React.createElement("path", {
    d: "M34 112v-1h1v1z",
    fill: "#707070",
    fillOpacity: 0.204
  })), _path3803 || (_path3803 = /*#__PURE__*/React.createElement("path", {
    d: "M36 111v1h-1v-1z",
    fill: "#525252",
    fillOpacity: 0.957
  })), _path3804 || (_path3804 = /*#__PURE__*/React.createElement("path", {
    d: "M37 111h1v1h-1z",
    fill: "#232427"
  })), _path3805 || (_path3805 = /*#__PURE__*/React.createElement("path", {
    d: "M42 112h-1v-1h1z",
    fill: "#1f2123"
  })), _path3806 || (_path3806 = /*#__PURE__*/React.createElement("path", {
    d: "M44 111v1h-1v-1z",
    fill: "#292828"
  })), _path3807 || (_path3807 = /*#__PURE__*/React.createElement("path", {
    d: "M44 112v-1h1v1z",
    fill: "#242020"
  })), _path3808 || (_path3808 = /*#__PURE__*/React.createElement("path", {
    d: "M45 112v-1h1v1z",
    fill: "#1f1a19"
  })), _path3809 || (_path3809 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111h1v1h-1z",
    fill: "#1e1a16"
  })), _path3810 || (_path3810 = /*#__PURE__*/React.createElement("path", {
    d: "M48 111v1h-1v-1z",
    fill: "#3e3b37"
  })), _path3811 || (_path3811 = /*#__PURE__*/React.createElement("path", {
    d: "M48 111h1v1h-1z",
    fill: "#615e5a"
  })), _path3812 || (_path3812 = /*#__PURE__*/React.createElement("path", {
    d: "M50 112h-1v-1h1z",
    fill: "#44403d"
  })), _path3813 || (_path3813 = /*#__PURE__*/React.createElement("path", {
    d: "M50 111h1v1h-1z",
    fill: "#2b261f"
  })), _path3814 || (_path3814 = /*#__PURE__*/React.createElement("path", {
    d: "M52 112h-1v-1h1z",
    fill: "#19130a"
  })), _path3815 || (_path3815 = /*#__PURE__*/React.createElement("path", {
    d: "M52 111h1v1h-1z",
    fill: "#201a15"
  })), _path3816 || (_path3816 = /*#__PURE__*/React.createElement("path", {
    d: "M53 112v-1h1v1z",
    fill: "#271f1e"
  })), _path3817 || (_path3817 = /*#__PURE__*/React.createElement("path", {
    d: "M55 111v1h-1v-1z",
    fill: "#2b2223"
  })), _path3818 || (_path3818 = /*#__PURE__*/React.createElement("path", {
    d: "M56 111h1v1h-1z",
    fill: "#302323"
  })), _path3819 || (_path3819 = /*#__PURE__*/React.createElement("path", {
    d: "M58 112h-1v-1h1z",
    fill: "#322525"
  })), _path3820 || (_path3820 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111v1h-1v-1z",
    fill: "#332625"
  })), _path3821 || (_path3821 = /*#__PURE__*/React.createElement("path", {
    d: "M61 111h1v1h-1z",
    fill: "#362726"
  })), _path3822 || (_path3822 = /*#__PURE__*/React.createElement("path", {
    d: "M63 112v-1h1v1z",
    fill: "#3c2c2b"
  })), _path3823 || (_path3823 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111v1h-1v-1z",
    fill: "#4a2c2c"
  })), _path3824 || (_path3824 = /*#__PURE__*/React.createElement("path", {
    d: "M66 112h-1v-1h1z",
    fill: "#522f30"
  })), _path3825 || (_path3825 = /*#__PURE__*/React.createElement("path", {
    d: "M66 111h1v1h-1z",
    fill: "#523030"
  })), _path3826 || (_path3826 = /*#__PURE__*/React.createElement("path", {
    d: "M68 111v1h-1v-1z",
    fill: "#533"
  })), _path3827 || (_path3827 = /*#__PURE__*/React.createElement("path", {
    d: "M68 111h1v1h-1z",
    fill: "#563332"
  })), _path3828 || (_path3828 = /*#__PURE__*/React.createElement("path", {
    d: "M70 112h-1v-1h1z",
    fill: "#5b3532"
  })), _path3829 || (_path3829 = /*#__PURE__*/React.createElement("path", {
    d: "M71 111h1v1h-1z",
    fill: "#593430"
  })), _path3830 || (_path3830 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111h1v1h-1z",
    fill: "#593432"
  })), _path3831 || (_path3831 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v-1h1v1z",
    fill: "#583432"
  })), _path3832 || (_path3832 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111v1h-1v-1z",
    fill: "#553230"
  })), _path3833 || (_path3833 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112h-1v-1h1z",
    fill: "#502f2c"
  })), _path3834 || (_path3834 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111v1h-1v-1z",
    fill: "#4d302c"
  })), _path3835 || (_path3835 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111h1v1h-1z",
    fill: "#492e2c"
  })), _path3836 || (_path3836 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111h1v1h-1z",
    fill: "#4a2f2f"
  })), _path3837 || (_path3837 = /*#__PURE__*/React.createElement("path", {
    d: "M80 111h1v1h-1z",
    fill: "#442b2d"
  })), _path3838 || (_path3838 = /*#__PURE__*/React.createElement("path", {
    d: "M81 112v-1h1v1z",
    fill: "#422a2d"
  })), _path3839 || (_path3839 = /*#__PURE__*/React.createElement("path", {
    d: "M83 112h-1v-1h1z",
    fill: "#3b2929"
  })), _path3840 || (_path3840 = /*#__PURE__*/React.createElement("path", {
    d: "M84 111v1h-1v-1z",
    fill: "#382c2a"
  })), _path3841 || (_path3841 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112v-1h1v1z",
    fill: "#292221"
  })), _path3842 || (_path3842 = /*#__PURE__*/React.createElement("path", {
    d: "M85 111h1v1h-1z",
    fill: "#1d1c1d"
  })), _path3843 || (_path3843 = /*#__PURE__*/React.createElement("path", {
    d: "M91 112v-1h1v1z",
    fill: "#2e2e35"
  })), _path3844 || (_path3844 = /*#__PURE__*/React.createElement("path", {
    d: "M93 111v1h-1v-1z",
    fill: "#56555a"
  })), _path3845 || (_path3845 = /*#__PURE__*/React.createElement("path", {
    d: "M94 111v1h-1v-1z",
    fill: "#666669",
    fillOpacity: 0.635
  })), _path3846 || (_path3846 = /*#__PURE__*/React.createElement("path", {
    d: "M35 112v1h-1v-1z",
    fill: "#909090",
    fillOpacity: 0.118
  })), _path3847 || (_path3847 = /*#__PURE__*/React.createElement("path", {
    d: "M36 113h-1v-1h1z",
    fill: "#525252",
    fillOpacity: 0.91
  })), _path3848 || (_path3848 = /*#__PURE__*/React.createElement("path", {
    d: "M45 112v1h-1v-1z",
    fill: "#1a1918"
  })), _path3849 || (_path3849 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113h-1v-1h1z",
    fill: "#1c1918"
  })), _path3850 || (_path3850 = /*#__PURE__*/React.createElement("path", {
    d: "M48 113h-1v-1h1z",
    fill: "#403e3d"
  })), _path3851 || (_path3851 = /*#__PURE__*/React.createElement("path", {
    d: "M49 112v1h-1v-1z",
    fill: "#232120"
  })), _path3852 || (_path3852 = /*#__PURE__*/React.createElement("path", {
    d: "M50 112v1h-1v-1z",
    fill: "#171513"
  })), _path3853 || (_path3853 = /*#__PURE__*/React.createElement("path", {
    d: "M51 112v1h-1v-1z",
    fill: "#1b1814"
  })), _path3854 || (_path3854 = /*#__PURE__*/React.createElement("path", {
    d: "M51 113v-1h1v1z",
    fill: "#1c1914"
  })), _path3855 || (_path3855 = /*#__PURE__*/React.createElement("path", {
    d: "M53 113h-1v-1h1z",
    fill: "#1e1b16"
  })), _path3856 || (_path3856 = /*#__PURE__*/React.createElement("path", {
    d: "M54 112v1h-1v-1z",
    fill: "#201c1a"
  })), _path3857 || (_path3857 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113v-1h1v1z",
    fill: "#221e1c"
  })), _path3858 || (_path3858 = /*#__PURE__*/React.createElement("path", {
    d: "M55 112h1v1h-1z",
    fill: "#241e1d"
  })), _path3859 || (_path3859 = /*#__PURE__*/React.createElement("path", {
    d: "M57 112v1h-1v-1z",
    fill: "#241d1d"
  })), _path3860 || (_path3860 = /*#__PURE__*/React.createElement("path", {
    d: "M59 113h-1v-1h1z",
    fill: "#272120"
  })), _path3861 || (_path3861 = /*#__PURE__*/React.createElement("path", {
    d: "M59 113v-1h1v1z",
    fill: "#292220"
  })), _path3862 || (_path3862 = /*#__PURE__*/React.createElement("path", {
    d: "M61 113h-1v-1h1z",
    fill: "#2c2321"
  })), _path3863 || (_path3863 = /*#__PURE__*/React.createElement("path", {
    d: "M62 112v1h-1v-1z",
    fill: "#2b2321"
  })), _path3864 || (_path3864 = /*#__PURE__*/React.createElement("path", {
    d: "M62 112h1v1h-1z",
    fill: "#2c2422"
  })), _path3865 || (_path3865 = /*#__PURE__*/React.createElement("path", {
    d: "M64 113h-1v-1h1z",
    fill: "#302725"
  })), _path3866 || (_path3866 = /*#__PURE__*/React.createElement("path", {
    d: "M65 113h-1v-1h1z",
    fill: "#372625"
  })), _path3867 || (_path3867 = /*#__PURE__*/React.createElement("path", {
    d: "M65 112h1v1h-1z",
    fill: "#3a2627"
  })), _path3868 || (_path3868 = /*#__PURE__*/React.createElement("path", {
    d: "M67 112v1h-1v-1z",
    fill: "#3c292a"
  })), _path3869 || (_path3869 = /*#__PURE__*/React.createElement("path", {
    d: "M67 112h1v1h-1z",
    fill: "#3f2c2d"
  })), _path3870 || (_path3870 = /*#__PURE__*/React.createElement("path", {
    d: "M69 112v1h-1v-1z",
    fill: "#3f2b29"
  })), _path3871 || (_path3871 = /*#__PURE__*/React.createElement("path", {
    d: "M71 113v-1h1v1z",
    fill: "#432d27"
  })), _path3872 || (_path3872 = /*#__PURE__*/React.createElement("path", {
    d: "M73 112v1h-1v-1z",
    fill: "#46302a"
  })), _path3873 || (_path3873 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v1h-1v-1z",
    fill: "#46332e"
  })), _path3874 || (_path3874 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112h1v1h-1z",
    fill: "#42312d"
  })), _path3875 || (_path3875 = /*#__PURE__*/React.createElement("path", {
    d: "M75 112h1v1h-1z",
    fill: "#3f2f2a"
  })), _path3876 || (_path3876 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112v1h-1v-1z",
    fill: "#3a2c27"
  })), _path3877 || (_path3877 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112h1v1h-1z",
    fill: "#342722"
  })), _path3878 || (_path3878 = /*#__PURE__*/React.createElement("path", {
    d: "M79 112v1h-1v-1z",
    fill: "#332725"
  })), _path3879 || (_path3879 = /*#__PURE__*/React.createElement("path", {
    d: "M80 113h-1v-1h1z",
    fill: "#322726"
  })), _path3880 || (_path3880 = /*#__PURE__*/React.createElement("path", {
    d: "M80 112h1v1h-1z",
    fill: "#2e2425"
  })), _path3881 || (_path3881 = /*#__PURE__*/React.createElement("path", {
    d: "M82 113h-1v-1h1z",
    fill: "#2d2426"
  })), _path3882 || (_path3882 = /*#__PURE__*/React.createElement("path", {
    d: "M83 112v1h-1v-1z",
    fill: "#2b2425"
  })), _path3883 || (_path3883 = /*#__PURE__*/React.createElement("path", {
    d: "M83 113v-1h1v1z",
    fill: "#262021"
  })), _path3884 || (_path3884 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112h1v1h-1z",
    fill: "#1c1a1b"
  })), _path3885 || (_path3885 = /*#__PURE__*/React.createElement("path", {
    d: "M90 112v1h-1v-1z",
    fill: "#1f2025"
  })), _path3886 || (_path3886 = /*#__PURE__*/React.createElement("path", {
    d: "M91 113v-1h1v1z",
    fill: "#302f37"
  })), _path3887 || (_path3887 = /*#__PURE__*/React.createElement("path", {
    d: "M93 113h-1v-1h1z",
    fill: "#5c5b60"
  })), _path3888 || (_path3888 = /*#__PURE__*/React.createElement("path", {
    d: "M93 112h1v1h-1z",
    fill: "#727276",
    fillOpacity: 0.482
  })), _path3889 || (_path3889 = /*#__PURE__*/React.createElement("path", {
    d: "M34 114v-1h1v1z",
    fill: "#bfbfbf",
    fillOpacity: 0.063
  })), _path3890 || (_path3890 = /*#__PURE__*/React.createElement("path", {
    d: "M35 113h1v1h-1z",
    fill: "#545454",
    fillOpacity: 0.839
  })), _path3891 || (_path3891 = /*#__PURE__*/React.createElement("path", {
    d: "M36 114v-1h1v1z",
    fill: "#282929"
  })), _path3892 || (_path3892 = /*#__PURE__*/React.createElement("path", {
    d: "M38 114h-1v-1h1z",
    fill: "#242628"
  })), _path3893 || (_path3893 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114v-1h1v1z",
    fill: "#171c1d"
  })), _path3894 || (_path3894 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114h-1v-1h1z",
    fill: "#1b1b19"
  })), _path3895 || (_path3895 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113v1h-1v-1z",
    fill: "#1c1b19"
  })), _path3896 || (_path3896 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113h1v1h-1z",
    fill: "#1a1a16"
  })), _path3897 || (_path3897 = /*#__PURE__*/React.createElement("path", {
    d: "M63 113v1h-1v-1z",
    fill: "#1c1a17"
  })), _path3898 || (_path3898 = /*#__PURE__*/React.createElement("path", {
    d: "M63 114v-1h1v1z",
    fill: "#1d1a17"
  })), _path3899 || (_path3899 = /*#__PURE__*/React.createElement("path", {
    d: "M69 114h-1v-1h1z",
    fill: "#1b1b17"
  })), _path3900 || (_path3900 = /*#__PURE__*/React.createElement("path", {
    d: "M71 114v-1h1v1z",
    fill: "#1b1a16"
  })), _path3901 || (_path3901 = /*#__PURE__*/React.createElement("path", {
    d: "M73 114h-1v-1h1z",
    fill: "#1b1915"
  })), _path3902 || (_path3902 = /*#__PURE__*/React.createElement("path", {
    d: "M77 114v-1h1v1z",
    fill: "#161b19"
  })), _path3903 || (_path3903 = /*#__PURE__*/React.createElement("path", {
    d: "M82 114h-1v-1h1z",
    fill: "#171b1d"
  })), _path3904 || (_path3904 = /*#__PURE__*/React.createElement("path", {
    d: "M83 114h-1v-1h1z",
    fill: "#181a1e"
  })), _path3905 || (_path3905 = /*#__PURE__*/React.createElement("path", {
    d: "M84 114h-1v-1h1z",
    fill: "#1a1a1e"
  })), _path3906 || (_path3906 = /*#__PURE__*/React.createElement("path", {
    d: "M85 113h1v1h-1z",
    fill: "#181c1e"
  })), _path3907 || (_path3907 = /*#__PURE__*/React.createElement("path", {
    d: "M90 114h-1v-1h1z",
    fill: "#202125"
  })), _path3908 || (_path3908 = /*#__PURE__*/React.createElement("path", {
    d: "M92 113v1h-1v-1z",
    fill: "#33323a"
  })), _path3909 || (_path3909 = /*#__PURE__*/React.createElement("path", {
    d: "M92 114v-1h1v1z",
    fill: "#626166",
    fillOpacity: 0.992
  })), _path3910 || (_path3910 = /*#__PURE__*/React.createElement("path", {
    d: "M93 114v-1h1v1z",
    fill: "#78787c",
    fillOpacity: 0.29
  })), _path3911 || (_path3911 = /*#__PURE__*/React.createElement("path", {
    d: "M35 115v-1h1v1z",
    fill: "#555",
    fillOpacity: 0.761
  })), _path3912 || (_path3912 = /*#__PURE__*/React.createElement("path", {
    d: "M37 114v1h-1v-1z",
    fill: "#2b2c2c"
  })), _path3913 || (_path3913 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114v1h-1v-1z",
    fill: "#1a1a1f"
  })), _path3914 || (_path3914 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114h1v1h-1z",
    fill: "#1a1b1f"
  })), _path3915 || (_path3915 = /*#__PURE__*/React.createElement("path", {
    d: "M76 115v-1h1v1z",
    fill: "#181b1f"
  })), _path3916 || (_path3916 = /*#__PURE__*/React.createElement("path", {
    d: "M83 115h-1v-1h1z",
    fill: "#191b20"
  })), _path3917 || (_path3917 = /*#__PURE__*/React.createElement("path", {
    d: "M91 114v1h-1v-1z",
    fill: "#202026"
  })), _path3918 || (_path3918 = /*#__PURE__*/React.createElement("path", {
    d: "M92 114v1h-1v-1z",
    fill: "#38393f"
  })), _path3919 || (_path3919 = /*#__PURE__*/React.createElement("path", {
    d: "M92 115v-1h1v1z",
    fill: "#6b6a6d",
    fillOpacity: 0.886
  })), _path3920 || (_path3920 = /*#__PURE__*/React.createElement("path", {
    d: "M94 115h-1v-1h1z",
    fill: "#8d8d97",
    fillOpacity: 0.106
  })), _path3921 || (_path3921 = /*#__PURE__*/React.createElement("path", {
    d: "M36 116h-1v-1h1z",
    fill: "#575755",
    fillOpacity: 0.596
  })), _path3922 || (_path3922 = /*#__PURE__*/React.createElement("path", {
    d: "M37 116h-1v-1h1z",
    fill: "#2c2d2e"
  })), _path3923 || (_path3923 = /*#__PURE__*/React.createElement("path", {
    d: "M90 116v-1h1v1z",
    fill: "#222229"
  })), _path3924 || (_path3924 = /*#__PURE__*/React.createElement("path", {
    d: "M93 116h-1v-1h1z",
    fill: "#747474",
    fillOpacity: 0.635
  })), _path3925 || (_path3925 = /*#__PURE__*/React.createElement("path", {
    d: "M36 116v1h-1v-1z",
    fill: "#545454",
    fillOpacity: 0.357
  })), _path3926 || (_path3926 = /*#__PURE__*/React.createElement("path", {
    d: "M36 116h1v1h-1z",
    fill: "#2d2d2e"
  })), _path3927 || (_path3927 = /*#__PURE__*/React.createElement("path", {
    d: "M90 116h1v1h-1z",
    fill: "#212229"
  })), _path3928 || (_path3928 = /*#__PURE__*/React.createElement("path", {
    d: "M91 117v-1h1v1z",
    fill: "#46464b",
    fillOpacity: 0.988
  })), _path3929 || (_path3929 = /*#__PURE__*/React.createElement("path", {
    d: "M92 117v-1h1v1z",
    fill: "#868686",
    fillOpacity: 0.306
  })), _path3930 || (_path3930 = /*#__PURE__*/React.createElement("path", {
    d: "M36 118h-1v-1h1z",
    fill: "#575757",
    fillOpacity: 0.149
  })), _path3931 || (_path3931 = /*#__PURE__*/React.createElement("path", {
    d: "M37 118h-1v-1h1z",
    fill: "#2a2b2c",
    fillOpacity: 0.925
  })), _path3932 || (_path3932 = /*#__PURE__*/React.createElement("path", {
    d: "M90 118v-1h1v1z",
    fill: "#22232a"
  })), _path3933 || (_path3933 = /*#__PURE__*/React.createElement("path", {
    d: "M91 117h1v1h-1z",
    fill: "#4b4b50",
    fillOpacity: 0.784
  })), _path3934 || (_path3934 = /*#__PURE__*/React.createElement("path", {
    d: "M36 118v1h-1v-1z",
    fill: "#bfbfbf",
    fillOpacity: 0.016
  })), _path3935 || (_path3935 = /*#__PURE__*/React.createElement("path", {
    d: "M36 118h1v1h-1z",
    fill: "#272728",
    fillOpacity: 0.741
  })), _path3936 || (_path3936 = /*#__PURE__*/React.createElement("path", {
    d: "M90 118h1v1h-1z",
    fill: "#212127"
  })), _path3937 || (_path3937 = /*#__PURE__*/React.createElement("path", {
    d: "M91 119v-1h1v1z",
    fill: "#44444c",
    fillOpacity: 0.392
  })), _path3938 || (_path3938 = /*#__PURE__*/React.createElement("path", {
    d: "M36 119h1v1h-1z",
    fill: "#222224",
    fillOpacity: 0.471
  })), _path3939 || (_path3939 = /*#__PURE__*/React.createElement("path", {
    d: "M39 120h-1v-1h1z",
    fill: "#242426"
  })), _path3940 || (_path3940 = /*#__PURE__*/React.createElement("path", {
    d: "M52 120h-1v-1h1z",
    fill: "#1e2020"
  })), _path3941 || (_path3941 = /*#__PURE__*/React.createElement("path", {
    d: "M52 119h1v1h-1z",
    fill: "#202222"
  })), _path3942 || (_path3942 = /*#__PURE__*/React.createElement("path", {
    d: "M90 119h1v1h-1z",
    fill: "#18181b",
    fillOpacity: 0.906
  })), _path3943 || (_path3943 = /*#__PURE__*/React.createElement("path", {
    d: "M92 119v1h-1v-1z",
    fill: "#383838",
    fillOpacity: 0.106
  })), _path3944 || (_path3944 = /*#__PURE__*/React.createElement("path", {
    d: "M37 120v1h-1v-1z",
    fill: "#2a2a2a",
    fillOpacity: 0.165
  })), _path3945 || (_path3945 = /*#__PURE__*/React.createElement("path", {
    d: "M38 121h-1v-1h1z",
    fill: "#212123",
    fillOpacity: 0.937
  })), _path3946 || (_path3946 = /*#__PURE__*/React.createElement("path", {
    d: "M91 121h-1v-1h1z",
    fill: "#1b1b1d",
    fillOpacity: 0.584
  })), _path3947 || (_path3947 = /*#__PURE__*/React.createElement("path", {
    d: "M37 121v1h-1v-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.008
  })), _path3948 || (_path3948 = /*#__PURE__*/React.createElement("path", {
    d: "M38 122h-1v-1h1z",
    fill: "#1a1a1b",
    fillOpacity: 0.643
  })), _path3949 || (_path3949 = /*#__PURE__*/React.createElement("path", {
    d: "M90 122h-1v-1h1z",
    fill: "#19191b",
    fillOpacity: 0.914
  })), _path3950 || (_path3950 = /*#__PURE__*/React.createElement("path", {
    d: "M91 121v1h-1v-1z",
    fill: "#2d2d2d",
    fillOpacity: 0.153
  })), _path3951 || (_path3951 = /*#__PURE__*/React.createElement("path", {
    d: "M38 122v1h-1v-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.161
  })), _path3952 || (_path3952 = /*#__PURE__*/React.createElement("path", {
    d: "M39 122v1h-1v-1z",
    fill: "#1e1e20",
    fillOpacity: 0.89
  })), _path3953 || (_path3953 = /*#__PURE__*/React.createElement("path", {
    d: "M83 122v1h-1v-1z",
    fill: "#17191b"
  })), _path3954 || (_path3954 = /*#__PURE__*/React.createElement("path", {
    d: "M90 122v1h-1v-1z",
    fill: "#1a1a1c",
    fillOpacity: 0.455
  })), _path3955 || (_path3955 = /*#__PURE__*/React.createElement("path", {
    d: "M38 123h1v1h-1z",
    fill: "#181818",
    fillOpacity: 0.286
  })), _path3956 || (_path3956 = /*#__PURE__*/React.createElement("path", {
    d: "M39 123h1v1h-1z",
    fill: "#1a1a1c",
    fillOpacity: 0.91
  })), _path3957 || (_path3957 = /*#__PURE__*/React.createElement("path", {
    d: "M89 123v1h-1v-1z",
    fill: "#1c1c1e",
    fillOpacity: 0.592
  })), _path3958 || (_path3958 = /*#__PURE__*/React.createElement("path", {
    d: "M89 124v-1h1v1z",
    fill: "#7f7f7f",
    fillOpacity: 0.024
  })), _path3959 || (_path3959 = /*#__PURE__*/React.createElement("path", {
    d: "M40 125h-1v-1h1z",
    fill: "#141414",
    fillOpacity: 0.2
  })), _path3960 || (_path3960 = /*#__PURE__*/React.createElement("path", {
    d: "M41 124h1v1h-1z",
    fill: "#1c1c1c",
    fillOpacity: 0.941
  })), _path3961 || (_path3961 = /*#__PURE__*/React.createElement("path", {
    d: "M85 125v-1h1v1z",
    fill: "#1d1d1d",
    fillOpacity: 0.992
  })), _path3962 || (_path3962 = /*#__PURE__*/React.createElement("path", {
    d: "M86 124h1v1h-1z",
    fill: "#1b1b1a",
    fillOpacity: 0.839
  })), _path3963 || (_path3963 = /*#__PURE__*/React.createElement("path", {
    d: "M88 125h-1v-1h1z",
    fill: "#1e1e1e",
    fillOpacity: 0.424
  })), _path3964 || (_path3964 = /*#__PURE__*/React.createElement("path", {
    d: "M88 124h1v1h-1z",
    fill: "#484848",
    fillOpacity: 0.027
  })), _path3965 || (_path3965 = /*#__PURE__*/React.createElement("path", {
    d: "M40 125h1v1h-1z",
    fillOpacity: 0.008
  })), _path3966 || (_path3966 = /*#__PURE__*/React.createElement("path", {
    d: "M41 126v-1h1v1z",
    fill: "#1d1d1d",
    fillOpacity: 0.169
  })), _path3967 || (_path3967 = /*#__PURE__*/React.createElement("path", {
    d: "M42 126v-1h1v1z",
    fill: "#151515",
    fillOpacity: 0.365
  })), _path3968 || (_path3968 = /*#__PURE__*/React.createElement("path", {
    d: "M43 125h1v1h-1z",
    fill: "#161616",
    fillOpacity: 0.486
  })), _path3969 || (_path3969 = /*#__PURE__*/React.createElement("path", {
    d: "M44 126v-1h1v1z",
    fill: "#141414",
    fillOpacity: 0.537
  })), _path3970 || (_path3970 = /*#__PURE__*/React.createElement("path", {
    d: "M46 125v1h-1v-1z",
    fill: "#171717",
    fillOpacity: 0.553
  })), _path3971 || (_path3971 = /*#__PURE__*/React.createElement("path", {
    d: "M46 126v-1h1v1z",
    fill: "#161616",
    fillOpacity: 0.576
  })), _path3972 || (_path3972 = /*#__PURE__*/React.createElement("path", {
    d: "M47 125h1v1h-1z",
    fill: "#161616",
    fillOpacity: 0.588
  })), _path3973 || (_path3973 = /*#__PURE__*/React.createElement("path", {
    d: "M48 125h1v1h-1z",
    fill: "#151515",
    fillOpacity: 0.6
  })), _path3974 || (_path3974 = /*#__PURE__*/React.createElement("path", {
    d: "M49 126v-1h1v1z",
    fill: "#161616",
    fillOpacity: 0.616
  })), _path3975 || (_path3975 = /*#__PURE__*/React.createElement("path", {
    d: "M50 125h1v1h-1z",
    fill: "#171717",
    fillOpacity: 0.627
  })), _path3976 || (_path3976 = /*#__PURE__*/React.createElement("path", {
    d: "M52 125v1h-1v-1z",
    fill: "#191919",
    fillOpacity: 0.639
  })), _path3977 || (_path3977 = /*#__PURE__*/React.createElement("path", {
    d: "M53 125v1h-1v-1z",
    fill: "#181818",
    fillOpacity: 0.655
  })), _path3978 || (_path3978 = /*#__PURE__*/React.createElement("path", {
    d: "M54 125v1h-1v-1z",
    fill: "#181818",
    fillOpacity: 0.667
  })), _path3979 || (_path3979 = /*#__PURE__*/React.createElement("path", {
    d: "M54 126v-1h1v1z",
    fill: "#191919",
    fillOpacity: 0.671
  })), _path3980 || (_path3980 = /*#__PURE__*/React.createElement("path", {
    d: "M57 126h-1v-1h1z",
    fill: "#1c1c1c",
    fillOpacity: 0.675
  })), _path3981 || (_path3981 = /*#__PURE__*/React.createElement("path", {
    d: "M59 126v-1h1v1z",
    fill: "#1c1c1c",
    fillOpacity: 0.671
  })), _path3982 || (_path3982 = /*#__PURE__*/React.createElement("path", {
    d: "M60 125h1v1h-1z",
    fill: "#1c1c1c",
    fillOpacity: 0.667
  })), _path3983 || (_path3983 = /*#__PURE__*/React.createElement("path", {
    d: "M62 126h-1v-1h1z",
    fill: "#1c1c1c",
    fillOpacity: 0.663
  })), _path3984 || (_path3984 = /*#__PURE__*/React.createElement("path", {
    d: "M62 126v-1h1v1z",
    fill: "#1c1c1c",
    fillOpacity: 0.659
  })), _path3985 || (_path3985 = /*#__PURE__*/React.createElement("path", {
    d: "M66 126v-1h1v1z",
    fill: "#1b1b1b",
    fillOpacity: 0.659
  })), _path3986 || (_path3986 = /*#__PURE__*/React.createElement("path", {
    d: "M68 125v1h-1v-1z",
    fill: "#1b1b1b",
    fillOpacity: 0.663
  })), _path3987 || (_path3987 = /*#__PURE__*/React.createElement("path", {
    d: "M68 126v-1h1v1z",
    fill: "#1a1a1a",
    fillOpacity: 0.671
  })), _path3988 || (_path3988 = /*#__PURE__*/React.createElement("path", {
    d: "M69 126v-1h1v1z",
    fill: "#1a1a1a",
    fillOpacity: 0.675
  })), _path3989 || (_path3989 = /*#__PURE__*/React.createElement("path", {
    d: "M71 126v-1h1v1z",
    fill: "#1b1b1b",
    fillOpacity: 0.686
  })), _path3990 || (_path3990 = /*#__PURE__*/React.createElement("path", {
    d: "M72 125h1v1h-1z",
    fill: "#1b1b1b",
    fillOpacity: 0.694
  })), _path3991 || (_path3991 = /*#__PURE__*/React.createElement("path", {
    d: "M73 126v-1h1v1z",
    fill: "#191919",
    fillOpacity: 0.702
  })), _path3992 || (_path3992 = /*#__PURE__*/React.createElement("path", {
    d: "M75 126h-1v-1h1z",
    fill: "#191919",
    fillOpacity: 0.706
  })), _path3993 || (_path3993 = /*#__PURE__*/React.createElement("path", {
    d: "M75 125h1v1h-1z",
    fill: "#191919",
    fillOpacity: 0.714
  })), _path3994 || (_path3994 = /*#__PURE__*/React.createElement("path", {
    d: "M76 125h1v1h-1z",
    fill: "#171717",
    fillOpacity: 0.722
  })), _path3995 || (_path3995 = /*#__PURE__*/React.createElement("path", {
    d: "M78 126h-1v-1h1z",
    fill: "#171717",
    fillOpacity: 0.714
  })), _path3996 || (_path3996 = /*#__PURE__*/React.createElement("path", {
    d: "M79 126h-1v-1h1z",
    fill: "#181818",
    fillOpacity: 0.706
  })), _path3997 || (_path3997 = /*#__PURE__*/React.createElement("path", {
    d: "M80 125v1h-1v-1z",
    fill: "#181818",
    fillOpacity: 0.694
  })), _path3998 || (_path3998 = /*#__PURE__*/React.createElement("path", {
    d: "M81 126h-1v-1h1z",
    fill: "#191919",
    fillOpacity: 0.678
  })), _path3999 || (_path3999 = /*#__PURE__*/React.createElement("path", {
    d: "M82 125v1h-1v-1z",
    fill: "#191919",
    fillOpacity: 0.667
  })), _path4000 || (_path4000 = /*#__PURE__*/React.createElement("path", {
    d: "M83 125v1h-1v-1z",
    fill: "#181818",
    fillOpacity: 0.643
  })), _path4001 || (_path4001 = /*#__PURE__*/React.createElement("path", {
    d: "M84 126h-1v-1h1z",
    fill: "#1c1c1c",
    fillOpacity: 0.6
  })), _path4002 || (_path4002 = /*#__PURE__*/React.createElement("path", {
    d: "M85 125v1h-1v-1z",
    fill: "#1a1a1a",
    fillOpacity: 0.494
  })), _path4003 || (_path4003 = /*#__PURE__*/React.createElement("path", {
    d: "M85 126v-1h1v1z",
    fill: "#151515",
    fillOpacity: 0.278
  })), _path4004 || (_path4004 = /*#__PURE__*/React.createElement("path", {
    d: "M87 126h-1v-1h1z",
    fill: "#1a1a1a",
    fillOpacity: 0.075
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorOil);
export default __webpack_public_path__ + "static/media/motor-oil.8d8686e37820fedadd90147b89b30ef0.svg";
export { ForwardRef as ReactComponent };